<template>
    <div class="IconSvg">
        <svg
            id="圖層_1"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 34 34"
            style="enable-background:new 0 0 34 34;"
            xml:space="preserve">
            <g
                id="logo_cc"
                class="st0">
                <g class="st1">
                    <g>
                        <path
                            class="st2"
                            d="M15.5,16.5h3.3c1.4,0,2.6-1.1,2.6-2.6V5.7c0-1.4-1.1-2.6-2.6-2.6h-3.3c-1.4,0-2.6,1.1-2.6,2.6v8.2
				C12.9,15.3,14.1,16.5,15.5,16.5z M14.2,5.7c0-0.7,0.6-1.3,1.3-1.3h3.3c0.7,0,1.3,0.6,1.3,1.3v8.2c0,0.7-0.6,1.3-1.3,1.3h-3.3
				c-0.7,0-1.3-0.6-1.3-1.3L14.2,5.7z" />
                        <path
                            class="st2"
                            d="M18.8,16.6h-3.3c-1.5,0-2.7-1.2-2.7-2.7V5.7C12.8,4.2,14,3,15.5,3h3.3c1.5,0,2.7,1.2,2.7,2.7v8.2
				C21.5,15.4,20.3,16.6,18.8,16.6z M15.5,3.3c-1.3,0-2.4,1.1-2.4,2.4v8.2c0,1.3,1.1,2.4,2.4,2.4h3.3c1.3,0,2.4-1.1,2.4-2.4V5.7
				c0-1.3-1.1-2.4-2.4-2.4L15.5,3.3z M18.8,15.4h-3.3c-0.8,0-1.5-0.7-1.5-1.5V5.7c0-0.8,0.7-1.5,1.5-1.5h3.3c0.8,0,1.5,0.7,1.5,1.5
				v8.2C20.3,14.7,19.6,15.4,18.8,15.4z M15.5,4.5c-0.6,0-1.2,0.5-1.2,1.2v8.2c0,0.6,0.5,1.2,1.2,1.2h3.3c0.6,0,1.2-0.5,1.2-1.2V5.7
				c0-0.6-0.5-1.2-1.2-1.2H15.5z" />
                    </g>
                    <g>
                        <path
                            class="st2"
                            d="M25.6,14.1h2.2c1.2,0,2.2-1,2.2-2.2V7.4c0-1.2-1-2.2-2.2-2.2h-2.2c-1.2,0-2.2,1-2.2,2.2v4.4
				C23.3,13.1,24.3,14.1,25.6,14.1z M24.6,7.4c0-0.5,0.4-1,1-1h2.2c0.5,0,1,0.4,1,1v4.4c0,0.5-0.4,1-1,1h-2.2c-0.5,0-1-0.4-1-1V7.4z
				" />
                        <path
                            class="st2"
                            d="M27.7,14.2h-2.2c-1.3,0-2.4-1.1-2.4-2.4V7.4c0-1.3,1.1-2.4,2.4-2.4h2.2c1.3,0,2.4,1.1,2.4,2.4v4.4
				C30.1,13.2,29,14.2,27.7,14.2z M25.6,5.4c-1.1,0-2.1,0.9-2.1,2.1v4.4c0,1.1,0.9,2.1,2.1,2.1h2.2c1.1,0,2.1-0.9,2.1-2.1V7.4
				c0-1.1-0.9-2.1-2.1-2.1L25.6,5.4L25.6,5.4z M27.7,13h-2.2c-0.6,0-1.1-0.5-1.1-1.1V7.4c0-0.6,0.5-1.1,1.1-1.1h2.2
				c0.6,0,1.1,0.5,1.1,1.1v4.4C28.9,12.5,28.4,13,27.7,13z M25.6,6.6c-0.5,0-0.8,0.4-0.8,0.8v4.4c0,0.5,0.4,0.8,0.8,0.8h2.2
				c0.5,0,0.8-0.4,0.8-0.8V7.4c0-0.5-0.4-0.8-0.8-0.8H25.6z" />
                    </g>
                    <g>
                        <path
                            class="st2"
                            d="M27.6,27v1.2h4.9v-8.3c0-1-0.3-1.7-0.9-2.2c-0.7-0.6-1.4-0.6-1.6-0.6h-6.6c-0.2,0-1,0-1.6,0.6
				c-0.5,0.4-0.8,1.1-0.8,1.9h-7.7c-0.1-0.8-0.4-1.4-0.8-1.9c-0.7-0.6-1.4-0.6-1.6-0.6H4c-0.2,0-1,0-1.6,0.6C1.8,18.3,1.5,19,1.5,20
				v8.3h4.9V27H2.7v-7c0-0.6,0.2-1,0.4-1.3c0.3-0.3,0.7-0.3,0.7-0.3l0,0h6.7h0.1c0,0,0.4,0,0.7,0.3c0.2,0.2,0.4,0.5,0.4,0.9h-0.5
				c-1.4,0-2.5,1.1-2.6,2.5l0,0V31H16v-1.2h-6v-7.5c0-0.7,0.6-1.3,1.3-1.3h11.4c0.7,0,1.3,0.6,1.3,1.3v7.5h-3.9L15.3,27h-3.4v1.2H15
				l4.9,2.7h5.5v-8.7c0-1.4-1.1-2.5-2.5-2.6l0,0h-0.8c0.1-0.4,0.2-0.7,0.4-0.9c0.3-0.3,0.7-0.3,0.7-0.3l0,0h6.7H30
				c0,0,0.4,0,0.7,0.3c0.3,0.2,0.4,0.7,0.4,1.3v7H27.6z" />
                        <path
                            class="st2"
                            d="M25.5,31.1h-5.7L15,28.4h-3.2v-1.5h3.7l4.9,2.7H24v-7.3c0-0.7-0.5-1.2-1.2-1.2H11.4c-0.7,0-1.2,0.5-1.2,1.2
				v7.3h6.2v1.5H8.6V22c0.1-1.4,1.3-2.5,2.7-2.5h0.3c-0.1-0.3-0.2-0.5-0.3-0.7c-0.3-0.2-0.6-0.2-0.6-0.2h-0.1H3.9c0,0-0.4,0-0.6,0.2
				C3,19.1,2.9,19.5,2.9,20v6.9h3.6v1.5H1.3V20c0-1,0.3-1.8,0.9-2.3c0.7-0.6,1.5-0.6,1.8-0.6h6.6c0.2,0,1,0,1.7,0.6
				c0.5,0.4,0.8,1,0.9,1.8h7.5c0.1-0.8,0.4-1.4,0.9-1.8c0.7-0.6,1.5-0.6,1.8-0.6H30c0.2,0,1,0,1.7,0.6c0.6,0.5,0.9,1.3,0.9,2.3v8.4
				h-5.2v-1.5H31V20c0-0.5-0.1-0.9-0.4-1.2c-0.3-0.2-0.6-0.2-0.6-0.2h-0.1h-6.7c0,0-0.4,0-0.6,0.2c-0.2,0.1-0.3,0.4-0.3,0.7h0.8
				c1.4,0.1,2.5,1.3,2.5,2.7v8.9H25.5z M19.9,30.8h5.3v-8.6c0-1.3-1-2.4-2.3-2.4h-0.1h-0.9v-0.2c0.1-0.5,0.2-0.8,0.5-1
				c0.3-0.3,0.8-0.3,0.9-0.3H30h0.1c0.1,0,0.5,0,0.8,0.3s0.5,0.7,0.5,1.4v7.2h-3.6v0.9h4.6V20c0-0.9-0.3-1.6-0.8-2.1
				c-0.6-0.6-1.4-0.5-1.5-0.5h-6.6c-0.2,0-0.9,0-1.5,0.5c-0.5,0.4-0.7,1-0.8,1.8v0.1h-8v-0.1c-0.1-0.8-0.3-1.4-0.8-1.8
				c-0.6-0.6-1.4-0.5-1.5-0.5H4c-0.2,0-0.9,0-1.5,0.5C2,18.4,1.7,19.1,1.7,20v8.1h4.6v-0.9H2.6V20c0-0.6,0.2-1.1,0.5-1.4
				s0.8-0.3,0.9-0.3h6.7h0.1c0.1,0,0.5,0,0.8,0.3c0.2,0.2,0.4,0.6,0.5,1v0.2h-0.6c-1.3,0-2.4,1-2.4,2.4v0.1v8.5h7.1v-0.9H9.9v-7.6
				c0-0.8,0.7-1.5,1.5-1.5h11.4c0.8,0,1.5,0.7,1.5,1.5v7.6h-4.2l-4.9-2.7H12v0.9h3L19.9,30.8z" />
                    </g>
                    <g>
                        <path
                            class="st2"
                            d="M6.1,14.1h2.2c1.2,0,2.2-1,2.2-2.2V7.4c0-1.2-1-2.2-2.2-2.2H6.1c-1.2,0-2.2,1-2.2,2.2v4.4
				C3.9,13.1,4.9,14.1,6.1,14.1z M5.1,7.4c0-0.5,0.4-1,1-1h2.2c0.5,0,1,0.4,1,1v4.4c0,0.5-0.4,1-1,1H6.1c-0.5,0-1-0.4-1-1V7.4z" />
                        <path
                            class="st2"
                            d="M8.3,14.2H6.1c-1.3,0-2.4-1.1-2.4-2.4V7.4C3.7,6.1,4.8,5,6.1,5h2.2c1.3,0,2.4,1.1,2.4,2.4v4.4
				C10.6,13.2,9.6,14.2,8.3,14.2z M6.1,5.4C5,5.4,4,6.3,4,7.4v4.4c0,1.2,1,2.1,2.1,2.1h2.2c1.1,0,2.1-0.9,2.1-2.1V7.4
				c0-1.1-0.9-2.1-2.1-2.1L6.1,5.4L6.1,5.4z M8.3,13H6.1C5.5,13,5,12.5,5,11.8V7.4c0-0.6,0.5-1.1,1.1-1.1h2.2c0.6,0,1.1,0.5,1.1,1.1
				v4.4C9.4,12.5,8.9,13,8.3,13z M6.1,6.6C5.6,6.6,5.3,7,5.3,7.4v4.4c0,0.5,0.4,0.8,0.8,0.8h2.2c0.5,0,0.8-0.4,0.8-0.8V7.4
				c0-0.5-0.4-0.8-0.8-0.8H6.1z" />
                    </g>
                    <g>
                        <rect
                            x="18.8"
                            y="27"
                            class="st2"
                            width="3.9"
                            height="1.2" />
                        <path
                            class="st2"
                            d="M22.9,28.4h-4.2v-1.5h4.2L22.9,28.4z M19,28.1h3.6v-0.9H19V28.1z" />
                    </g>
                </g>
            </g>
            <g
                id="logo_ct"
                class="st0">
                <g class="st1">
                    <path
                        class="st2"
                        d="M16.8,29.3c-0.1,0-0.1,0-0.1,0s-0.1,0-0.2,0c-3.2-0.1-6.1-0.8-8.4-2.3c-4-2.4-6.8-6.1-6.7-8.9
			c0-0.2,0-1.8,2.1-5.3s6.5-7.3,9.9-7.5c1,0,1.8,0.3,2.5,0.6c0.5,0.2,1,0.4,1.5,0.5c0.7,0,1.4-0.2,2.1-0.5c0.6-0.2,1.2-0.4,1.8-0.4
			c1.5,0,4.1,0.7,8.7,6c0.3,0.5,2.9,4,3,6c0.1,2.4-1.3,5.1-4.3,8.1C25.4,28.7,18,29.3,16.8,29.3z M13.5,7h-0.1
			C11,7.2,7,10.3,4.9,13.7c-1.8,3-1.8,4.4-1.8,4.4c0,1.9,2.2,5.2,5.9,7.5c2.1,1.3,4.7,1.9,7.6,2c0.2,0,0.3,0,0.4,0
			c0.6,0,7.8-0.6,10.5-3.3c2.6-2.6,3.9-4.9,3.8-6.8l0,0c0-1.1-1.6-3.6-2.6-5c-3-3.5-5.5-5.3-7.4-5.3c-0.2,0-0.7,0.2-1.2,0.3
			c-0.8,0.3-1.8,0.6-2.8,0.6c-0.9,0-1.5-0.4-2.1-0.6C14.5,7.2,14.1,7,13.5,7z M15.7,22.5c-1,0-1.6-0.1-3.7-0.4
			C11.1,22,7.2,21.3,7.1,19c-0.1-1.7,1.5-3.2,2.5-4.3l0.2-0.2c1.3-1.4,3-2.4,4.7-2.7c2-0.4,4.3-0.2,6.3,0.7s3.4,2.3,5,4.1
			c0.8,1,1.2,1.9,1,2.7c-0.1,0.4-0.4,1-1.2,1.4l0,0c-2.3,1.1-5.3,1.6-7.1,1.6H17C16.6,22.5,16.1,22.5,15.7,22.5z M16.6,13.4
			c-0.5,0-1.1,0.1-1.6,0.2c-1.4,0.3-2.7,1-3.8,2.2L10.9,16c-0.7,0.7-2,2.1-2,3c0,0.5,1.6,1.2,3.3,1.4c2.8,0.4,2.8,0.4,4.9,0.3h1.5
			c1.8,0,4.5-0.5,6.4-1.4l0,0c0.1-0.1,0.2-0.1,0.2-0.2s-0.1-0.5-0.6-1.2c-1.4-1.7-2.7-2.9-4.4-3.7C19.1,13.7,17.8,13.4,16.6,13.4z" />
                </g>
            </g>
            <g
                id="logo_cta"
                class="st0">
                <g class="st1">
                    <path
                        class="st2"
                        d="M10.5,14c-0.9,0-1.6-0.1-1.7-0.1c-2.9-0.4-4.9-1.4-6-3.1C1.7,8.9,2.3,7,2.4,6.9c0.4-1.1,1.2-1.8,2.2-2.3
			c2.3-0.9,5.5-0.1,6.9,0.4l0.1-0.4c0.5-1.1,0.5-1.7,0.3-1.8c-0.2-0.2-0.7-0.2-0.9-0.1l-0.3-1.5c0.2,0,1.6-0.3,2.4,0.7
			c0.6,0.7,0.6,1.8-0.1,3.4L12.3,7l-0.7-0.3c0,0-4-1.7-6.4-0.7C4.5,6.3,4,6.8,3.8,7.4l0,0c0,0-0.4,1.3,0.4,2.6
			c0.8,1.2,2.4,2,4.9,2.4c0.9,0.1,3.6,0.3,4.9-0.8c0.4-0.4,0.6-0.9,0.6-1.5c0-0.4-0.2-1.7-0.9-2.2l-0.6-0.4l1.5-2.8
			c0.2-0.3,1.2-1.6,2.4-1.4c0.8,0.2,1.3,0.9,1.6,2.2l-1.5,0.3c-0.1-0.8-0.4-1-0.4-1c-0.1,0-0.6,0.4-0.9,0.7L15,7.1
			c1,1.1,1.1,2.9,1.1,2.9c0,1.1-0.4,2-1.1,2.7C13.8,13.7,11.9,14,10.5,14z" />
                </g>
                <g class="st1">
                    <rect
                        x="13"
                        y="12.7"
                        transform="matrix(0.9547 -0.2975 0.2975 0.9547 -4.182 4.8219)"
                        class="st2"
                        width="1.5"
                        height="6.9" />
                </g>
                <g class="st1">
                    <path
                        class="st2"
                        d="M19.5,28c-0.2,0-0.5,0-0.7,0c-4.6-0.2-8.1-2.5-8-5.3c0.1-2.7,3.8-4.7,8.4-4.5s8.1,2.5,8,5.3l0,0
			C27.1,26.1,23.7,28,19.5,28z M18.5,19.8c-3.6,0-6.1,1.5-6.2,3.1c-0.1,1.6,2.5,3.5,6.5,3.7s6.8-1.4,6.9-3l0,0
			c0.1-1.6-2.5-3.5-6.5-3.7C18.9,19.8,18.7,19.8,18.5,19.8z" />
                </g>
                <g class="st1">
                    <g>
                        <path
                            class="st2"
                            d="M10.7,30.6c-0.2,0.1-0.4,0.1-0.6-0.1c-0.3-0.5-0.8-1.4-0.5-2.2c0.2-0.4,0.6-0.9,1.6-1
				c1.2-0.2,1.6-0.8,1.7-1.2c0.1-0.2,0.2-0.3,0.4-0.3h0.6c0.2,0,0.4,0.2,0.4,0.5c-0.2,0.9-1,2.1-2.9,2.4c-0.4,0-0.5,0.2-0.5,0.2
				c-0.1,0.2,0.1,0.6,0.4,0.9c0.1,0.2,0.1,0.4-0.1,0.5L10.7,30.6z" />
                        <path
                            class="st2"
                            d="M10.5,31C10.4,31,10.4,31,10.5,31c-0.3,0-0.4-0.1-0.5-0.3c-0.4-0.5-0.9-1.5-0.6-2.5c0.2-0.5,0.6-1.1,1.8-1.2
				c1.1-0.1,1.4-0.7,1.5-1.1c0.1-0.3,0.4-0.4,0.6-0.4h0.6c0.2,0,0.4,0.1,0.5,0.3c0.1,0.2,0.2,0.3,0.1,0.5c-0.1,0.5-0.7,2.2-3.1,2.6
				c-0.2,0-0.2,0-0.3,0.1c0,0.1,0.1,0.4,0.3,0.7c0.2,0.3,0.1,0.6-0.1,0.8l-0.5,0.4C10.8,30.9,10.6,31,10.5,31z M13.3,26
				c-0.1,0-0.1,0-0.1,0.1c-0.1,0.5-0.6,1.2-1.9,1.4c-0.7,0.1-1.2,0.4-1.4,0.9c-0.3,0.7,0.2,1.6,0.5,2l0.1,0.1h0.1l0.5-0.4
				c0.1,0,0.1-0.1,0-0.2c-0.1-0.2-0.5-0.8-0.4-1.2c0.1-0.2,0.4-0.3,0.7-0.3c2-0.3,2.6-1.7,2.7-2.2c0-0.1,0-0.1,0-0.1s0-0.1-0.1-0.1
				L13.3,26L13.3,26z" />
                    </g>
                </g>
                <g class="st1">
                    <path
                        class="st2"
                        d="M25.8,22.2c-0.3,0-0.4,0-0.5,0l0.2-1.5c0,0,1.7,0.2,2.9-1c1-1.1,1.3-3.1,0.8-5.8l1.5-0.3
			c0.6,3.2,0.2,5.6-1.2,7.1C28.2,22.1,26.6,22.2,25.8,22.2z" />
                </g>
                <g class="st1">
                    <g>
                        <path
                            class="st2"
                            d="M17,32.6l-0.5-0.3c-0.2-0.1-0.2-0.3-0.2-0.4c0.3-1,0-2.9-0.4-4.1c-0.1-0.2,0-0.4,0.2-0.5l0.6-0.2
				c0.2-0.1,0.4,0,0.5,0.2c0.3,1,1,3.5,0.4,5.1C17.5,32.6,17.2,32.7,17,32.6z" />
                        <path
                            class="st2"
                            d="M17.2,32.9c-0.1,0-0.2,0-0.3-0.1l0,0l-0.5-0.3c-0.3-0.1-0.4-0.5-0.3-0.7c0.3-0.9,0-2.6-0.4-4
				c-0.1-0.3,0.1-0.7,0.4-0.8l0.6-0.2c0.2-0.1,0.3,0,0.5,0c0.2,0.1,0.3,0.2,0.3,0.4c0.3,1,1,3.6,0.4,5.3c-0.1,0.2-0.2,0.3-0.4,0.4
				C17.4,32.9,17.3,32.9,17.2,32.9z M17.2,32.4h0.1c0,0,0.1,0,0.1-0.1c0.6-1.6-0.1-4-0.4-4.9c0,0,0-0.1-0.1-0.1h-0.1l-0.6,0.2
				c-0.1,0-0.1,0.1-0.1,0.2c0.4,1.3,0.8,3.2,0.4,4.3c0,0.1,0,0.1,0.1,0.2L17.2,32.4z" />
                    </g>
                </g>
                <g class="st1">
                    <circle
                        class="st2"
                        cx="30.1"
                        cy="13.8"
                        r="1.5" />
                </g>
                <g class="st1">
                    <g>
                        <path
                            class="st2"
                            d="M28.4,31.6l0.1-0.4c0.1-0.3-0.1-0.6-0.3-0.7c-2-0.8-2.5-3.3-2.6-4.4c0-0.3-0.3-0.5-0.6-0.5h-0.4
				c-0.3,0-0.6,0.3-0.5,0.6c0.2,1.3,0.8,4.5,3.6,5.6C28,32.1,28.4,31.9,28.4,31.6z" />
                        <path
                            class="st2"
                            d="M27.9,32.2c-0.1,0-0.2,0-0.3-0.1c-2.9-1.2-3.6-4.5-3.8-5.8c0-0.2,0-0.5,0.2-0.6c0.1-0.2,0.4-0.3,0.6-0.3H25
				c0.4,0,0.8,0.3,0.8,0.7c0.1,1,0.6,3.4,2.5,4.2c0.4,0.2,0.6,0.6,0.5,1l-0.1,0.4c-0.1,0.2-0.2,0.4-0.4,0.5
				C28.1,32.2,28,32.2,27.9,32.2z M25,25.9L25,25.9h-0.4c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.2-0.1,0.2c0.2,1.3,0.8,4.4,3.5,5.4
				c0.1,0,0.2,0,0.2,0c0.1,0,0.1-0.1,0.2-0.2l0,0l0.1-0.4c0-0.1,0-0.3-0.2-0.4c-2.1-0.9-2.7-3.5-2.8-4.6C25.3,26,25.2,25.9,25,25.9z
				" />
                    </g>
                </g>
                <g class="st1">
                    <g>
                        <path
                            class="st2"
                            d="M24,32.1l0.2-0.3c0.1-0.2,0.1-0.6-0.1-0.7c-1.5-1.2-1.4-2.7-1.3-3.5c0.1-0.3-0.1-0.5-0.3-0.6l-0.4-0.1
				c-0.3-0.1-0.7,0.1-0.8,0.4c-0.3,1.4-0.2,3.5,1.8,5.1C23.5,32.5,23.8,32.4,24,32.1z" />
                        <path
                            class="st2"
                            d="M23.5,32.6c-0.2,0-0.3-0.1-0.5-0.2c-2.5-1.9-2.1-4.6-1.9-5.3c0.1-0.2,0.2-0.4,0.4-0.5c0.2-0.1,0.5-0.1,0.7,0
				l0.4,0.1c0.4,0.1,0.6,0.5,0.5,0.9c-0.2,0.7-0.2,2.2,1.2,3.2c0.3,0.3,0.4,0.7,0.2,1.1l-0.2,0.3c-0.1,0.2-0.3,0.3-0.5,0.4
				C23.6,32.6,23.6,32.6,23.5,32.6z M21.9,27c-0.1,0-0.1,0-0.1,0c-0.1,0-0.1,0.1-0.2,0.2c-0.2,0.7-0.5,3.1,1.7,4.8
				c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2-0.1,0.2-0.1l0.2-0.3c0.1-0.1,0-0.3-0.1-0.4c-1.6-1.2-1.5-2.9-1.4-3.7c0-0.2,0-0.3-0.2-0.4
				L22,27.1C22,27,22,27,21.9,27z" />
                    </g>
                </g>
            </g>
            <g
                id="content_search"
                class="st0">
                <g class="st1">
                    <g>
                        <path
                            class="st2"
                            d="M14.3,23.5c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8S18.7,23.5,14.3,23.5z M14.3,8.4c-3.9,0-7,3.1-7,7
				s3.1,7,7,7s7-3.1,7-7C21.3,11.6,18.2,8.4,14.3,8.4z" />
                    </g>
                    <g>
                        <polygon
                            class="st2"
                            points="27.2,27.6 20,20.4 20.7,19.7 27.9,26.9 			" />
                    </g>
                </g>
            </g>
            <g
                id="menu"
                class="st0">
                <g class="st1">
                    <rect
                        x="7.1"
                        y="9.2"
                        class="st2"
                        width="19.8"
                        height="1.5" />
                </g>
                <g class="st1">
                    <rect
                        x="7.1"
                        y="16.3"
                        class="st2"
                        width="19.8"
                        height="1.5" />
                </g>
                <g class="st1">
                    <rect
                        x="7.1"
                        y="23.3"
                        class="st2"
                        width="19.8"
                        height="1.5" />
                </g>
            </g>
            <g
                id="logo_reallusion"
                class="st0">
                <g class="st1">
                    <path
                        class="st2"
                        d="M0,7.2c1.7,1.4,6.6,5.9,21,5.6c14.4-0.4,18.9-3.6,19.2-5C40.5,6.3,39,6,39,6s3.2,0.1,2.7,2s-3.3,4.3-10.8,5.7
			c-7.5,1.5-13.2,1.2-18.4,0.6C6.6,13.6,0.9,10.4,0,7.2z" />
                    <path
                        class="st2"
                        d="M0.3,7.6C1.9,9,6.7,13.4,21.1,13S40,9.2,40.4,7.8c0.4-1.2-0.7-1.5-0.7-1.5s2.2,0.3,1.8,1.7
			c-0.5,1.8-3.1,4-10.6,5.5c-6.1,1.2-11.6,1.4-18.2,0.5C6.8,13.3,1.6,10.4,0.3,7.6z" />
                    <path
                        class="st2"
                        d="M0.7,8c1.4,1.3,6.1,5.7,20.5,5.3c14.4-0.3,18.9-4,19.3-5.4c0.4-1.1-0.3-1.4-0.3-1.4s1.2,0.5,1,1.5
			c-0.4,1.7-3,3.9-10.4,5.3c-4.7,0.9-10,1.5-17.9,0.5C6.9,13.1,2.2,10.3,0.7,8z" />
                </g>
                <path
                    class="st3"
                    d="M39.2-0.8c0,0-0.9,3.9-10.2,5.7c0,0-0.9,0.1-1.6-0.5c0,0-2.7-2.9-10.9-3.8c0,0-6.8-0.7-11.9,0
		c0,0-3.2,0.4-3.2,1.3l0.2,1.5c0.5-0.4,2.1-1,7.1-1.3c0,0,8.4-0.6,15,1.9c0,0,2.6,0.9,3.9,2.2c0,0,0.4,1,2.3,0.5
		C29.9,6.8,41,4.4,39.2-0.8z" />
                <path
                    class="st3"
                    d="M1.5,1.9c0,0,0.3,3.5,11.6,5.4c0,0,9.5,2,21.2-1c0,0,6.7-2,7.5-5c0,0,2.3,4.3-7.9,7.2c0,0-9.9,2.8-21.3,0.8
		c0,0-10.2-1.6-11.2-5.6L1.5,1.9L1.5,1.9z" />
            </g>
            <g
                id="newsletters"
                class="st0">
                <g class="st1">
                    <path
                        class="st4"
                        d="M86.5,53.3H0.1V0h86.4V53.3z M2,51.4h82.6V1.9H2V51.4z" />
                </g>
                <g class="st1">
                    <polygon
                        class="st4"
                        points="44,39.2 1.5,1.7 2.7,0.3 44,36.7 85.1,0.3 86.4,1.7 		" />
                </g>
                <g class="st1">

                    <rect
                        x="69.496"
                        y="20.9"
                        transform="matrix(0.5947 -0.8039 0.8039 0.5947 -3.5661 72.824)"
                        class="st4"
                        width="1.9"
                        height="38.099" />
                </g>
                <g class="st1">
                    <path
                        class="st5"
                        d="M36,26.3" />
                </g>
                <g class="st1">

                    <rect
                        x="-1.7"
                        y="38.701"
                        transform="matrix(0.8039 -0.5948 0.5948 0.8039 -20.0732 18.4231)"
                        class="st4"
                        width="39.201"
                        height="1.9" />
                </g>
            </g>
            <g
                id="logout"
                class="st0">
                <g class="st1">
                    <g>
                        <path
                            class="st2"
                            d="M14,16.7c-3.2,0-5.7-2.6-5.7-5.7s2.6-5.7,5.7-5.7s5.7,2.6,5.7,5.7S17.2,16.7,14,16.7z M14,6.5
				c-2.5,0-4.5,2-4.5,4.5s2,4.5,4.5,4.5s4.5-2,4.5-4.5S16.4,6.5,14,6.5z" />
                    </g>
                    <g>
                        <path
                            class="st2"
                            d="M21.7,28.7H6.3v-2.6v-2c0.4-3.7,3.7-6.3,7.6-6.3s7.2,2.7,7.6,6.3v0.1l0.1,1.7L21.7,28.7L21.7,28.7z
				 M7.5,27.5h13v-1.6l-0.1-1.7C20.1,21.3,17.2,19,14,19c-3.3,0-6.1,2.2-6.4,5.2L7.5,27.5z" />
                    </g>
                </g>
                <g class="st1">
                    <rect
                        x="20.801"
                        y="16.101"
                        transform="matrix(1 -0.0078 0.0078 1 -0.1296 0.191)"
                        class="st2"
                        width="7.2"
                        height="1.2" />
                </g>
                <g class="st1">
                    <path
                        class="st9"
                        d="M25.9,16.4" />
                </g>
                <g class="st1">
                    <polygon
                        class="st2"
                        points="25.7,20.2 24.8,19.4 27.3,16.7 24.8,13.9 25.8,13.1 29,16.7 		" />
                </g>
            </g>
            <g
                id="icon_login"
                class="st0">
                <g class="st1">
                    <g>
                        <path
                            class="st2"
                            d="M14,16.7c-3.2,0-5.7-2.6-5.7-5.7s2.6-5.7,5.7-5.7s5.7,2.6,5.7,5.7S17.2,16.7,14,16.7z M14,6.5
				c-2.5,0-4.5,2-4.5,4.5s2,4.5,4.5,4.5s4.5-2,4.5-4.5S16.4,6.5,14,6.5z" />
                    </g>
                    <g>
                        <path
                            class="st2"
                            d="M21.7,28.7H6.3v-2.6v-2c0.4-3.7,3.7-6.3,7.6-6.3s7.2,2.7,7.6,6.3v0.1l0.1,1.7L21.7,28.7L21.7,28.7z
				 M7.5,27.5h13v-1.6l-0.1-1.7C20.1,21.3,17.2,19,14,19c-3.3,0-6.1,2.2-6.4,5.2L7.5,27.5z" />
                    </g>
                </g>
                <g class="st1">
                    <rect
                        x="24.825"
                        y="13.171"
                        transform="matrix(0.0078 -1 1 0.0078 8.4553 42.0646)"
                        class="st2"
                        width="1.2"
                        height="7.2" />
                </g>
                <g class="st1">
                    <path
                        class="st9"
                        d="M23.9,16.4" />
                </g>
                <g class="st1">
                    <polygon
                        class="st2"
                        points="20.8,16.7 24,13.1 25,13.9 22.5,16.7 25,19.4 24.1,20.2 		" />
                </g>
            </g>
            <g
                id="add_to_cart"
                class="st0">
                <g class="st3">
                    <polygon points="22,23.2 11,23.2 9.8,17.7 10.8,17.5 11.8,22.2 21.2,22.2 22.6,18 23.6,18.4 		" />
                </g>
                <g class="st3">
                    <polygon points="20.6,15.3 9,15.3 8,11.9 5.5,11.9 5.5,10.9 8.8,10.9 9.8,14.3 20.6,14.3 		" />
                </g>
                <g class="st3">
                    <circle
                        cx="12.7"
                        cy="27"
                        r="1.4" />
                </g>
                <g class="st3">
                    <circle
                        cx="20.4"
                        cy="27"
                        r="1.4" />
                </g>
                <path
                    class="st3"
                    d="M24,9.2c-2.7,0-5,2.2-5,5c0,2.7,2.2,5,5,5c2.7,0,5-2.2,5-5S26.7,9.2,24,9.2z M27.2,14.8h-2.4v2.8h-1.5v-2.8
		h-2.4v-1.4h2.4v-2.6h1.5v2.6h2.4V14.8z" />
                <g class="st3">
                    <path
                        d="M17.3,32.6c-8.6,0-15.6-7-15.6-15.6s7-15.6,15.6-15.6s15.6,7,15.6,15.6S25.9,32.6,17.3,32.6z M17.3,2.4
			C9.2,2.4,2.6,8.9,2.6,17s6.6,14.6,14.6,14.6S31.9,25.1,31.9,17S25.3,2.4,17.3,2.4z" />
                </g>
            </g>
            <g
                id="add_to_cart_hover"
                class="st0">
                <g class="st3">
                    <polygon
                        points="24.8,10.7 23.2,10.7 23.2,13.3 20.8,13.3 20.8,14.8 23.2,14.8 23.2,17.5 24.8,17.5 24.8,14.8 27.2,14.8
			27.2,13.3 24.8,13.3 		" />
                    <path
                        d="M17.3,1.4C8.6,1.4,1.7,8.4,1.7,17s7,15.6,15.6,15.6s15.6-7,15.6-15.6S25.9,1.4,17.3,1.4z M12.7,28.4
			c-0.8,0-1.4-0.6-1.4-1.4s0.6-1.4,1.4-1.4s1.4,0.6,1.4,1.4S13.5,28.4,12.7,28.4z M20.4,28.4c-0.8,0-1.4-0.6-1.4-1.4
			s0.6-1.4,1.4-1.4s1.4,0.6,1.4,1.4S21.2,28.4,20.4,28.4z M24,19.1c-0.2,0-0.4,0-0.6-0.1L22,23.1H11l-1.2-5.4l1-0.2l1.1,4.6h9.4
			l1.2-3.4c-1.6-0.5-2.8-1.9-3.2-3.5H9l-1-3.4H5.5v-1h3.2l1,3.4H19v-0.1c0-2.7,2.2-5,5-5c2.7,0,5,2.2,5,5S26.7,19.1,24,19.1z" />
                </g>
            </g>
            <g
                id="youtube"
                class="st0">
                <g
                    id="Lozenge"
                    class="st1">
                    <g>
                        <path
                            class="st15"
                            d="M33.5,10.3c0,0-0.3-2.3-1.3-3.3c-1.3-1.3-2.7-1.3-3.4-1.4c-4.7-0.3-11.7-0.3-11.7-0.3l0,0c0,0-7,0-11.7,0.3
				c-0.8,0-2.2,0-3.5,1.3c-1,1-1.3,3.3-1.3,3.3S0.3,13,0.3,15.7v2.5c0,2.7,0.3,5.4,0.3,5.4S0.9,26,1.9,27c1.3,1.3,3,1.3,3.7,1.4
				C8.3,28.7,17,28.8,17,28.8s7.1,0,11.7-0.4c0.7-0.1,2.1-0.1,3.4-1.4c1-1,1.3-3.3,1.3-3.3s0.3-2.7,0.3-5.4v-2.5
				C33.8,13,33.5,10.3,33.5,10.3z M13.6,21.3v-9.4l9.1,4.7L13.6,21.3z" />
                    </g>
                </g>
            </g>
            <path
                id="twitter"
                class="st16"
                d="M33.7,6.9c-1.3,0.5-2.5,0.9-4,1.1c1.4-0.9,2.5-2.2,3.1-3.8c-1.3,0.7-2.7,1.3-4.3,1.6
	c-1.3-1.3-3.1-2.2-5.1-2.2c-3.8,0-6.9,3.1-6.9,6.9c0,0.5,0,1.1,0.2,1.6C11.1,11.8,6.1,9,2.8,4.9C2.1,5.8,1.7,7.1,1.7,8.3
	c0,2.3,1.3,4.5,3.1,5.8c-1.1,0-2.2-0.4-3.1-0.9l0,0c0,3.3,2.3,6.1,5.4,6.7c-0.5,0.2-1.3,0.2-1.8,0.2c-0.4,0-0.9,0-1.3-0.2
	c0.9,2.7,3.4,4.7,6.3,4.7c-2.3,1.8-5.2,2.9-8.5,2.9c-0.5,0-1.1,0-1.6-0.2c3.1,2,6.7,3.1,10.5,3.1c12.7,0,19.5-10.5,19.5-19.5
	c0-0.4,0-0.5,0-0.9C31.7,9.4,32.8,8.1,33.7,6.9z" />
            <path
                id="fb_1_"
                class="st16"
                d="M25.8,5.7h-3.1c-2.4,0-2.9,1.1-2.9,2.9v3.9h5.9L25,18.4h-5.2v15.3h-6.1V18.4H8.5v-5.9h5.2V8.1
	c0-5.2,3.1-7.9,7.7-7.9c2.2,0,4,0.2,4.6,0.2L25.8,5.7L25.8,5.7z" />
            <g
                id="blog"
                class="st0">
                <path
                    class="st17"
                    d="M31.5,13H30c-1.4,0-2.3-0.9-2.3-1.9v-0.9c0-4.8-5.2-9.8-9.7-9.8h-7C5.1,0.3,0.4,5,0.4,10.9v12.7
		c0,5.6,4.8,10.1,9.7,10.1h13.4c5.5,0,10.2-4.6,10.2-10.2v-8C33.8,14,33.3,13,31.5,13z M11,9.1h6.1C18.2,9.1,19,10,19,11
		c0,1.1-0.9,1.9-1.9,1.9H11C10,13,9.1,12.1,9.1,11C9.1,10,10,9.1,11,9.1z M23.1,25H11c-1.1,0-1.9-0.9-1.9-1.9c0-1.1,0.9-1.9,1.9-1.9
		h12c1.1,0,1.9,0.9,1.9,1.9C25,24.2,24.1,25,23.1,25z" />
            </g>
            <g
                id="IC7"
                class="st0">
                <g class="st1">
                    <g>
                        <path
                            class="st2"
                            d="M20,10.7V4.3l9.5,10.3h-5.9c0.1,0.4,0.2,0.7,0.3,1.1H32L18.9,1.4v8.9C19.3,10.4,19.7,10.6,20,10.7z" />
                        <path
                            class="st2"
                            d="M32.3,15.9h-8.5v-0.1c-0.1-0.4-0.2-0.7-0.3-1.1l-0.1-0.2h5.8l-9.1-9.9v6.3H20c-0.3-0.2-0.7-0.3-1.1-0.4h-0.1
				V1.1L19,1.4L32.3,15.9z M24,15.6h7.8L19,1.7v8.5c0.3,0.1,0.6,0.2,0.9,0.3V4l9.9,10.8h-6C23.8,15.1,23.9,15.3,24,15.6z" />
                    </g>
                    <g>
                        <path
                            class="st2"
                            d="M17,12.7c2.4,0,4.4,2,4.4,4.4s-2,4.4-4.4,4.4s-4.4-2-4.4-4.4S14.6,12.7,17,12.7 M17,11.6
				c-3,0-5.5,2.5-5.5,5.5s2.5,5.5,5.5,5.5s5.5-2.5,5.5-5.5S20,11.6,17,11.6L17,11.6z" />
                        <path
                            class="st2"
                            d="M17,22.7c-3.1,0-5.6-2.5-5.6-5.6s2.5-5.6,5.6-5.6s5.6,2.5,5.6,5.6S20.1,22.7,17,22.7z M17,11.7
				c-3,0-5.4,2.4-5.4,5.4s2.4,5.4,5.4,5.4s5.4-2.4,5.4-5.4S20,11.7,17,11.7z M17,21.6c-2.5,0-4.5-2-4.5-4.5s2-4.5,4.5-4.5
				s4.5,2,4.5,4.5S19.5,21.6,17,21.6z M17,12.8c-2.3,0-4.3,1.9-4.3,4.3c0,2.3,1.9,4.3,4.3,4.3s4.3-1.9,4.3-4.3S19.3,12.8,17,12.8z" />
                    </g>
                    <g>
                        <path
                            class="st2"
                            d="M10.4,14.7H4.5L14,4.3v6.4c0.4-0.2,0.7-0.3,1.1-0.4V1.4L2,15.8h8.1C10.2,15.4,10.3,15,10.4,14.7z" />
                        <path
                            class="st2"
                            d="M10.2,15.9H1.7l0.2-0.2L15.2,1.1v9.3h-0.1c-0.4,0.1-0.7,0.2-1.1,0.4l-0.2,0.1V4.6l-9.1,9.9h5.8l-0.1,0.2
				C10.4,15,10.3,15.4,10.2,15.9L10.2,15.9z M2.2,15.6H10c0.1-0.3,0.1-0.6,0.2-0.9h-6L14.1,4v6.6c0.3-0.1,0.6-0.2,0.9-0.3V1.7
				L2.2,15.6z" />
                    </g>
                    <g>
                        <path
                            class="st2"
                            d="M23.7,19.2c-0.1,0.4-0.3,0.8-0.5,1.1h5.9L17,31.2L4.9,20.4h5.9c-0.2-0.4-0.3-0.7-0.5-1.1H2l15,13.5l15-13.5
				L23.7,19.2L23.7,19.2z" />
                        <path
                            class="st2"
                            d="M17,32.9L17,32.9L1.7,19.1h8.7v0.1c0.1,0.4,0.3,0.7,0.5,1.1l0.1,0.2H5.2L17,31.1l11.8-10.6H23l0.1-0.2
				c0.2-0.4,0.3-0.7,0.5-1.1v-0.1h8.7l-0.2,0.2L17,32.9z M2.3,19.4L17,32.6l14.7-13.2h-8c-0.1,0.3-0.2,0.6-0.4,0.9h6L17,31.4
				l-0.1-0.1L4.6,20.2h6c-0.1-0.3-0.3-0.6-0.4-0.9L2.3,19.4L2.3,19.4z" />
                    </g>
                </g>
            </g>
            <g
                id="delete"
                class="st0">
                <g class="st1">

                    <rect
                        x="5.199"
                        y="15.7"
                        transform="matrix(0.7071 -0.7071 0.7071 0.7071 -6.8005 16.9822)"
                        class="st11"
                        width="23.8"
                        height="2" />
                </g>
                <g class="st1">

                    <rect
                        x="15.999"
                        y="4.699"
                        transform="matrix(0.7071 -0.7071 0.7071 0.7071 -6.7583 16.8819)"
                        class="st11"
                        width="2"
                        height="23.8" />
                </g>
                <g class="st1">

                    <rect
                        x="5.199"
                        y="15.7"
                        transform="matrix(0.7071 -0.7071 0.7071 0.7071 -6.8005 16.9822)"
                        class="st11"
                        width="23.8"
                        height="2" />
                </g>
            </g>
            <g
                id="top"
                class="st0">
                <polygon
                    class="st1"
                    points="8.1,25.3 6.4,24.2 17,9 27.6,23.8 25.9,24.9 17,12.5 	" />
            </g>

            <path
                id="member_login"
                class="st19"
                d="M12.7,26.6h8.5v-2.1c-0.3-2-2.1-3.4-4.2-3.4c-2.2,0-4,1.5-4.2,3.4L12.7,26.6z" />
            <g
                id="member_circle"
                class="st0">
                <g class="st1">
                    <circle
                        class="st8"
                        cx="16.9"
                        cy="23.8"
                        r="3.2" />
                </g>
            </g>
            <g
                id="logined"
                class="st0">
                <circle
                    class="st22"
                    cx="17"
                    cy="12.9"
                    r="4.4" />
                <path
                    class="st22"
                    d="M17,19.2c-2,0-3.7,0.9-5.2,2.7c-1.2,1.5-2.1,3.7-2.8,5.8c-0.2,0.5-0.4,1-0.6,1.5h0.1l-0.1,0.2l-0.3,0.1
		c0,0,8.4,6.9,16.6,0.5c0-0.2,0-0.4,0-0.6h0.1c0,0,0,0,0,0.1l0.5-0.1C24.7,26.8,22.7,19.2,17,19.2z" />
                <g class="st1">
                    <path
                        class="st8"
                        d="M16.8,4.1c7.6,0,13.8,6.2,13.8,13.8s-6.3,13.8-13.8,13.8l0,0C9.2,31.7,3,25.5,3,17.9S9.2,4.1,16.8,4.1
			 M16.8,2.6C8.3,2.6,1.5,9.4,1.5,17.9c0,8.4,6.9,15.3,15.3,15.3c8.5,0,15.3-6.9,15.3-15.3C32.1,9.4,25.3,2.6,16.8,2.6L16.8,2.6z" />
                </g>
            </g>
            <g
                id="Notification"
                class="st0">
                <g class="st1">
                    <path
                        class="st2"
                        d="M17.019,31.087c-2.206,0-4.001-1.795-4.001-4.001v-0.75h7.992v0.75C21.01,29.292,19.22,31.087,17.019,31.087z
			 M14.633,27.836c0.319,1.014,1.269,1.751,2.386,1.751c1.113,0,2.058-0.737,2.376-1.751H14.633z" />
                </g>
                <g class="st1">
                    <path
                        class="st2"
                        d="M28.74,25.161H5.287l0.778-1.166c0.262-0.394,0.535-0.779,0.808-1.165c0.41-0.581,0.834-1.182,1.205-1.788
			c0.109-0.179,0.172-0.312,0.204-0.431c0.041-0.15,0.047-0.315,0.047-0.653v-5.694c0-3.793,2.374-6.976,5.968-8.09V5.905
			c0-1.396,1.265-2.624,2.706-2.628c0.002,0,0.005,0,0.007,0c0.681,0,1.381,0.309,1.923,0.849c0.514,0.513,0.797,1.145,0.797,1.779
			v0.269c3.594,1.115,5.968,4.297,5.968,8.09v5.694c0,0.331,0.007,0.504,0.047,0.652c0.032,0.119,0.096,0.253,0.205,0.433
			c0.37,0.604,0.792,1.202,1.201,1.78c0.274,0.389,0.548,0.776,0.812,1.172L28.74,25.161z M8.122,23.661h17.785
			c-0.417-0.59-0.847-1.2-1.236-1.837l-0.001-0.002c-0.186-0.306-0.3-0.558-0.371-0.819c-0.093-0.341-0.1-0.648-0.1-1.045v-5.694
			c0-3.285-2.167-6.014-5.394-6.79L18.23,7.335V5.905c0-0.226-0.133-0.494-0.356-0.716c-0.254-0.254-0.585-0.412-0.864-0.412
			c0,0-0.001,0-0.002,0c-0.682,0.002-1.211,0.608-1.211,1.128v1.431l-0.575,0.138c-3.226,0.776-5.394,3.505-5.394,6.79v5.694
			c0,0.398-0.007,0.706-0.1,1.046c-0.07,0.26-0.185,0.513-0.372,0.819C8.968,22.461,8.539,23.071,8.122,23.661z" />
                </g>
            </g>
            <g
                id="top_nav_cart_2_"
                class="st0">
                <g class="st1">
                    <g>
                        <ellipse
                            class="st2"
                            cx="12.252"
                            cy="26.566"
                            rx="1.749"
                            ry="1.721" />
                    </g>
                </g>
                <g class="st1">
                    <g>
                        <ellipse
                            class="st2"
                            cx="24.844"
                            cy="26.566"
                            rx="1.749"
                            ry="1.721" />
                    </g>
                </g>
                <g class="st1">
                    <polygon
                        class="st2"
                        points="26.57,23.351 10.694,23.351 8.73,15.27 10.188,14.915 11.873,21.851 25.523,21.851 29.285,11.599
			7.894,11.599 6.649,7.109 2.99,7.109 2.99,5.609 7.79,5.609 9.034,10.099 31.434,10.099 		" />
                </g>
            </g>
            <g
                id="favorite"
                class="st0">
                <g
                    id="love_2_"
                    class="st1">
                    <g>
                        <path
                            class="st2"
                            d="M17,29.6l-2.4-2.1C7.9,22.2,2.7,18,2.7,12.9c0-4.3,3.1-7.4,7.6-7.4c2.2,0,4.6,1.4,6.7,4c2-2.6,4.4-4,6.6-4
				c4.4,0,7.6,3,7.7,7.4c0,5.1-5,9.1-12,14.6L17,29.6z M10.3,7c-3.6,0-6.1,2.4-6.1,5.9c0,4.2,4.3,7.8,11.4,13.4l1.4,1.3l1.4-1.2
				c7.1-5.6,11.4-9.3,11.4-13.4c-0.1-3.6-2.6-6-6.2-6c-1.9,0-4.2,1.6-6,4.2L17,12.1l-0.6-0.9C14.4,8.6,12.2,7,10.3,7z" />
                    </g>
                </g>
            </g>
            <g
                id="favorite_hover"
                class="st0">
                <path
                    class="st22"
                    d="M23.6,5.5c-2.2,0-4.6,1.5-6.6,4c-2.1-2.6-4.5-4-6.7-4c-4.5,0-7.6,3-7.6,7.4c0,5.1,5.3,9.3,11.9,14.6l2.4,2.1
		l2.4-2.1c7-5.5,12-9.5,12-14.6C31.2,8.5,28,5.5,23.6,5.5z" />
            </g>
            <g
                id="download"
                class="st0">
                <g class="st1">
                    <rect
                        x="5.5"
                        y="29.2"
                        class="st2"
                        width="22.6"
                        height="1.5" />
                </g>
                <g class="st1">
                    <path
                        class="st2"
                        d="M17,27L5.5,18.6h5.6V4.4h11.7v14.3h5.6L17,27z M10.2,20.1l6.8,5l6.8-5h-2.5V5.9h-8.7v14.3h-2.4V20.1z" />
                </g>
            </g>
            <g id="download_hover">
                <g>
                    <rect
                        x="5.5"
                        y="29.2"
                        class="st8"
                        width="22.6"
                        height="1.5" />
                </g>
                <polygon
                    class="st8"
                    points="22.9,18.6 22.9,4.4 11.1,4.4 11.1,18.6 5.5,18.6 17,27 28.5,18.6 	" />
            </g>
            <g
                id="pack"
                class="st0">
                <g class="st24">
                    <path
                        class="st25"
                        d="M25,28.5H2.4L2.5,5.8h11.7l2.6,3.4h13.9v4.1h2.2L25,28.5z M4.3,27h19.8l6.3-12.1H10.5L4.3,27z M4,7.3
			L3.9,24.4l5.6-11.1h19.6v-2.6h-13l-2.6-3.4C13.5,7.3,4,7.3,4,7.3z" />
                </g>
            </g>
            <g
                id="spring"
                class="st0">
                <path
                    class="st1"
                    d="M20.211,11.001l-8.787-1.746c-0.541-0.104-0.968-0.53-1.082-1.072c-0.141-0.749,0.342-1.471,1.083-1.623
		l4.174-0.826h-5.284V4.543v-0.64h12.573c0.531,0,0.987,0.38,1.09,0.901c0.123,0.598-0.275,1.186-0.882,1.309l-9.052,1.793
		l8.787,1.746c0.541,0.114,0.969,0.541,1.083,1.082c0.141,0.75-0.342,1.471-1.083,1.613l-8.787,1.746l8.787,1.746
		c0.541,0.104,0.969,0.531,1.083,1.082c0.141,0.74-0.342,1.461-1.083,1.613l-8.787,1.746l8.787,1.746
		c0.541,0.104,0.969,0.531,1.083,1.082c0.141,0.74-0.342,1.461-1.083,1.613l-8.787,1.746l9.052,1.793
		c0.522,0.104,0.901,0.56,0.901,1.091c0,0.617-0.503,1.12-1.11,1.12H10.315v-1.831h5.284l-4.174-0.826
		c-0.541-0.114-0.969-0.541-1.083-1.082c-0.141-0.75,0.342-1.471,1.083-1.613l8.787-1.746l-8.787-1.746
		c-0.541-0.104-0.969-0.531-1.083-1.082c-0.141-0.74,0.342-1.471,1.083-1.613l8.786-1.746l-8.787-1.746
		c-0.541-0.104-0.969-0.531-1.083-1.082c-0.141-0.74,0.342-1.461,1.083-1.613L20.211,11.001z" />
            </g>
            <g
                id="morph_animation"
                class="st0">
                <g class="st1">
                    <path
                        d="M31.681,18.445c-0.144-0.583-0.496-1.133-0.882-1.607c-1.107-1.356-2.549-2.392-3.973-3.411
			c-1.698-1.215-3.415-2.441-5.34-3.25c-0.909-0.382-1.89-0.671-2.871-0.571c-1.673,0.17-3.276,1.269-4.462,2.406
			c-1.169,1.12-2.087,2.494-2.722,3.981c-0.203,0.475-0.377,0.963-0.522,1.459c-0.147,0.507-0.263,1.023-0.347,1.544
			c-0.309,1.937-0.184,4.006,0.751,5.731c0.723,1.335,1.991,2.428,3.477,2.807c1.673,0.427,3.533-0.058,5.12-0.613
			c1.531-0.535,2.984-1.265,4.429-1.996c2.099-1.063,4.22-2.139,6.02-3.654c0.626-0.527,1.242-1.165,1.368-1.973
			C31.771,19.009,31.75,18.723,31.681,18.445z M10.948,18.738c0.134-0.687,0.34-1.377,0.612-2.051
			c0.17-0.423,0.371-0.887,0.553-1.272c0.343-0.686,0.692-1.208,0.999-1.631c0.053,0.284,0.202,0.571,0.439,0.841
			c-1.037,1.535-1.776,3.356-2.089,5.146C11.082,19.466,10.896,19.093,10.948,18.738z M10.768,20.17
			c0.129,0.181,0.315,0.35,0.568,0.519c-0.167,1.703,0.07,3.283,0.67,4.487c-0.078-0.056-0.141-0.118-0.187-0.188l-0.001-0.001
			l-0.012-0.019C11.794,24.949,10.62,23.05,10.768,20.17z M30.267,19.098c0.493-0.153,0.829-0.297,1.039-0.445
			c0.094,0.446,0.002,0.742-0.125,1.069c-0.075,0.145-0.127,0.242-0.165,0.309c-0.06,0.087-0.146,0.201-0.273,0.371l-0.125,0.133
			c-0.116,0.096-0.328,0.211-0.632,0.341C30.303,20.303,30.396,19.718,30.267,19.098z M25.886,22.793l0.507-0.163
			c0.775-0.248,1.462-0.468,2.051-0.667c-0.535,0.477-1.239,0.971-2.139,1.5c-0.371,0.186-0.836,0.399-1.229,0.574
			C25.405,23.651,25.681,23.227,25.886,22.793z M20.618,10.727c-0.485,0.204-0.988,0.545-1.498,1.018
			c-0.336-0.191-0.622-0.398-0.837-0.604C19.074,10.814,19.84,10.678,20.618,10.727z M19.595,11.99
			c0.6-0.579,1.171-0.937,1.701-1.067c-0.117,0.366-0.247,0.903-0.381,1.569C20.444,12.349,19.991,12.176,19.595,11.99z
			 M24.843,12.957c-0.286-0.239-0.59-0.494-0.904-0.751c0.375,0.236,0.74,0.475,1.08,0.699C24.976,12.922,24.92,12.94,24.843,12.957
			z M21.007,16.79c1.176,0.058,2.449,0.058,3.687-0.001c0.415,1.021,0.68,1.912,0.812,2.718c-1.671,0.294-3.225,0.539-4.622,0.729
			C20.887,19.119,20.929,17.96,21.007,16.79z M25.125,16.136c-0.367-0.762-0.812-1.594-1.36-2.537
			c0.44,0.024,0.819,0.017,1.128-0.019c0.795,0.7,1.702,1.507,2.518,2.321C26.809,16.006,26.024,16.087,25.125,16.136z
			 M21.055,16.115c0.075-0.965,0.175-1.958,0.292-2.882c0.592,0.143,1.211,0.251,1.798,0.314c0.513,0.963,0.934,1.821,1.285,2.618
			C23.293,16.202,22.131,16.184,21.055,16.115z M27.935,16.438c0.82,0.879,1.328,1.598,1.59,2.253
			c-0.761,0.197-1.802,0.414-3.263,0.681c-0.142-0.792-0.415-1.63-0.855-2.624C26.429,16.678,27.3,16.571,27.935,16.438z
			 M26.133,22.161c0.218-0.682,0.288-1.395,0.215-2.174c1.53-0.294,2.57-0.519,3.347-0.725c0.124,0.669-0.045,1.3-0.516,1.923
			c-0.744,0.262-1.704,0.56-2.918,0.937L26.133,22.161z M28.003,15.773c-0.804-0.79-1.744-1.609-2.572-2.317
			c0.089-0.037,0.162-0.08,0.217-0.13c0.947,0.641,2.037,1.394,3.02,2.168C28.592,15.56,28.415,15.664,28.003,15.773z
			 M23.402,12.982c-0.267-0.442-0.571-0.934-0.89-1.397c0.585,0.451,1.172,0.948,1.733,1.431
			C23.995,13.02,23.707,13.009,23.402,12.982z M20.801,13.09c-0.171,0.942-0.322,1.967-0.435,2.973
			c-1.213-0.106-2.292-0.279-3.21-0.515c0.708-1.487,1.459-2.486,1.979-3.076C19.622,12.705,20.196,12.918,20.801,13.09z
			 M11.988,20.094c0.275-1.753,0.974-3.553,1.974-5.082c0.532,0.42,1.302,0.786,2.24,1.065c-0.65,1.482-1.075,3.064-1.23,4.585
			C13.686,20.616,12.683,20.426,11.988,20.094z M15.697,20.672c0.146-1.463,0.541-2.99,1.145-4.424
			c0.984,0.238,2.144,0.406,3.451,0.5c-0.122,1.23-0.19,2.438-0.203,3.593C18.331,20.56,16.892,20.669,15.697,20.672z
			 M20.089,21.048c0.01,1.08,0.072,2.095,0.18,2.946c-1.272,0.39-2.738,0.824-4.056,1.12c-0.426-0.943-0.627-2.235-0.571-3.655
			C16.849,21.431,18.306,21.297,20.089,21.048z M14.434,14.334c0.931-1.245,2.062-2.265,3.198-2.882
			c0.25,0.264,0.598,0.527,1.017,0.766c-0.784,0.847-1.515,1.934-2.119,3.152C15.638,15.092,14.916,14.735,14.434,14.334z
			 M14.045,13.94c-0.278-0.359-0.359-0.728-0.228-1.047c1.014-1.133,2.171-1.938,3.353-2.334c0.009,0.161,0.066,0.333,0.167,0.506
			C16.168,11.682,15.004,12.698,14.045,13.94z M11.883,20.974c0.738,0.303,1.756,0.467,3.03,0.486
			c-0.061,1.46,0.15,2.802,0.598,3.799c-1.19,0.228-2.122,0.288-2.774,0.179C12.043,24.311,11.741,22.73,11.883,20.974z
			 M13.53,26.133c0.618,0,1.389-0.097,2.293-0.288c0.395,0.623,0.912,1.06,1.508,1.275c-0.385,0.1-0.712,0.161-0.974,0.182
			c-0.111,0.003-0.238,0.005-0.389,0.007c-1.085-0.032-2.018-0.44-2.712-1.183C13.345,26.131,13.437,26.133,13.53,26.133z
			 M20.355,24.579c0.097,0.575,0.216,1.033,0.347,1.334c-1.005,0.411-1.776,0.704-2.418,0.92c-0.7-0.06-1.306-0.456-1.76-1.147
			C17.759,25.388,19.091,24.98,20.355,24.579z M25.582,20.131c0.066,0.821-0.021,1.588-0.259,2.282
			c-0.715,0.222-1.453,0.454-2.2,0.689c-0.697,0.219-1.401,0.441-2.099,0.658c-0.077-0.84-0.124-1.814-0.136-2.828
			C22.284,20.721,23.821,20.459,25.582,20.131z M30.093,18.532c-0.269-0.667-0.774-1.383-1.582-2.24
			c0.333-0.105,0.561-0.223,0.694-0.361c0.976,0.824,1.581,1.506,1.895,2.14C31.022,18.161,30.787,18.319,30.093,18.532z
			 M21.426,12.635c0.088-0.632,0.174-1.155,0.249-1.529c0.403,0.541,0.818,1.257,1.122,1.803
			C22.343,12.844,21.873,12.75,21.426,12.635z M17.856,10.373c0.634-0.13,1.249-0.144,1.891-0.042
			c-0.59,0.047-1.174,0.19-1.775,0.436C17.884,10.62,17.844,10.483,17.856,10.373z M22.817,23.785l0.258-0.083
			c0.667-0.217,1.328-0.432,1.971-0.639c-0.285,0.561-0.676,1.072-1.136,1.489c-1.007,0.437-1.858,0.8-2.599,1.11
			c-0.082-0.302-0.161-0.763-0.227-1.315C21.661,24.161,22.241,23.972,22.817,23.785z" />
                    <path
                        d="M16.163,27.747c-0.467,0-0.933-0.049-1.386-0.164c-1.435-0.366-2.746-1.425-3.508-2.832
			c-1.07-1.975-1.002-4.223-0.756-5.762c0.083-0.52,0.2-1.041,0.348-1.551c0.145-0.496,0.321-0.989,0.524-1.465
			c0.652-1.527,1.598-2.909,2.733-3.998c1.046-1.002,2.674-2.235,4.492-2.419c0.838-0.084,1.761,0.097,2.896,0.575
			c1.94,0.815,3.673,2.055,5.35,3.255c1.407,1.007,2.862,2.049,3.982,3.419c0.473,0.579,0.765,1.111,0.893,1.626l0,0
			c0.073,0.301,0.089,0.595,0.046,0.873c-0.134,0.854-0.811,1.52-1.386,2.003c-1.813,1.526-3.957,2.611-6.03,3.661
			c-1.34,0.679-2.859,1.448-4.435,1.998C18.829,27.353,17.49,27.747,16.163,27.747z M19.013,9.637c-0.134,0-0.265,0.006-0.394,0.02
			c-1.883,0.19-3.585,1.581-4.432,2.392c-1.126,1.079-2.063,2.45-2.71,3.964c-0.202,0.472-0.376,0.961-0.52,1.454
			c-0.146,0.506-0.263,1.023-0.345,1.538c-0.243,1.523-0.311,3.749,0.746,5.699c0.749,1.383,2.037,2.423,3.445,2.781
			c1.714,0.438,3.621-0.097,5.091-0.611c1.569-0.549,3.085-1.316,4.423-1.994c2.068-1.047,4.207-2.129,6.011-3.647
			c0.562-0.473,1.223-1.12,1.351-1.942c0.042-0.266,0.026-0.546-0.044-0.834l0,0c-0.122-0.493-0.416-1.027-0.873-1.586
			c-1.11-1.36-2.561-2.398-3.963-3.402c-1.672-1.196-3.4-2.433-5.33-3.244C20.522,9.827,19.73,9.637,19.013,9.637z M15.969,27.359
			c-1.098-0.032-2.048-0.447-2.75-1.199l-0.084-0.091l0.124,0.007c0.088,0.005,0.178,0.007,0.271,0.007
			c0.615,0,1.383-0.097,2.283-0.287l0.034-0.007l0.019,0.029c0.386,0.61,0.899,1.045,1.483,1.255l0.152,0.055l-0.157,0.041
			c-0.39,0.101-0.721,0.162-0.983,0.183c-0.082,0.002-0.169,0.004-0.269,0.006L15.969,27.359z M13.379,26.181
			c0.674,0.676,1.567,1.049,2.591,1.079l0.122-0.003c0.099-0.001,0.186-0.003,0.265-0.005c0.22-0.018,0.494-0.065,0.813-0.143
			c-0.535-0.23-1.005-0.645-1.369-1.209c-0.892,0.188-1.656,0.282-2.27,0.282C13.479,26.183,13.429,26.183,13.379,26.181z
			 M18.29,26.884l-0.01-0.001c-0.715-0.062-1.336-0.466-1.798-1.169l-0.039-0.06l0.069-0.017c1.233-0.297,2.568-0.707,3.828-1.106
			l0.055-0.018l0.009,0.057c0.098,0.57,0.216,1.027,0.345,1.323l0.021,0.047l-0.048,0.019c-1.005,0.411-1.773,0.704-2.421,0.922
			L18.29,26.884z M16.605,25.718c0.438,0.637,1.015,1.004,1.673,1.064c0.633-0.213,1.383-0.498,2.358-0.896
			c-0.12-0.292-0.23-0.719-0.321-1.241C19.094,25.03,17.804,25.426,16.605,25.718z M21.277,25.729l-0.015-0.056
			c-0.083-0.308-0.164-0.777-0.229-1.322l-0.005-0.041l0.039-0.013c0.451-0.145,0.905-0.292,1.357-0.439l0.834-0.27
			c0.6-0.195,1.191-0.388,1.771-0.574l0.114-0.036l-0.054,0.106c-0.287,0.564-0.684,1.084-1.147,1.503l-0.014,0.009
			c-1.056,0.458-1.882,0.811-2.6,1.11L21.277,25.729z M21.139,24.381c0.06,0.491,0.132,0.917,0.206,1.212
			c0.703-0.294,1.512-0.64,2.538-1.085c0.422-0.383,0.787-0.851,1.063-1.36c-0.542,0.175-1.096,0.354-1.654,0.536l-0.834,0.271
			C22.018,24.097,21.577,24.24,21.139,24.381z M13.457,25.541c-0.271,0-0.515-0.018-0.729-0.054l-0.022-0.003l-0.012-0.02
			c-0.698-1.134-1.004-2.729-0.861-4.494l0.005-0.068l0.063,0.026c0.734,0.3,1.748,0.462,3.012,0.482l0.051,0.001l-0.002,0.051
			c-0.061,1.447,0.15,2.788,0.594,3.776l0.026,0.058l-0.062,0.012C14.714,25.464,14.023,25.541,13.457,25.541z M12.768,25.393
			c0.635,0.104,1.533,0.044,2.672-0.17c-0.428-0.984-0.633-2.298-0.58-3.713c-1.217-0.023-2.203-0.179-2.933-0.464
			C11.801,22.753,12.098,24.293,12.768,25.393z M12.14,25.332l-0.163-0.115c-0.083-0.06-0.151-0.127-0.2-0.201l-0.013-0.02
			c-0.05-0.082-1.192-1.993-1.046-4.829l0.007-0.144l0.083,0.117c0.124,0.175,0.305,0.341,0.554,0.507l0.025,0.017l-0.003,0.03
			c-0.165,1.685,0.071,3.268,0.666,4.459L12.14,25.332z M10.812,20.308c-0.095,2.528,0.834,4.282,1.01,4.589
			c-0.496-1.16-0.687-2.629-0.539-4.183C11.086,20.581,10.931,20.446,10.812,20.308z M16.184,25.171l-0.017-0.037
			c-0.428-0.946-0.632-2.253-0.576-3.678l0.001-0.047l0.047-0.001c1.203-0.026,2.655-0.16,4.441-0.41l0.057-0.008v0.058
			c0.01,1.07,0.072,2.087,0.18,2.939l0.005,0.041l-0.04,0.013c-1.181,0.362-2.708,0.817-4.06,1.121L16.184,25.171z M15.69,21.507
			c-0.049,1.373,0.146,2.63,0.552,3.549c1.322-0.299,2.811-0.741,3.972-1.098c-0.104-0.832-0.163-1.816-0.175-2.853
			C18.299,21.347,16.875,21.479,15.69,21.507z M24.896,24.173l0.144-0.168c0.321-0.378,0.599-0.805,0.802-1.233l0.009-0.02
			l0.528-0.17c0.749-0.239,1.456-0.466,2.051-0.667l0.231-0.078L28.478,22c-0.542,0.484-1.244,0.977-2.146,1.506
			c-0.385,0.194-0.861,0.41-1.233,0.577L24.896,24.173z M25.922,22.834c-0.177,0.368-0.406,0.734-0.671,1.07
			c0.333-0.15,0.716-0.326,1.032-0.486c0.791-0.464,1.428-0.9,1.937-1.327c-0.541,0.181-1.16,0.379-1.811,0.587L25.922,22.834z
			 M20.979,23.826l-0.006-0.062c-0.077-0.854-0.124-1.833-0.136-2.832l-0.001-0.044l0.043-0.007c1.383-0.207,2.918-0.469,4.694-0.8
			l0.055-0.011l0.004,0.056c0.066,0.828-0.022,1.603-0.263,2.303l-0.008,0.023l-0.024,0.008c-0.577,0.179-1.17,0.365-1.77,0.554
			l-0.431,0.135c-0.696,0.22-1.4,0.441-2.1,0.658L20.979,23.826z M20.938,20.975c0.012,0.958,0.057,1.896,0.129,2.719
			c0.68-0.211,1.364-0.426,2.041-0.64l0.43-0.135c0.592-0.186,1.177-0.369,1.746-0.546c0.224-0.665,0.31-1.398,0.253-2.183
			C23.801,20.513,22.295,20.77,20.938,20.975z M26.056,22.236l0.029-0.092c0.216-0.676,0.285-1.381,0.212-2.153l-0.004-0.045
			l0.044-0.009c1.528-0.294,2.56-0.517,3.345-0.725l0.052-0.014l0.01,0.054c0.127,0.684-0.045,1.325-0.525,1.962l-0.009,0.012
			l-0.015,0.005c-0.731,0.258-1.669,0.549-2.856,0.918L26.056,22.236z M26.4,20.027c0.065,0.734,0.002,1.409-0.191,2.058l0.1-0.031
			c1.179-0.366,2.111-0.655,2.838-0.911c0.444-0.592,0.61-1.188,0.508-1.818C28.881,19.525,27.872,19.744,26.4,20.027z
			 M29.871,20.98l0.07-0.128c0.313-0.564,0.404-1.136,0.276-1.745l-0.01-0.044l0.044-0.014c0.482-0.148,0.817-0.292,1.025-0.438
			l0.062-0.043l0.016,0.073c0.098,0.462,0,0.771-0.127,1.099c-0.078,0.15-0.129,0.248-0.169,0.316
			c-0.059,0.085-0.137,0.189-0.251,0.342l-0.024,0.033l-0.13,0.138c-0.122,0.104-0.333,0.217-0.648,0.353L29.871,20.98z
			 M30.324,19.132c0.11,0.571,0.036,1.11-0.228,1.642c0.231-0.105,0.396-0.198,0.488-0.275l0.143-0.158
			c0.113-0.151,0.19-0.255,0.247-0.336c0.036-0.063,0.087-0.16,0.162-0.305c0.116-0.3,0.202-0.567,0.134-0.963
			C31.06,18.869,30.749,18.999,30.324,19.132z M15.642,20.722l0.005-0.055c0.146-1.468,0.544-3.002,1.149-4.438l0.016-0.039
			l0.042,0.01c0.98,0.238,2.138,0.405,3.443,0.499l0.051,0.003l-0.005,0.051c-0.121,1.229-0.189,2.437-0.203,3.589v0.043
			l-0.044,0.006c-1.762,0.22-3.2,0.328-4.399,0.331H15.642z M16.872,16.307c-0.585,1.397-0.972,2.888-1.12,4.315
			c1.173-0.007,2.578-0.113,4.288-0.325c0.015-1.126,0.081-2.304,0.198-3.503C18.968,16.701,17.836,16.537,16.872,16.307z
			 M15.016,20.713l-0.047-0.002c-1.292-0.045-2.302-0.237-3.002-0.572l-0.034-0.016l0.006-0.037
			c0.275-1.756,0.979-3.568,1.981-5.102l0.03-0.046l0.042,0.034c0.526,0.415,1.294,0.78,2.223,1.056l0.054,0.016l-0.022,0.052
			c-0.648,1.477-1.072,3.057-1.227,4.57L15.016,20.713z M12.043,20.064c0.678,0.314,1.648,0.498,2.883,0.545
			c0.158-1.491,0.574-3.045,1.207-4.501c-0.892-0.27-1.636-0.623-2.159-1.023C13.002,16.586,12.317,18.352,12.043,20.064z
			 M20.834,20.295v-0.058c0.003-1.109,0.044-2.271,0.123-3.451l0.003-0.049l0.05,0.002c1.177,0.058,2.449,0.058,3.683,0l0.035-0.002
			l0.013,0.033c0.416,1.024,0.683,1.917,0.815,2.729l0.008,0.049l-0.049,0.008c-1.668,0.294-3.224,0.539-4.624,0.73L20.834,20.295z
			 M21.054,16.842c-0.075,1.141-0.115,2.263-0.12,3.337c1.371-0.188,2.889-0.427,4.515-0.713c-0.133-0.782-0.391-1.643-0.787-2.625
			C23.454,16.897,22.208,16.897,21.054,16.842z M11.496,19.863l-0.066-0.053c-0.393-0.316-0.586-0.71-0.532-1.079l0-0.003
			c0.135-0.689,0.342-1.382,0.615-2.06c0.17-0.423,0.372-0.888,0.554-1.275c0.363-0.727,0.728-1.257,1.004-1.639l0.068-0.094
			l0.021,0.114c0.051,0.278,0.195,0.553,0.428,0.817l0.025,0.029l-0.021,0.032c-1.031,1.527-1.77,3.348-2.082,5.127L11.496,19.863z
			 M10.997,18.747c-0.045,0.313,0.111,0.648,0.431,0.931c0.32-1.753,1.05-3.542,2.061-5.048c-0.2-0.235-0.334-0.478-0.401-0.726
			c-0.265,0.37-0.598,0.87-0.93,1.534c-0.181,0.384-0.382,0.847-0.551,1.268C11.335,17.377,11.13,18.063,10.997,18.747z
			 M26.223,19.431l-0.009-0.05c-0.143-0.789-0.413-1.62-0.853-2.613l-0.028-0.065l0.07-0.005c1.02-0.07,1.892-0.177,2.522-0.309
			l0.027-0.006l0.019,0.021c0.827,0.886,1.336,1.606,1.601,2.269l0.021,0.053l-0.055,0.015c-0.756,0.195-1.794,0.412-3.267,0.681
			L26.223,19.431z M25.481,16.793c0.417,0.951,0.679,1.756,0.821,2.521c1.408-0.258,2.414-0.467,3.154-0.656
			c-0.263-0.631-0.754-1.321-1.539-2.164C27.3,16.62,26.46,16.724,25.481,16.793z M30.063,18.594l-0.017-0.043
			c-0.268-0.664-0.768-1.371-1.572-2.225l-0.055-0.058l0.076-0.024c0.325-0.103,0.546-0.216,0.673-0.348l0.032-0.034l0.036,0.03
			c0.982,0.829,1.589,1.514,1.908,2.156l0.015,0.03l-0.021,0.025c-0.124,0.143-0.48,0.307-1.031,0.476L30.063,18.594z
			 M28.601,16.315c0.767,0.819,1.251,1.507,1.521,2.156c0.606-0.189,0.833-0.33,0.918-0.409c-0.313-0.613-0.897-1.271-1.833-2.063
			C29.077,16.118,28.878,16.222,28.601,16.315z M23.26,16.234c-0.753,0-1.501-0.023-2.208-0.069l-0.051-0.003l0.004-0.051
			c0.075-0.964,0.176-1.961,0.292-2.884l0.007-0.055l0.055,0.013c0.589,0.142,1.208,0.25,1.792,0.313l0.025,0.003l0.013,0.023
			c0.52,0.975,0.94,1.832,1.287,2.621l0.029,0.067l-0.073,0.002C24.043,16.228,23.65,16.234,23.26,16.234z M21.108,16.068
			c1.035,0.065,2.157,0.083,3.245,0.049c-0.337-0.762-0.743-1.588-1.24-2.523c-0.563-0.062-1.156-0.165-1.724-0.299
			C21.278,14.184,21.182,15.141,21.108,16.068z M25.095,16.188l-0.015-0.03c-0.367-0.763-0.811-1.592-1.357-2.534l-0.047-0.08
			l0.093,0.005c0.436,0.024,0.814,0.018,1.119-0.02l0.022-0.002l0.017,0.015c0.791,0.697,1.703,1.508,2.521,2.324l0.068,0.068
			l-0.095,0.017c-0.604,0.105-1.396,0.188-2.293,0.236L25.095,16.188z M23.855,13.653c0.52,0.899,0.945,1.696,1.3,2.431
			c0.833-0.046,1.573-0.121,2.152-0.217c-0.792-0.785-1.667-1.563-2.431-2.236C24.593,13.664,24.245,13.67,23.855,13.653z
			 M20.41,16.118l-0.048-0.004c-1.214-0.106-2.297-0.28-3.219-0.517l-0.059-0.015l0.026-0.055c0.716-1.504,1.476-2.509,1.987-3.087
			l0.024-0.028l0.034,0.017c0.484,0.231,1.059,0.443,1.659,0.615l0.044,0.012l-0.009,0.044c-0.172,0.943-0.322,1.97-0.435,2.97
			L20.41,16.118z M17.227,15.515c0.891,0.224,1.932,0.391,3.095,0.494c0.11-0.971,0.256-1.966,0.422-2.883
			c-0.576-0.167-1.126-0.371-1.597-0.592C18.647,13.104,17.919,14.076,17.227,15.515z M27.988,15.829l-0.021-0.02
			c-0.825-0.81-1.807-1.663-2.569-2.314l-0.063-0.053l0.075-0.031c0.086-0.036,0.152-0.076,0.202-0.122l0.029-0.026l0.033,0.022
			c0.937,0.634,2.029,1.388,3.023,2.171l0.047,0.037l-0.045,0.04c-0.082,0.071-0.268,0.18-0.686,0.29L27.988,15.829z M25.522,13.469
			c0.749,0.641,1.693,1.463,2.495,2.249c0.312-0.084,0.479-0.164,0.568-0.224c-0.967-0.758-2.022-1.487-2.935-2.105
			C25.614,13.417,25.571,13.444,25.522,13.469z M16.556,15.431l-0.041-0.013c-0.896-0.281-1.627-0.642-2.113-1.045l-0.037-0.03
			l0.028-0.038c0.934-1.249,2.075-2.277,3.214-2.896l0.034-0.019l0.026,0.028c0.245,0.258,0.593,0.52,1.005,0.756l0.055,0.031
			l-0.042,0.046c-0.78,0.842-1.51,1.928-2.11,3.14L16.556,15.431z M14.502,14.326c0.469,0.377,1.159,0.716,2.002,0.984
			c0.59-1.183,1.303-2.246,2.065-3.079c-0.383-0.225-0.708-0.471-0.947-0.716C16.518,12.123,15.413,13.118,14.502,14.326z
			 M14.044,14.021l-0.04-0.051c-0.289-0.374-0.372-0.763-0.235-1.097l0.009-0.014c1.019-1.138,2.185-1.95,3.374-2.348l0.063-0.021
			l0.003,0.065c0.009,0.153,0.063,0.316,0.16,0.484l0.026,0.045l-0.046,0.024c-1.159,0.612-2.322,1.628-3.275,2.861L14.044,14.021z
			 M13.859,12.92c-0.113,0.282-0.046,0.613,0.186,0.938c0.941-1.205,2.082-2.2,3.222-2.813c-0.077-0.143-0.125-0.283-0.142-0.418
			C15.976,11.026,14.848,11.817,13.859,12.92z M24.127,13.067c-0.224,0-0.469-0.012-0.729-0.035l-0.024-0.002l-0.014-0.021
			c-0.238-0.395-0.554-0.91-0.889-1.395l-0.181-0.262l0.252,0.194c0.611,0.47,1.217,0.986,1.735,1.432l0.1,0.085l-0.131,0.002
			C24.207,13.066,24.167,13.067,24.127,13.067z M23.432,12.935c0.242,0.021,0.471,0.032,0.68,0.032
			c-0.423-0.363-0.896-0.765-1.381-1.148C22.994,12.215,23.238,12.613,23.432,12.935z M24.829,13.011l-0.165-0.138
			c-0.242-0.203-0.496-0.415-0.757-0.628l0.058-0.081c0.383,0.241,0.759,0.488,1.081,0.7l0.079,0.052l-0.088,0.036
			c-0.049,0.02-0.111,0.038-0.184,0.054L24.829,13.011z M24.61,12.697c0.04,0.033,0.079,0.066,0.118,0.098l0.127,0.107
			c0.018-0.004,0.034-0.008,0.049-0.012C24.811,12.828,24.712,12.764,24.61,12.697z M22.89,12.974l-0.1-0.015
			c-0.456-0.066-0.933-0.161-1.377-0.275l-0.043-0.011l0.006-0.044c0.086-0.617,0.173-1.147,0.25-1.532l0.021-0.11l0.067,0.09
			c0.421,0.563,0.844,1.302,1.126,1.809L22.89,12.974z M21.481,12.598c0.396,0.1,0.815,0.185,1.223,0.248
			c-0.264-0.47-0.632-1.105-1.002-1.617C21.633,11.59,21.557,12.06,21.481,12.598z M20.953,12.556L20.9,12.54
			c-0.47-0.143-0.929-0.317-1.327-0.505l-0.065-0.031l0.052-0.05c0.605-0.584,1.186-0.947,1.725-1.079l0.087-0.021l-0.027,0.085
			c-0.116,0.362-0.244,0.888-0.38,1.563L20.953,12.556z M19.683,11.975c0.363,0.167,0.773,0.323,1.194,0.453
			c0.122-0.602,0.237-1.083,0.344-1.433C20.739,11.134,20.223,11.463,19.683,11.975z M19.127,11.807l-0.031-0.018
			c-0.336-0.191-0.629-0.402-0.847-0.611l-0.056-0.053l0.07-0.029c0.801-0.331,1.574-0.469,2.357-0.418l0.213,0.013l-0.196,0.083
			c-0.478,0.201-0.977,0.54-1.483,1.009L19.127,11.807z M18.375,11.158c0.198,0.18,0.451,0.36,0.738,0.525
			c0.438-0.402,0.873-0.709,1.294-0.916c-0.033,0-0.066-0.001-0.099-0.001C19.666,10.767,19.03,10.896,18.375,11.158z M17.953,10.83
			l-0.022-0.037c-0.094-0.157-0.137-0.304-0.124-0.426l0.004-0.036l0.036-0.007c0.64-0.13,1.265-0.145,1.909-0.042l0.417,0.066
			l-0.421,0.033c-0.586,0.046-1.162,0.188-1.76,0.433L17.953,10.83z M17.904,10.414c0,0.084,0.031,0.183,0.09,0.291
			c0.451-0.182,0.889-0.305,1.33-0.374C18.846,10.293,18.381,10.32,17.904,10.414z" />
                </g>
                <g class="st1">
                    <rect
                        x="3.32"
                        y="11.39"
                        transform="matrix(0.7071 0.7071 -0.7071 0.7071 11.4582 -0.0186)"
                        width="4.864"
                        height="4.864" />
                </g>
                <g class="st1">
                    <g>
                        <rect
                            x="2.312"
                            y="6.063"
                            width="28.889"
                            height="1.5" />
                    </g>
                    <g>
                        <rect
                            x="2.312"
                            y="19.99"
                            width="5.15"
                            height="1.5" />
                    </g>
                </g>
            </g>
            <g
                id="3d_scan"
                class="st0">
                <g class="st1">
                    <path
                        d="M12.7,28.222c-2.276,0-4.563-0.379-6.599-1.117c-2.751-0.998-5.417-3.184-4.648-6.323c0.298-1.217,1.136-2.311,2.492-3.25
			l0.854,1.232c-1.045,0.726-1.681,1.523-1.889,2.374c-0.687,2.809,2.964,4.288,3.703,4.557c2.851,1.035,6.387,1.303,9.458,0.717
			l0.28,1.473C15.165,28.11,13.933,28.222,12.7,28.222z" />
                </g>
                <g class="st1">
                    <path
                        d="M23.912,27.985l-0.176-1.49c1.777-0.209,5.013-0.871,6.722-2.966c0.545-0.669,0.751-1.341,0.63-2.055
			c-0.183-1.074-1.137-2.232-2.551-3.101l0.783-1.278c1.806,1.106,2.988,2.61,3.246,4.127c0.192,1.134-0.135,2.259-0.946,3.254
			C29.577,26.981,25.914,27.75,23.912,27.985z" />
                </g>
                <g class="st1">
                    <polygon points="18.683,26.966 16.637,28.707 14.592,30.448 14.43,27.175 14.269,23.902 16.476,25.434 		" />
                </g>
                <g class="st1">
                    <path
                        d="M9.519,12.7h1.492c0.712,0,1.217-0.169,1.514-0.508c0.297-0.338,0.446-0.828,0.446-1.47c0-0.63-0.162-1.111-0.485-1.443
			S11.673,8.78,11.02,8.78c-0.595,0-1.073,0.164-1.435,0.49s-0.543,0.767-0.543,1.32H6.896c0-1.03,0.38-1.876,1.139-2.538
			s1.745-0.993,2.958-0.993c1.277,0,2.283,0.312,3.019,0.936c0.735,0.624,1.104,1.533,1.104,2.728c0,0.559-0.164,1.09-0.49,1.594
			c-0.327,0.503-0.808,0.899-1.443,1.187c0.748,0.265,1.289,0.656,1.625,1.174s0.503,1.124,0.503,1.818
			c0,1.201-0.399,2.132-1.196,2.794c-0.798,0.662-1.838,0.993-3.121,0.993c-1.213,0-2.219-0.313-3.02-0.936
			c-0.8-0.624-1.201-1.521-1.201-2.693h2.146c0,0.583,0.188,1.047,0.565,1.395c0.376,0.347,0.889,0.521,1.536,0.521
			c0.677,0,1.204-0.177,1.58-0.529c0.376-0.354,0.565-0.865,0.565-1.537c0-0.741-0.172-1.28-0.516-1.615
			c-0.345-0.335-0.891-0.503-1.638-0.503H9.519V12.7z" />
                    <path
                        d="M17.755,20.098V7.244h4.043c1.754,0,3.141,0.509,4.162,1.527c1.021,1.019,1.531,2.369,1.531,4.052v1.704
			c0,1.695-0.515,3.047-1.545,4.057c-1.029,1.009-2.451,1.514-4.264,1.514H17.755z M19.9,8.965v9.419h1.722
			c1.277,0,2.217-0.344,2.82-1.032c0.604-0.689,0.905-1.63,0.905-2.825v-1.722c0-1.207-0.298-2.148-0.892-2.825
			c-0.595-0.677-1.501-1.015-2.72-1.015H19.9z" />
                </g>
            </g>
            <g
                id="component"
                class="st0">
                <g class="st1">
                    <path
                        d="M30,30.313H8.444v-6.854c-0.479,0.188-0.99,0.286-1.505,0.286c-2.33,0-4.225-1.896-4.225-4.225
			c0-2.33,1.895-4.225,4.225-4.225c0.516,0,1.026,0.098,1.505,0.286V8.752h6.761c-0.171-0.46-0.259-0.946-0.259-1.445
			c0-2.34,1.904-4.245,4.245-4.245c2.341,0,4.245,1.904,4.245,4.245c0,0.499-0.088,0.985-0.259,1.445H30v9.144l-1.132-0.669
			c-0.439-0.26-0.906-0.392-1.387-0.392c-1.513,0-2.744,1.231-2.744,2.745s1.231,2.745,2.744,2.745c0.48,0,0.947-0.132,1.387-0.392
			L30,21.265V30.313z M9.944,28.813H28.5v-5.117c-0.335,0.086-0.677,0.13-1.019,0.13c-2.34,0-4.244-1.904-4.244-4.245
			s1.904-4.245,4.244-4.245c0.342,0,0.684,0.044,1.019,0.13v-5.213h-8.186l0.995-1.223c0.41-0.504,0.627-1.1,0.627-1.722
			c0-1.513-1.231-2.745-2.745-2.745c-1.513,0-2.745,1.231-2.745,2.745c0,0.622,0.217,1.217,0.627,1.722l0.995,1.223H9.944v8.279
			l-1.239-1.067c-0.355-0.306-0.95-0.67-1.766-0.67c-1.502,0-2.725,1.222-2.725,2.725c0,1.502,1.222,2.725,2.725,2.725
			c0.816,0,1.411-0.364,1.766-0.67l1.239-1.067V28.813z" />
                </g>
            </g>
            <g
                id="PBR"
                class="st0">
                <g class="st1">
                    <path
                        d="M4.169,19.216v4.761H2.073V11.419H6.98c1.414,0,2.507,0.352,3.277,1.056c0.771,0.705,1.156,1.652,1.156,2.842
			c0,1.202-0.385,2.152-1.156,2.851c-0.771,0.699-1.863,1.048-3.277,1.048H4.169z M4.169,17.534H6.98
			c0.793,0,1.381-0.204,1.764-0.612s0.573-0.938,0.573-1.587c0-0.65-0.191-1.185-0.573-1.604c-0.382-0.419-0.97-0.629-1.764-0.629
			H4.169V17.534z" />
                    <path
                        d="M12.6,23.977V11.419h4.209c1.409,0,2.494,0.28,3.255,0.841s1.143,1.421,1.143,2.583c0,0.575-0.158,1.082-0.479,1.522
			c-0.318,0.44-0.764,0.769-1.332,0.988v0.026c0.742,0.161,1.309,0.515,1.699,1.061c0.391,0.547,0.586,1.19,0.586,1.932
			c0,1.202-0.371,2.104-1.117,2.704c-0.744,0.601-1.809,0.901-3.195,0.901H12.6z M14.696,16.706h2.337
			c0.661,0,1.173-0.149,1.535-0.448c0.363-0.299,0.543-0.739,0.543-1.32c0-0.632-0.189-1.097-0.568-1.393
			c-0.38-0.296-0.958-0.444-1.734-0.444h-2.113V16.706z M14.696,18.268v4.036h2.673c0.724,0,1.277-0.167,1.656-0.501
			c0.379-0.333,0.57-0.811,0.57-1.432c0-0.678-0.162-1.198-0.484-1.561s-0.834-0.543-1.535-0.543H14.696z" />
                    <path
                        d="M25.128,18.768v5.209h-2.096V11.419h4.735c1.42,0,2.492,0.306,3.217,0.918s1.087,1.517,1.087,2.712
			c0,0.678-0.177,1.245-0.53,1.699c-0.354,0.455-0.879,0.825-1.574,1.113c0.725,0.236,1.237,0.601,1.539,1.095
			s0.453,1.127,0.453,1.897v1.044c0,0.373,0.044,0.727,0.134,1.061c0.089,0.333,0.245,0.598,0.47,0.793v0.225h-2.147
			c-0.235-0.195-0.385-0.493-0.448-0.893s-0.095-0.801-0.095-1.203v-1.009c0-0.661-0.177-1.178-0.531-1.549
			c-0.354-0.37-0.854-0.556-1.505-0.556H25.128z M25.128,17.085h2.433c0.856,0,1.473-0.158,1.85-0.474
			c0.377-0.316,0.565-0.811,0.565-1.483c0-0.65-0.182-1.15-0.544-1.501c-0.362-0.351-0.938-0.526-1.725-0.526h-2.579V17.085z" />
                </g>
            </g>
            <g
                id="physic"
                class="st0">
                <g class="st1">
                    <path
                        class="st26"
                        d="M16.641,24.22c-8.585,0-15.31-2.994-15.31-6.817c0-3.822,6.725-6.816,15.31-6.816
			c8.584,0,15.309,2.994,15.309,6.816C31.95,21.226,25.226,24.22,16.641,24.22z M16.641,12.087c-8.139,0-13.81,2.802-13.81,5.316
			c0,2.515,5.671,5.317,13.81,5.317c8.138,0,13.809-2.802,13.809-5.317C30.45,14.889,24.779,12.087,16.641,12.087z" />
                </g>
                <g class="st1">
                    <path
                        class="st26"
                        d="M22.527,31.113c-3.399,0-8.183-4.054-11.791-10.302C6.445,13.378,5.676,6.057,8.985,4.146
			c1.683-0.972,4.055-0.404,6.679,1.601c2.444,1.868,4.887,4.797,6.879,8.248c4.293,7.434,5.063,14.755,1.754,16.667l0,0
			C23.769,30.967,23.173,31.113,22.527,31.113z M10.801,5.182c-0.403,0-0.762,0.086-1.066,0.262c-2.177,1.258-1.767,7.57,2.3,14.617
			c4.07,7.046,9.335,10.554,11.512,9.302c2.177-1.259,1.767-7.571-2.303-14.619c-1.896-3.284-4.201-6.056-6.491-7.806
			C13.244,5.786,11.866,5.182,10.801,5.182z" />
                </g>
                <g class="st1">
                    <path
                        class="st26"
                        d="M10.754,31.113c-0.646,0-1.241-0.146-1.769-0.451l0,0c-3.31-1.912-2.54-9.233,1.753-16.667
			c1.992-3.451,4.436-6.38,6.88-8.248c2.623-2.003,4.997-2.572,6.678-1.601c3.31,1.912,2.54,9.232-1.752,16.666
			C18.936,27.06,14.153,31.113,10.754,31.113z M9.735,29.363c2.18,1.254,7.44-2.254,11.51-9.302
			c4.069-7.047,4.479-13.359,2.301-14.617c-1.11-0.641-2.937-0.096-5.018,1.495c-2.291,1.75-4.596,4.522-6.492,7.806
			C7.967,21.792,7.558,28.104,9.735,29.363L9.735,29.363z" />
                </g>
                <g class="st1">
                    <circle
                        class="st26"
                        cx="16.641"
                        cy="17.403"
                        r="2.427" />
                </g>
                <g class="st1">
                    <circle
                        class="st26"
                        cx="12.632"
                        cy="4.993"
                        r="1.82" />
                </g>
                <g class="st1">
                    <circle
                        class="st26"
                        cx="30.618"
                        cy="19.223"
                        r="1.82" />
                </g>
                <g class="st1">
                    <circle
                        class="st26"
                        cx="7.482"
                        cy="26.706"
                        r="1.82" />
                </g>
            </g>
            <g
                id="rl_certified"
                class="st0">
                <path
                    class="st3"
                    d="M26.5,21.7L26.5,21.7c0.4-0.6,0.7-1.3,1-2c0.3,0.1,0.6,0.2,0.9,0.2c2.8,0,4.3-4.6,4.3-4.6c-0.3,0-0.6,0-0.9,0
		c-1.6,0-2.7,0.4-3.4,0.9c0.1-0.9,0.2-1.8,0.2-2.7C31.8,13,31,7.9,31,7.9c-1.3,0.5-2.1,1.2-2.7,1.9c-0.2-1-0.4-1.7-0.4-1.9
		c0.8-2.7-3.7-4.3-3.7-4.3c-0.4,3.5,1.4,4.7,2.5,5c0.1,0.3,0.4,1.6,0.6,3.2c-1.2-1.4-3.1-2.3-3.1-2.3c-0.9,4.7,1.8,6.1,2.9,6.5
		c0,0.2-0.1,0.3-0.1,0.5c-0.2,1-0.5,1.9-0.9,2.8c-0.4-2-1.8-3.8-1.8-3.8c-3,3.8-1.4,6.4-0.5,7.4c-0.7,0.8-1.5,1.5-2.4,2.1
		c0.5-2.1-0.4-4.7-0.4-4.7c-4,2.5-3.5,5.3-3,6.6c-0.4,0.2-0.7,0.3-1.1,0.5c-0.5-0.2-0.9-0.4-1.3-0.6c0.4-1.4,0.5-4.2-3.6-6.2
		c0,0-0.5,2.1-0.1,4c-0.7-0.5-1.3-1.1-1.8-1.7c0.9-0.9,2.6-3.5-0.5-7.4c0,0-1.4,1.8-1.8,3.8c-0.4-0.9-0.7-1.8-0.9-2.8
		c0-0.2-0.1-0.4-0.1-0.5c1.1-0.4,3.9-1.8,2.9-6.5c0,0-1.9,0.9-3.1,2.3c0.1-1.7,0.5-2.9,0.6-3.2c1.1-0.4,2.9-1.5,2.5-5
		c0,0-4.4,1.6-3.7,4.3c0,0.2-0.2,0.9-0.4,1.9C5.1,9.1,4.3,8.4,3,7.9c0,0-0.8,5.1,2.3,5.6c0,0.9,0.1,1.8,0.2,2.7
		c-0.8-0.5-1.9-0.9-3.4-0.9c-0.3,0-0.6,0-0.9,0c0,0,1.5,4.6,4.3,4.6c0.3,0,0.6,0,0.9-0.2c0.3,0.7,0.6,1.4,1,2l0,0
		c-0.4-0.1-0.9-0.2-1.5-0.2c-1,0-2.1,0.2-3.5,0.7c0,0,2.8,4,5.8,4c0.8,0,1.5-0.3,2.3-0.9c1.3,1.1,2.8,2,4.5,2.8
		c-1.3,0.4-2.7,0.7-4.2,1l0.2,1.3c2.2-0.4,4.1-0.9,5.9-1.5c1.8,0.6,3.7,1.1,5.9,1.5l0.2-1.3c-1.5-0.3-2.9-0.6-4.2-1
		c1.7-0.8,3.2-1.7,4.5-2.8c0.7,0.6,1.5,0.9,2.3,0.9c3,0,5.8-4,5.8-4c-1.3-0.5-2.5-0.7-3.5-0.7C27.4,21.5,26.9,21.6,26.5,21.7z
		 M29.1,11.2c0.1-0.3,0.4-0.7,0.7-0.9c-0.1,0.7-0.3,1.3-0.6,1.6c-0.1,0.1-0.1,0.2-0.3,0.2C28.9,11.8,29,11.5,29.1,11.2z M30.7,16.7
		c0,0.1-0.1,0.1-0.1,0.2c-0.3,0.5-0.7,0.9-1.1,1.2c-0.4,0.3-0.7,0.4-1,0.4c-0.1,0-0.1,0-0.2,0c0.1-0.2,0.2-0.4,0.3-0.6
		C29,17.3,29.7,16.8,30.7,16.7z M26.2,6.6c-0.2-0.2-0.3-0.5-0.4-0.8c0.5,0.4,0.8,0.8,0.9,1.1V7C26.5,7,26.3,6.8,26.2,6.6z M27,14.6
		c-0.4-0.2-0.8-0.6-1.1-0.9c-0.3-0.5-0.5-1.1-0.6-1.8c0.9,0.7,1.5,1.4,1.7,2.1C27.1,14.1,27.1,14.3,27,14.6z M19.2,24.7
		c0.1-0.7,0.5-1.3,1.1-1.9c0.1,1,0.1,2.2-0.4,2.9c-0.2,0.3-0.4,0.4-0.6,0.5C19.1,25.8,19,25.3,19.2,24.7z M13.2,23
		c0.6,0.5,1,1.1,1.2,1.8c0.2,0.5,0.2,1,0.1,1.6c-0.2-0.1-0.5-0.2-0.7-0.5C13.3,25.2,13.1,24,13.2,23z M4.8,11.8
		c-0.3-0.3-0.5-0.9-0.6-1.6c0.3,0.3,0.5,0.6,0.7,0.9C5,11.4,5.1,11.7,5.1,12C5,12,4.9,11.9,4.8,11.8z M7,13.9
		c0.2-0.6,0.7-1.4,1.7-2.1c-0.1,0.7-0.3,1.3-0.6,1.8C7.8,14,7.5,14.3,7,14.5C6.9,14.3,6.9,14.1,7,13.9z M7.3,7
		c0.1-0.4,0.4-0.7,0.9-1.1c0,0.3-0.2,0.5-0.4,0.7C7.7,6.8,7.5,7,7.3,7L7.3,7z M5.6,18.5c-0.3,0-0.7-0.1-1-0.4
		c-0.4-0.3-0.7-0.7-1.1-1.2c0-0.1-0.1-0.1-0.1-0.2c0.9,0.2,1.6,0.6,2.1,1.2c0.1,0.2,0.2,0.4,0.3,0.6C5.7,18.5,5.6,18.5,5.6,18.5z
		 M9.7,18.2L9.7,18.2c0.4,0.7,0.5,1.4,0.4,2.1c-0.1,0.5-0.3,1-0.6,1.5c-0.3-0.3-0.4-0.5-0.4-0.7C8.9,20.3,9.1,19.3,9.7,18.2z
		 M8.4,24.9c-0.9,0-1.9-0.6-3.1-1.6c-0.1-0.1-0.3-0.2-0.4-0.4c0.4-0.1,0.8-0.1,1.1-0.1l0,0c1.2,0,2.2,0.4,3,1.2
		c0.2,0.2,0.3,0.4,0.5,0.6C9.1,24.8,8.7,24.9,8.4,24.9z M24.3,18.1L24.3,18.1c0.6,1.2,0.8,2.2,0.6,2.9c0,0.2-0.1,0.5-0.4,0.7
		c-0.3-0.5-0.5-0.9-0.6-1.5S24,18.9,24.3,18.1z M28.7,23.3c-0.5,0.5-1.1,0.9-1.6,1.2C26.5,24.8,26,25,25.6,25s-0.8-0.1-1.1-0.3
		c0.1-0.2,0.3-0.4,0.5-0.6c0.8-0.8,1.8-1.2,3-1.2c0.4,0,0.7,0,1.1,0.1C29,23,28.9,23.2,28.7,23.3z" />
            </g>
            <g
                id="video_preview"
                class="st0">
                <circle
                    class="st26"
                    cx="17"
                    cy="17.4"
                    r="12.1" />
                <g
                    id="watch_video_1_"
                    class="st1">
                    <g>
                        <path
                            class="st2"
                            d="M16.9,30.1C9.8,30.1,4,24.3,4,17.2S9.8,4.3,16.9,4.3s12.9,5.8,12.9,12.9C29.8,24.4,24,30.1,16.9,30.1z
				 M16.9,5.4c-6.5,0-11.8,5.3-11.8,11.9S10.4,29.2,17,29.2s11.9-5.3,11.9-11.9S23.5,5.4,16.9,5.4z" />
                    </g>
                    <g>
                        <polygon
                            class="st2"
                            points="23,17.3 18.3,20 13.6,22.7 13.6,17.3 13.6,11.9 18.3,14.6 			" />
                    </g>
                </g>
            </g>
            <g
                id="win"
                class="st0">
                <g class="st1">
                    <path
                        class="st27"
                        d="M4.7,17L4.7,17C4.7,17.1,4.7,17,4.7,17z" />
                    <path
                        class="st27"
                        d="M7.9,5.7C7.9,5.8,7.9,5.8,7.9,5.7C7.9,5.8,7.9,5.8,7.9,5.7C7.9,5.8,7.9,5.8,7.9,5.7z" />
                    <path
                        class="st27"
                        d="M5.4,15.6c1.2-0.5,2.4-0.9,3.8-1.1c0.5-0.1,1-0.1,1.5-0.1c1.6,0.1,2.7,0.5,3.8,1.1c0.3,0.2,0.7,0.4,1,0.6
			l0,0c0.1,0,0.2,0,0.3-0.1c0.1,0,0.1-0.2,0.1-0.3c0.8-2.9,1.7-5.8,2.5-8.7c0-0.2,0.2-0.5,0.2-0.6s-0.2-0.2-0.2-0.2
			c-1.3-0.9-2.7-1.6-4.8-1.7c-1.2-0.1-2.2,0.1-3.1,0.4C9.6,5.1,8.7,5.4,7.9,5.7c0,0,0,0.1-0.1,0.1C7,8.8,6.1,12,5.2,15.1
			c0,0.1-0.1,0.2-0.1,0.3C5.2,15.5,5.3,15.5,5.4,15.6z" />
                    <path
                        class="st27"
                        d="M15.4,17.6c0-0.1-0.2-0.1-0.2-0.2c-1.3-0.9-2.7-1.6-4.8-1.7c-0.6,0-1.1,0-1.6,0.1C7.3,16,6,16.5,4.8,17l0,0
			c-0.9,3.1-1.8,6.2-2.7,9.3v0.1v0.1l0,0l0,0c0,0.1,0.1,0.1,0.1,0.1c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.2-0.1,0.3-0.1
			c0.5-0.1,1.3-0.4,2-0.6c0.9-0.2,1.8-0.4,2.9-0.3c1.9,0.1,3.2,0.8,4.5,1.6c0.1,0,0.2,0.1,0.3,0.1s0.2-0.1,0.2-0.2
			c0.1-0.1,0.1-0.5,0.2-0.6c0.9-2.9,1.7-5.8,2.6-8.8C15.4,17.8,15.4,17.7,15.4,17.6z" />
                    <path
                        class="st27"
                        d="M31.1,8.2C31,8.1,30.9,8,30.9,8h-0.2c-0.8,0.4-1.7,0.6-2.6,0.9c-0.9,0.2-1.9,0.4-3.1,0.3
			c-1.9-0.1-3.3-0.8-4.5-1.6c-0.1-0.1-0.4-0.3-0.5-0.3s-0.3,0.2-0.3,0.2c0,0.1,0,0.2-0.1,0.3c-0.8,2.9-1.7,5.8-2.5,8.7
			c0,0.1-0.2,0.5-0.1,0.6c0,0.1,0.2,0.2,0.2,0.2c0.1,0.1,0.2,0.1,0.3,0.2c1.3,0.8,2.8,1.6,4.8,1.7c1.2,0.1,2.3-0.1,3.4-0.3
			c0.9-0.2,1.7-0.5,2.4-0.8c0.1-0.1,0.3-0.1,0.3-0.2s0.1-0.2,0.1-0.3c0.9-3,1.7-6,2.6-8.9c0-0.1,0.1-0.2,0.1-0.3L31.1,8.2z" />
                    <path
                        class="st27"
                        d="M27.5,19.3C27.5,19.3,27.5,19.4,27.5,19.3c-0.3,0-0.5,0.1-0.7,0.2c-1.5,0.5-3.1,0.9-5.1,0.8
			c-1-0.1-1.9-0.3-2.7-0.6c-0.7-0.3-1.4-0.7-2-1.1h-0.1l0,0v0.1c-0.1-0.1,0,0,0-0.1s-0.2,0-0.2,0c-0.1,0.1-0.2,0.1-0.2,0.2
			s-0.1,0.2-0.1,0.3c-0.9,3-1.7,5.9-2.6,8.9c0,0.1-0.1,0.2-0.1,0.3c0,0.1,0.2,0.2,0.3,0.2c1.5,1,3.3,1.8,5.8,1.8l0,0h0.1
			c2,0,3.6-0.5,5.1-1.1c0.1,0,0.3-0.1,0.3-0.2c0.9-3,1.7-6,2.6-9c0-0.1,0-0.2,0.1-0.3C27.9,19.6,27.6,19.4,27.5,19.3z" />
                </g>
            </g>
            <g
                id="mac"
                class="st0">
                <g class="st1">
                    <path
                        class="st27"
                        d="M20.8,8.2c0.9-1.1,1.7-2.5,1.5-4.7l0,0c-0.2,0-0.5,0.1-0.7,0.1c-1.5,0.3-2.6,1.1-3.4,2
			c-0.9,1-1.8,2.5-1.5,4.5C18.6,10.2,19.8,9.3,20.8,8.2z" />
                    <path
                        class="st27"
                        d="M28.6,23.5c-1-0.5-1.8-1.1-2.5-1.9s-1.2-1.8-1.3-3.2c-0.1-1.5,0.3-2.7,0.9-3.6c0.6-0.9,1.4-1.6,2.2-2.2
			c-1.1-1.4-2.7-2.5-5-2.7c-0.8-0.1-1.7,0-2.4,0.1c-0.7,0.1-1.3,0.4-1.9,0.6c-0.3,0.1-0.6,0.2-1,0.3s-0.8,0.1-1.1,0
			c-0.7-0.2-1.2-0.5-1.9-0.7c-0.7-0.3-1.7-0.4-2.7-0.3c-2.3,0.2-3.8,1-4.9,2.3c-0.6,0.7-1.1,1.5-1.4,2.4S5,16.6,5,17.9
			c0,2.5,0.5,4.6,1.3,6.4c0.4,0.9,0.8,1.7,1.3,2.6c0.5,0.8,1,1.6,1.6,2.2c0.6,0.7,1.3,1.3,2.2,1.6c0.2,0.1,0.5,0.1,0.8,0.2
			c1,0.1,1.7-0.2,2.4-0.5c0.5-0.2,0.9-0.4,1.5-0.5c0.5-0.1,1.1-0.2,1.8-0.1c0.6,0.1,1.1,0.2,1.5,0.4c0.5,0.2,0.9,0.4,1.4,0.5
			s1.1,0.3,1.7,0.2c0.5-0.1,1-0.3,1.4-0.6c0.8-0.5,1.4-1.2,2-1.9C27,27.1,27.9,25.5,28.6,23.5C28.6,23.6,28.6,23.5,28.6,23.5z" />
                </g>
            </g>
            <g
                id="star"
                class="st0">
                <polygon
                    class="st28"
                    points="17,2.8 21.7,12.2 32.1,13.7 24.5,21.1 26.3,31.4 17,26.5 7.7,31.4 9.5,21.1 1.9,13.7 12.3,12.2 	" />
            </g>
            <g
                id="da_point"
                class="st0">
                <g class="st1">
                    <g>
                        <path
                            class="st2"
                            d="M21.748,10.464c0,0.363-0.589,0.992-2.248,1.572c-1.808,0.631-4.24,0.979-6.848,0.979
				s-5.04-0.348-6.848-0.979c-1.659-0.579-2.248-1.209-2.248-1.572V9.499C3.93,9.68,4.342,9.85,4.79,10.007
				c2.121,0.741,4.914,1.149,7.862,1.149s5.741-0.408,7.862-1.149c0.448-0.157,0.86-0.326,1.234-0.508V10.464L21.748,10.464z" />
                    </g>
                    <g>
                        <path
                            class="st2"
                            d="M4.79,14.029c2.121,0.741,4.914,1.149,7.862,1.149s5.741-0.408,7.862-1.149
				c0.448-0.157,0.86-0.326,1.234-0.508v0.965c0,0.363-0.589,0.992-2.248,1.572c-1.808,0.631-4.24,0.979-6.848,0.979
				s-5.04-0.348-6.848-0.979c-1.659-0.58-2.248-1.209-2.248-1.572v-0.965C3.93,13.703,4.342,13.873,4.79,14.029z" />
                    </g>
                    <g>
                        <path
                            class="st2"
                            d="M16.347,18.957c-1.179,0.149-2.413,0.244-3.695,0.244c-2.949,0-5.741-0.408-7.862-1.149
				c-0.448-0.157-0.86-0.326-1.234-0.508v0.965c0,0.363,0.589,0.992,2.248,1.572c1.808,0.631,4.24,0.979,6.848,0.979
				c0.904,0,1.764-0.063,2.601-0.149C15.484,20.187,15.83,19.539,16.347,18.957z" />
                    </g>
                    <g>
                        <path
                            class="st2"
                            d="M15.014,23.121c-0.77,0.061-1.556,0.102-2.362,0.102c-2.949,0-5.741-0.408-7.862-1.149
				c-0.448-0.157-0.86-0.326-1.234-0.508v0.965c0,0.363,0.589,0.992,2.248,1.572c1.808,0.631,4.24,0.979,6.848,0.979
				c0.758,0,1.697-0.062,2.41-0.123C15.054,24.896,14.978,23.68,15.014,23.121z" />
                    </g>
                    <g>
                        <path
                            class="st2"
                            d="M12.667,9.62c-2.449,0-4.743-0.311-6.46-0.875c-1.675-0.55-2.56-1.261-2.56-2.057S4.531,5.18,6.206,4.63
				L6.44,5.343L6.206,4.63c1.717-0.564,4.012-0.875,6.46-0.875c2.449,0,4.744,0.311,6.461,0.875c1.675,0.55,2.56,1.261,2.56,2.057
				s-0.885,1.507-2.56,2.057C17.41,9.309,15.116,9.62,12.667,9.62z M5.297,6.688C5.517,6.846,5.942,7.08,6.674,7.32
				c1.571,0.516,3.699,0.8,5.993,0.8s4.422-0.284,5.993-0.8c0.733-0.241,1.157-0.474,1.377-0.632
				c-0.22-0.158-0.644-0.392-1.377-0.632c-1.57-0.516-3.698-0.8-5.993-0.8c-2.294,0-4.422,0.284-5.993,0.8l0,0
				C5.941,6.296,5.517,6.529,5.297,6.688z" />
                    </g>
                    <g>
                        <g>
                            <path
                                class="st2"
                                d="M22.549,24.66v2.954h-1.301v-7.791h3.045c0.878,0,1.556,0.219,2.033,0.655
					c0.479,0.438,0.718,1.024,0.718,1.764c0,0.745-0.239,1.335-0.718,1.769c-0.478,0.433-1.155,0.649-2.033,0.649
					C24.293,24.66,22.549,24.66,22.549,24.66z M22.549,23.617h1.744c0.492,0,0.857-0.127,1.095-0.38
					c0.237-0.254,0.355-0.582,0.355-0.985c0-0.402-0.118-0.734-0.355-0.995c-0.237-0.26-0.603-0.391-1.095-0.391h-1.744V23.617z" />
                        </g>
                        <g>
                            <path
                                class="st2"
                                d="M23.66,30.219c-0.007,0-0.015,0-0.021,0c-3.781-0.011-6.857-3.088-6.857-6.859
					c0-3.782,3.077-6.859,6.859-6.859S30.5,19.578,30.5,23.36c0,1.83-0.719,3.555-2.024,4.855
					C27.179,29.508,25.47,30.219,23.66,30.219z M23.641,18c-2.955,0-5.359,2.404-5.359,5.359c0,2.946,2.405,5.351,5.361,5.359
					c1.442,0.024,2.757-0.552,3.774-1.565C28.438,26.136,29,24.788,29,23.359C29,20.404,26.596,18,23.641,18z" />
                        </g>
                    </g>
                </g>
            </g>
            <g
                id="Inventory_List"
                class="st0">
                <g
                    id="Inventory_List"
                    class="st1">
                    <g>
                        <path
                            class="st2"
                            d="M32.6,28.9H1.5V5.2h31.1V28.9z M3,27.4h28.1V6.7H3V27.4z" />
                    </g>
                    <g>
                        <rect
                            x="13.9"
                            y="12.9"
                            class="st2"
                            width="13.1"
                            height="1.5" />
                    </g>
                    <g>
                        <rect
                            x="13.9"
                            y="20.3"
                            class="st2"
                            width="13.1"
                            height="1.5" />
                    </g>
                    <g>
                        <polygon
                            class="st2"
                            points="7.7,15.9 5.6,12.5 6.9,11.7 7.8,13.2 10.1,10.2 11.3,11.2 			" />
                    </g>
                    <g>
                        <polygon
                            class="st2"
                            points="7.7,23.7 5.6,20.3 6.9,19.6 7.8,21 10.1,18.1 11.3,19 			" />
                    </g>
                </g>
            </g>
            <g
                id="Transaction_History"
                class="st0">
                <g
                    id="Transaction_History"
                    class="st1">
                    <g>
                        <path
                            class="st2"
                            d="M32.6,28.9H1.5V5.2h31.1V28.9z M3,27.4h28.1V6.7H3V27.4z" />
                    </g>
                    <g>
                        <rect
                            x="17.2"
                            y="13.9"
                            class="st2"
                            width="11.1"
                            height="1.5" />
                    </g>
                    <g>
                        <rect
                            x="17.2"
                            y="19.8"
                            class="st2"
                            width="11.1"
                            height="1.5" />
                    </g>
                    <g>
                        <path
                            class="st2"
                            d="M14.5,19.2c0,0.9-0.3,1.7-0.9,2.2c-0.6,0.5-1.6,0.8-2.8,0.8v1.4H10v-1.3c-1.1,0-2-0.3-2.6-0.8
				c-0.6-0.5-1-1.2-1.2-2.2l2-0.4c0.1,0.6,0.3,1,0.6,1.3s0.7,0.4,1.2,0.5v-3c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.1,0
				c-0.8-0.2-1.5-0.4-1.9-0.7c-0.4-0.3-0.8-0.6-1-1S6.5,15,6.5,14.4c0-0.9,0.3-1.5,0.9-2C8,12,8.8,11.7,10,11.7v-1h0.8v1
				c0.7,0,1.2,0.1,1.7,0.3s0.8,0.5,1.1,0.8c0.3,0.4,0.5,0.9,0.7,1.6l-2,0.3c-0.1-0.4-0.2-0.8-0.5-1s-0.5-0.4-1-0.5v2.7l0.1,0
				c0.1,0,0.6,0.1,1.4,0.4c0.8,0.2,1.3,0.6,1.7,1.1C14.3,17.9,14.5,18.5,14.5,19.2z M10,13.2c-1,0.1-1.4,0.5-1.4,1.2
				c0,0.2,0,0.4,0.1,0.6c0.1,0.1,0.2,0.3,0.3,0.4c0.2,0.1,0.5,0.2,1,0.4V13.2z M12.5,19.2c0-0.3,0-0.5-0.1-0.6
				c-0.1-0.2-0.2-0.3-0.4-0.4s-0.6-0.2-1.2-0.4v2.8C11.9,20.6,12.5,20.1,12.5,19.2z" />
                    </g>
                </g>
            </g>
            <g
                id="Management_Backend"
                class="st0">
                <g class="st1">
                    <g>
                        <path
                            class="st29"
                            d="M18.6,31.3h-3c-0.9,0-1.2-0.5-2.6-3.9l-0.7-0.3c-3.1,1.4-3.5,1.4-3.7,1.4c-0.3,0-0.7-0.1-0.9-0.4L5.6,26
				c-0.7-0.7-0.5-1.2,1-4.6l-0.3-0.6c-3.5-1.3-4-1.5-4-2.5v-2.9c0-1,0.5-1.2,4-2.6l0.3-0.6C5,8.8,4.8,8.2,5.5,7.5l2.1-2.1
				c0.2-0.2,0.6-0.4,0.9-0.4c0.3,0,0.9,0.1,3.8,1.3L13,6.1c1.3-3.4,1.6-4,2.5-4h3c0.9,0,1.2,0.5,2.6,3.9l0.7,0.3
				C24.9,5,25.3,5,25.6,5c0.3,0,0.7,0.1,0.9,0.4l2.1,2.1c0.7,0.7,0.5,1.3-1,4.6l0.3,0.6c3.5,1.2,4,1.5,4,2.5v2.9c0,1-0.5,1.2-4,2.6
				l-0.3,0.6c1.6,3.3,1.8,3.9,1.1,4.6L26.5,28c-0.2,0.2-0.6,0.4-0.9,0.4c-0.2,0-0.6,0-3.8-1.3l-0.7,0.3
				C19.9,30.7,19.6,31.3,18.6,31.3z M15.8,29.8h2.8c0.3-0.5,1.1-2.5,1.3-3.2l0.2-0.4l1.9-0.8l0.4,0.2c2.3,1,3.1,1.2,3.3,1.3l1.9-1.9
				c-0.2-0.6-1-2.5-1.4-3.1L26,21.4l0.8-1.8l0.4-0.2c0.8-0.3,2.7-1.1,3.2-1.4v-2.7c-0.5-0.3-2.5-1-3.2-1.3l-0.4-0.2L26,12l0.2-0.4
				c0.3-0.7,1.2-2.6,1.3-3.2l-1.9-1.9c-0.2,0.1-0.9,0.3-3.2,1.3L21.9,8L20,7.3l-0.2-0.4c-0.3-0.7-1.1-2.7-1.4-3.2h-2.7
				c-0.3,0.5-1.1,2.5-1.3,3.2l-0.2,0.4L12.3,8l-0.4-0.2c-2.3-1-3.1-1.2-3.3-1.3L6.6,8.5c0.2,0.6,1,2.5,1.4,3.1l0.2,0.4l-0.8,1.9
				L7,14.1c-0.8,0.3-2.7,1-3.2,1.4l0,2.7c0.5,0.3,2.5,1,3.2,1.3l0.4,0.2l0.8,1.8L8,21.8c-0.3,0.7-1.2,2.6-1.3,3.2l1.9,1.9
				c0.2-0.1,0.9-0.3,3.2-1.3l0.4-0.2l1.9,0.8l0.2,0.4C14.7,27.4,15.4,29.3,15.8,29.8z M8.7,6.5L8.7,6.5C8.7,6.5,8.7,6.5,8.7,6.5z
				 M25.4,6.4C25.4,6.4,25.4,6.4,25.4,6.4L25.4,6.4z M17.1,22.2c-3.1,0-5.6-2.5-5.6-5.5c0-3,2.5-5.5,5.6-5.5c3.1,0,5.6,2.5,5.6,5.5
				C22.7,19.8,20.2,22.2,17.1,22.2z M17.1,12.7c-2.3,0-4.1,1.8-4.1,4c0,2.2,1.8,4,4.1,4c2.3,0,4.1-1.8,4.1-4
				C21.2,14.5,19.3,12.7,17.1,12.7z" />
                    </g>
                </g>
            </g>
            <g
                id="my_store"
                class="st0">
                <g class="st1">
                    <polygon
                        class="st2"
                        points="18.3,15.4 1.3,15.4 1.3,2.4 29.8,2.4 29.8,8.1 28.3,8.1 28.3,3.9 2.8,3.9 2.8,13.9 18.3,13.9 		" />
                </g>
                <g class="st1">
                    <polygon
                        class="st2"
                        points="17.2,31.8 3.1,31.8 3.1,14.8 4.6,14.8 4.6,30.3 17.2,30.3 		" />
                </g>
                <g class="st1">
                    <path
                        class="st2"
                        d="M25.5,19.9c-2.9,0-5.3-2.4-5.3-5.3c0-2.9,2.4-5.3,5.3-5.3s5.3,2.4,5.3,5.3C30.9,17.5,28.5,19.9,25.5,19.9z
			 M25.5,10.8c-2.1,0-3.8,1.7-3.8,3.8s1.7,3.8,3.8,3.8s3.8-1.7,3.8-3.8S27.6,10.8,25.5,10.8z" />
                </g>
                <g class="st1">
                    <path
                        class="st2"
                        d="M32.7,31.6H18.4l0-4.2c0.4-3.4,3.4-5.9,7.1-5.9c3.6,0,6.7,2.5,7.1,5.8l0,0.1l0,1.5V31.6z M19.9,30.1h11.3
			l0-2.7c-0.3-2.6-2.7-4.5-5.6-4.5c-2.9,0-5.3,1.9-5.6,4.5L19.9,30.1z" />
                </g>
                <g class="st1">
                    <path
                        class="st2"
                        d="M14.5,31.3H7.3V19.8h7.2V31.3z M8.8,29.8H13v-8.5H8.8V29.8z" />
                </g>
            </g>
            <path
                id="fb"
                class="st30"
                d="M25.8,5.7h-3.1c-2.4,0-2.9,1.1-2.9,2.9v3.9h5.9L25,18.4h-5.2v15.3h-6.1V18.4H8.5v-5.9h5.2V8.1
	c0-5.2,3.1-7.9,7.7-7.9c2.2,0,4,0.2,4.6,0.2L25.8,5.7L25.8,5.7z" />
            <path
                id="twitter"
                class="st30"
                d="M33.7,6.9c-1.3,0.5-2.5,0.9-4,1.1c1.4-0.9,2.5-2.2,3.1-3.8c-1.3,0.7-2.7,1.3-4.3,1.6
	c-1.3-1.3-3.1-2.2-5.1-2.2c-3.8,0-6.9,3.1-6.9,6.9c0,0.5,0,1.1,0.2,1.6C11.1,11.8,6.1,9,2.8,4.9C2.1,5.8,1.7,7.1,1.7,8.3
	c0,2.3,1.3,4.5,3.1,5.8c-1.1,0-2.2-0.4-3.1-0.9l0,0c0,3.3,2.3,6.1,5.4,6.7c-0.5,0.2-1.3,0.2-1.8,0.2c-0.4,0-0.9,0-1.3-0.2
	c0.9,2.7,3.4,4.7,6.3,4.7c-2.3,1.8-5.2,2.9-8.5,2.9c-0.5,0-1.1,0-1.6-0.2c3.1,2,6.7,3.1,10.5,3.1c12.7,0,19.5-10.5,19.5-19.5
	c0-0.4,0-0.5,0-0.9C31.7,9.4,32.8,8.1,33.7,6.9z" />
            <g
                id="linkedin"
                class="st0">
                <g class="st1">
                    <path
                        class="st31"
                        d="M1.7,12.1h6.4v20.7H1.7V12.1z M4.9,1.8c2.1,0,3.7,1.7,3.7,3.7c0,2.1-1.7,3.7-3.7,3.7c-2.1,0-3.7-1.7-3.7-3.7
			C1.2,3.5,2.9,1.8,4.9,1.8" />
                </g>
                <g class="st1">
                    <path
                        class="st31"
                        d="M12.2,12.1h6.2v2.8h0.1c0.9-1.6,3-3.3,6.1-3.3c6.5,0,7.7,4.3,7.7,9.9v11.4h-6.4V22.7c0-2.4,0-5.5-3.3-5.5
			c-3.4,0-3.9,2.6-3.9,5.3v10.2h-6.4V12.1z" />
                </g>
            </g>
            <g
                id="pinterest"
                class="st0">
                <g class="st1">
                    <path
                        class="st31"
                        d="M29.7,12.1c0-7.7-6.3-11.7-12.1-11.7c-6.1,0-13.1,4-13.1,11.8c0,8.2,3.7,7.4,4.5,6.8
			c0.7-0.6,0.8-2.7-0.7-2.9c-0.2-0.6-0.4-2.1-0.4-2.9c0-1.9,1.4-9.2,9.5-9.2c6.1,0,8,5.4,8,8.1c0,1.9-0.8,9-5.8,9
			c-3.1,0-3.9-2.1-3.7-4c0.2-1.9,0.3-2.6,0.3-2.6s2.2-0.7,2.2-3.4c0-2.4-2-2.9-3.5-2.9c-1,0-2.8,0.7-2.8,4.1c0,1.5,0.5,2.8,0.1,6.4
			C9.7,29.1,9.7,32.8,9.7,33.5c0,0,0.1,0,0.1,0c0.6-1.2,5-9.3,5-11.7c0,0,1.7,2.6,4.8,2.6C24.7,24.4,29.7,19,29.7,12.1z" />
                </g>
            </g>
            <g
                id="google"
                class="st0">
                <path
                    class="st32"
                    d="M8.6,26.9c3.6,1.2,8.1,0.3,10.5-2.8c1.8-2.2,2.2-5.1,2-7.8c-3.1,0-6.2,0-9.3,0c0,1.1,0,2.2,0,3.3
		c1.9,0.1,3.7,0,5.6,0.1c-0.5,1.6-1.5,3.1-3.2,3.7C11,24.7,7,22.9,6.1,19.7c-1.2-3.2,0.8-7,4-7.9c2-0.7,4.1,0.1,5.8,1.1
		c0.9-0.8,1.7-1.7,2.5-2.6c-1.9-1.6-4.4-2.6-7-2.4C6.2,8,1.8,12.6,2,17.6C1.9,21.7,4.7,25.6,8.6,26.9z" />
                <path
                    class="st32"
                    d="M26.4,21.8c0.9,0,1.8,0,2.8,0c0-0.9,0-1.9,0-2.8H32v-2.8l-2.8,0c0-0.9,0-1.9,0-2.8l-2.8,0c0,0.9,0,1.9,0,2.8
		l-2.8,0V19l2.8,0C26.4,20,26.4,20.9,26.4,21.8z" />
            </g>
            <g id="Private_Message">
                <g>
                    <g>
                        <path
                            class="st2"
                            d="M33.3,27.9H17.8V18h15.4V27.9z M19.3,26.4h12.4v-6.9H19.3V26.4z" />
                    </g>
                    <g>
                        <path
                            class="st2"
                            d="M25.9,24.9h-0.8c-0.4,0-0.7-0.3-0.7-0.7v-2.4c0-0.4,0.3-0.7,0.7-0.7h0.8c0.4,0,0.7,0.3,0.7,0.7v2.4
				C26.6,24.6,26.3,24.9,25.9,24.9z" />
                    </g>
                    <g>
                        <path
                            class="st2"
                            d="M29.6,18.6l-1.5-0.1c0,0,0.1-1.3-0.1-3.3c-0.2-1.5-1.6-1.8-2-1.8c-1.1-0.1-2.4,0.3-2.9,1.6
				c-0.2,0.5-0.2,2.7-0.1,3.3l-1.5,0.3c-0.1-0.7-0.1-3.2,0.2-4.1c0.6-1.8,2.5-2.8,4.5-2.6c1.8,0.2,3.1,1.5,3.3,3.2
				C29.6,17.2,29.6,18.6,29.6,18.6z" />
                    </g>
                </g>
                <g>
                    <g>
                        <path
                            class="st2"
                            d="M3.6,29.9H1.7l1.4-1.3c1-1,1.7-2.9,1.8-5.6c-2.6-2.4-4.1-5.4-4.1-8.6c0-7.1,7.3-12.9,16.3-12.9
				c9,0,16.3,5.8,16.3,12.9h-1.5C31.9,8.1,25.2,3,17.1,3C8.9,3,2.3,8.1,2.3,14.4c0,2.9,1.4,5.6,3.9,7.7l0.3,0.2l0,0.4
				c-0.1,1.7-0.4,3.8-1.2,5.5c2.3-0.5,4.5-2,5.7-3l0.3-0.2l0.4,0.1c1.6,0.5,2.3,0.7,4.1,0.7l0,1.5c-1.9,0-2.7-0.2-4.2-0.7
				C9.5,28.1,6.6,29.9,3.6,29.9z" />
                    </g>
                </g>
            </g>
            <g
                id="reply"
                class="st0">
                <g class="st1">
                    <g>
                        <path
                            class="st2"
                            d="M3.6,30.9H1.7l1.4-1.3c1-1,1.7-2.9,1.8-5.6c-2.6-2.4-4.1-5.4-4.1-8.6c0-7.1,7.3-12.9,16.3-12.9
				c9,0,16.3,5.8,16.3,12.9c0,7.1-7.3,13-16.3,13c-1.9,0-3.8-0.3-5.6-0.8C9.5,29.1,6.6,30.9,3.6,30.9z M17.1,4
				C8.9,4,2.3,9.1,2.3,15.4c0,2.9,1.4,5.6,3.9,7.7l0.3,0.2l0,0.4c-0.1,1.7-0.4,3.8-1.2,5.5c2.3-0.5,4.5-2,5.7-3l0.3-0.2l0.4,0.1
				c1.7,0.5,3.6,0.8,5.5,0.8c8.1,0,14.8-5.1,14.8-11.5C31.9,9.1,25.2,4,17.1,4z" />
                    </g>
                </g>
            </g>
            <g
                id="report"
                class="st0">
                <g class="st1">
                    <path
                        d="M13.2,20.6c-3.5,0-6.8-1-7.1-1l-0.5-0.2V2.5l1,0.3c0.1,0,7.4,2.1,11.2,0.1l0,0c4.4-2.4,10.1-0.1,10.4,0L28.6,3v17l-1-0.4
			c-0.1,0-5.3-2.1-9.1,0C16.9,20.3,15,20.6,13.2,20.6z M7.1,18.3c1.8,0.4,7.4,1.6,10.7-0.1c3.4-1.8,7.5-0.9,9.3-0.4V4
			c-1.4-0.4-5.5-1.5-8.6,0.1l0,0C14.9,6,9.3,5,7.1,4.5V18.3z" />
                </g>
                <g class="st1">
                    <rect
                        x="5.6"
                        y="2.2"
                        width="1.5"
                        height="30.5" />
                </g>
            </g>
            <g
                id="report_hover"
                class="st0">
                <path
                    class="st1"
                    d="M27.661,2.617c-0.24-0.096-5.919-2.32-10.36,0.034C14.042,4.381,8.37,3.17,6.625,2.735V1.901h-1.5v0.412V19.24
		v13.135h1.5V19.646c1.274,0.302,3.638,0.77,6.094,0.77c1.856,0,3.763-0.268,5.285-1.076c3.818-2.023,9.049,0.014,9.102,0.034
		l1.027,0.409V2.806L27.661,2.617z" />
            </g>
            <g id="point">
                <g>
                    <path
                        class="st8"
                        d="M14.9,19.8v6.7h-2.9V8.8h6.9c2,0,3.5,0.5,4.6,1.5c1.1,1,1.6,2.3,1.6,4c0,1.7-0.5,3-1.6,4
			c-1.1,1-2.6,1.5-4.6,1.5H14.9z M14.9,17.4h3.9c1.1,0,1.9-0.3,2.5-0.9c0.5-0.6,0.8-1.3,0.8-2.2c0-0.9-0.3-1.7-0.8-2.3
			s-1.4-0.9-2.5-0.9h-3.9V17.4z" />
                </g>
                <g>
                    <path
                        class="st8"
                        d="M17.4,3C25,3,31.2,9.2,31.2,16.8c0,7.6-6.3,13.8-13.8,13.8c0,0,0,0,0,0c-7.6,0-13.8-6.2-13.8-13.8
			S9.7,3,17.4,3 M17.4,1.5C8.9,1.5,2,8.4,2,16.8c0,8.4,6.9,15.3,15.3,15.3c8.5,0,15.3-6.9,15.3-15.3C32.7,8.4,25.8,1.5,17.4,1.5
			L17.4,1.5z" />
                </g>
            </g>
            <g
                id="arrow_up"
                class="st0">
                <polygon
                    class="st1"
                    points="8.409,24.702 6.091,22.798 17.021,9.485 27.899,22.448 25.601,24.376 17.046,14.182 	" />
            </g>
            <g
                id="arrow_down"
                class="st0">
                <polygon
                    class="st1"
                    points="8.409,9.485 6.091,11.389 17.021,24.702 27.899,11.739 25.601,9.811 17.046,20.005 	" />
            </g>
            <g
                id="arrow_prev"
                class="st0">
                <polygon
                    class="st1"
                    points="22.006,28.701 8.693,17.771 21.656,6.893 23.584,9.19 13.39,17.746 23.91,26.383 	" />
            </g>
            <g
                id="arrow_next"
                class="st0">
                <polygon
                    class="st1"
                    points="10.597,28.701 23.91,17.771 10.947,6.893 9.019,9.19 19.213,17.746 8.693,26.383 	" />
            </g>
            <g
                id="elite"
                class="st0">
                <g class="st1">
                    <path
                        d="M16.6,22c-5.9,0-10.7-4.8-10.7-10.7S10.7,0.5,16.6,0.5s10.7,4.8,10.7,10.7S22.5,22,16.6,22z M16.6,2
			c-5.1,0-9.2,4.1-9.2,9.2s4.1,9.2,9.2,9.2s9.2-4.1,9.2-9.2S21.7,2,16.6,2z" />
                </g>
                <g class="st1">
                    <polygon points="11.9,33.3 9.1,26.7 2.4,29.1 7.7,16.9 9.1,17.5 5.1,26.5 9.9,24.8 11.9,29.5 15.6,20.8 17,21.4 		" />
                </g>
                <g class="st1">
                    <polygon
                        points="22.7,33.5 16.5,21.9 16.5,21.2 18,21.3 18,21.5 22.3,29.7 23.9,24.8 24.7,25 28.8,26.2 24.1,17.3 25.4,16.6
			31.8,28.5 24.9,26.6 		" />
                </g>
            </g>
            <g
                id="rl_icon"
                class="st0">
                <path
                    class="st1"
                    d="M30.9,16.5c2.5-2.3,1.6-4.6,1.6-4.6c-0.6,2.9-5.7,4.9-5.7,4.9c-8.8,2.9-16.1,0.9-16.1,0.9
		c-5.3-1.2-7.4-2.9-8.3-4.1c0.7-0.4,2-0.7,5-0.9c0,0,6.3-0.6,11.4,1.8c0,0,1.9,0.9,2.9,2.1c0,0,0.3,0.9,1.7,0.5c0,0,8.4-2.3,7.1-7.4
		c0,0-0.7,3.8-7.7,5.6c0,0-0.7,0.1-1.2-0.5c0,0-2.1-2.8-8.3-3.7c0,0-5.1-0.7-9,0c0,0-2.4,0.4-2.4,1.3l0,0v1.9
		c0.8,3.9,8.5,5.5,8.5,5.5C19,21.7,26.5,19,26.5,19c2-0.7,3.3-1.6,4.3-2.4c0.3,0.2,0.6,0.6,0.5,1.4c-0.3,1.4-3.6,4.5-14.6,4.9
		s-14.6-4-16-5.4c0.7,3.2,5,6.3,9.5,7c4,0.6,8.3,0.9,14-0.5s7.8-3.8,8.2-5.6C32.7,17.1,31.6,16.6,30.9,16.5z" />
            </g>
            <g id="logo_marketplace">
                <polygon
                    class="st8"
                    style="fill:#FFA003;"
                    points="201.3,16.6 187.9,16.6 186.4,10 188.1,9.6 189.3,14.9 200.1,14.9 202.8,7.3 185.9,7.3 184.7,3.2
		181.7,3.2 181.7,1.5 186,1.5 187.2,5.5 205.3,5.5 	" />
                <g>
                    <circle
                        class="st8"
                        style="fill:#FFA003;"
                        cx="190.2"
                        cy="19.7"
                        r="2.1" />
                    <path
                        class="st8"
                        style="fill:#FFA003;"
                        d="M190.2,18.9c0.4,0,0.8,0.4,0.8,0.8s-0.4,0.8-0.8,0.8c-0.4,0-0.8-0.4-0.8-0.8S189.7,18.9,190.2,18.9
			 M190.2,17.6c-1.2,0-2.1,0.9-2.1,2.1s0.9,2.1,2.1,2.1s2.1-0.9,2.1-2.1S191.4,17.6,190.2,17.6L190.2,17.6z" />
                </g>
                <g>
                    <circle
                        class="st8"
                        style="fill:#FFA003;"
                        cx="199"
                        cy="19.7"
                        r="2.1" />
                    <path
                        class="st8"
                        style="fill:#FFA003;"
                        d="M199,18.9c0.4,0,0.8,0.4,0.8,0.8s-0.4,0.8-0.8,0.8c-0.4,0-0.8-0.4-0.8-0.8S198.5,18.9,199,18.9 M199,17.6
			c-1.2,0-2.1,0.9-2.1,2.1s0.9,2.1,2.1,2.1s2.1-0.9,2.1-2.1S200.1,17.6,199,17.6L199,17.6z" />
                </g>
                <g>
                    <path
                        class="st10"
                        style="fill:#FFFFFF;"
                        d="M3.8,1.6h3.5l4.3,13l4.4-13h3.4l3.1,18.6h-3.4l-2-11.8l-4,11.8H10L6.1,8.5L4,20.3H0.6L3.8,1.6z" />
                    <path
                        class="st10"
                        style="fill:#FFFFFF;"
                        d="M31,1.6h3.6l7.2,18.6h-3.7l-1.5-3.8H29l-1.5,3.8h-3.7L31,1.6z M32.8,6.6L30.3,13h5L32.8,6.6z" />
                    <path
                        class="st10"
                        style="fill:#FFFFFF;"
                        d="M44.1,1.6h3.8c2.1,0,3.5,0.2,4.4,0.6s1.6,1,2.1,1.8c0.5,0.9,0.8,1.9,0.8,3c0,1.2-0.3,2.2-0.9,3.1
			c-0.6,0.8-1.5,1.4-2.7,1.9l4.4,8.3h-3.9l-4.2-7.9h-0.3v7.9h-3.5C44.1,20.3,44.1,1.6,44.1,1.6z M47.6,8.9h1.1
			c1.1,0,1.9-0.1,2.3-0.4c0.4-0.3,0.6-0.8,0.6-1.5c0-0.4-0.1-0.8-0.3-1.1c-0.2-0.3-0.5-0.5-0.8-0.6c-0.4-0.1-1-0.2-1.9-0.2h-1
			C47.6,5.1,47.6,8.9,47.6,8.9z" />
                    <path
                        class="st10"
                        style="fill:#FFFFFF;"
                        d="M58.9,1.6h3.6V8l5.1-6.4h4.3l-6.5,8.3l7.1,10.3h-4.2L62.5,12v8.3h-3.6V1.6z" />
                    <path
                        class="st10"
                        style="fill:#FFFFFF;"
                        d="M74.3,1.6h10.2v3.5h-6.6v3.4h6.6v3.4h-6.6v4.9h6.6v3.5H74.3V1.6z" />
                    <path
                        class="st10"
                        style="fill:#FFFFFF;"
                        d="M86.6,1.6h10.3v3.5h-3.4v15.1h-3.6V5.1h-3.3V1.6z" />
                </g>
                <g>
                    <path
                        class="st33"
                        style="fill:#D8D8D8;"
                        d="M99.9,1.6h3.7c2.1,0,3.6,0.1,4.3,0.3c1.1,0.3,1.9,0.8,2.6,1.6s1,1.8,1,3.1c0,1.2-0.3,2.3-1,3.1
			s-1.6,1.3-2.7,1.6c-0.8,0.2-2.4,0.3-4.7,0.3h-1.3v8.7h-1.9V1.6z M101.7,3.5v6.3h3.2c1.3,0,2.2-0.1,2.8-0.3
			c0.6-0.2,1.1-0.6,1.4-1.1s0.5-1.1,0.5-1.7s-0.2-1.2-0.5-1.7s-0.8-0.9-1.3-1.1c-0.6-0.2-1.5-0.3-2.7-0.3h-3.4V3.5z" />
                    <path
                        class="st33"
                        style="fill:#D8D8D8;"
                        d="M115.2,1.6h1.9v16.8h7.2v1.8h-9L115.2,1.6L115.2,1.6z" />
                    <path
                        class="st33"
                        style="fill:#D8D8D8;"
                        d="M134.8,1.6l8.7,18.6h-2l-2.9-6.1h-8l-2.9,6.1h-2.1l8.8-18.6C134.4,1.6,134.8,1.6,134.8,1.6z M134.6,5.6
			l-3.2,6.7h6.4L134.6,5.6z" />
                    <path
                        class="st33"
                        style="fill:#D8D8D8;"
                        d="M163,5.1l-1.5,1.1c-0.8-1.1-1.8-1.9-2.9-2.4c-1.1-0.5-2.4-0.8-3.7-0.8c-1.5,0-2.9,0.4-4.1,1.1
			c-1.3,0.7-2.2,1.7-2.9,2.9s-1,2.6-1,4.1c0,2.3,0.8,4.2,2.3,5.7c1.6,1.5,3.5,2.3,5.9,2.3c2.6,0,4.8-1,6.5-3.1l1.4,1
			c-0.9,1.2-2.1,2.1-3.5,2.7s-2.9,1-4.6,1c-3.3,0-5.8-1.1-7.7-3.3c-1.6-1.8-2.4-4-2.4-6.6c0-2.7,1-5,2.9-6.9s4.3-2.8,7.2-2.8
			c1.7,0,3.3,0.3,4.7,1C161,2.9,162.1,3.9,163,5.1z" />
                    <path
                        class="st33"
                        style="fill:#D8D8D8;"
                        d="M166.8,1.6h10.7v1.8h-8.8v5.8h8.7V11h-8.7v7.3h8.7v1.8h-10.6L166.8,1.6L166.8,1.6z" />
                </g>
            </g>
            <g
                id="Shopping_Guide"
                class="st0">
                <g
                    id="Shopping_Guide_1_"
                    class="st1">
                    <g>
                        <g>
                            <ellipse
                                class="st2"
                                cx="10.377"
                                cy="26.503"
                                rx="1.749"
                                ry="1.721" />
                        </g>
                    </g>
                    <g>
                        <polygon
                            class="st2"
                            points="16.375,23.288 8.819,23.288 6.855,15.207 8.313,14.853 9.999,21.788 16.375,21.788 			" />
                    </g>
                    <g>
                        <polygon
                            class="st2"
                            points="28.027,14.726 26.598,14.274 27.461,11.536 6.019,11.536 4.774,7.047 1.115,7.047 1.115,5.547
				5.915,5.547 7.159,10.036 29.508,10.036 			" />
                    </g>
                    <g>
                        <g>
                            <path
                                class="st29"
                                d="M25.815,29.003H24.49c-0.531,0-0.693-0.316-1.289-1.787l-0.177-0.071
					c-1.362,0.609-1.529,0.609-1.665,0.609c-0.192,0-0.386-0.079-0.518-0.211l-0.935-0.912c-0.396-0.399-0.257-0.755,0.37-2.177
					l-0.064-0.152c-1.454-0.522-1.838-0.685-1.838-1.246v-1.299c0-0.554,0.355-0.708,1.83-1.278l0.063-0.151
					c-0.635-1.342-0.805-1.757-0.404-2.155l0.942-0.919c0.13-0.128,0.323-0.206,0.514-0.206c0.122,0,0.306,0,1.686,0.577
					l0.175-0.071c0.547-1.454,0.716-1.795,1.254-1.795h1.325c0.53,0,0.692,0.316,1.288,1.786l0.177,0.071
					c1.359-0.609,1.528-0.609,1.665-0.609c0.194,0,0.39,0.081,0.521,0.216l0.93,0.906c0.399,0.396,0.245,0.788-0.368,2.18
					l0.063,0.151c1.444,0.517,1.839,0.676,1.839,1.244v1.298c0,0.555-0.356,0.71-1.831,1.282l-0.063,0.149
					c0.652,1.374,0.807,1.755,0.406,2.153l-0.943,0.923c-0.138,0.131-0.327,0.206-0.514,0.206c-0.123,0-0.307,0-1.685-0.578
					l-0.175,0.07C26.537,28.627,26.372,29.003,25.815,29.003z M24.638,28.003h1.027c0.1-0.196,0.274-0.63,0.522-1.293l0.077-0.206
					l0.227-0.142l0.758-0.307l0.189,0.077c0.868,0.367,1.25,0.504,1.414,0.555l0.718-0.703c-0.072-0.21-0.261-0.634-0.562-1.267
					l-0.097-0.202l0.06-0.265l0.315-0.747l0.198-0.077c0.323-0.125,1.092-0.423,1.39-0.577v-0.99
					c-0.202-0.098-0.646-0.27-1.323-0.512l-0.062-0.021l-0.206-0.075l-0.401-0.956l0.089-0.197c0.31-0.701,0.493-1.147,0.561-1.361
					l-0.722-0.703c-0.141,0.05-0.5,0.188-1.314,0.556l-0.194,0.089l-0.253-0.056l-0.771-0.311l-0.079-0.199
					c-0.127-0.315-0.43-1.065-0.587-1.355h-1.024c-0.101,0.197-0.276,0.629-0.523,1.292l-0.077,0.205l-0.227,0.142l-0.757,0.309
					l-0.189-0.077c-0.869-0.366-1.252-0.503-1.416-0.553l-0.718,0.7c0.072,0.21,0.261,0.635,0.562,1.268l0.096,0.202l-0.06,0.265
					l-0.316,0.752l-0.2,0.076c-0.321,0.123-1.088,0.419-1.386,0.572V22.9c0.202,0.098,0.646,0.271,1.324,0.514l0.207,0.074
					l0.144,0.224l0.314,0.748l-0.084,0.196c-0.139,0.315-0.464,1.052-0.564,1.366l0.722,0.704c0.14-0.05,0.499-0.187,1.315-0.556
					l0.195-0.088l0.253,0.054l0.771,0.313l0.079,0.198C24.34,27.363,24.532,27.808,24.638,28.003z M21.539,26.826l0.006,0.006
					C21.543,26.83,21.541,26.828,21.539,26.826z M29.731,20.825l-0.012,0.052l0.02-0.055L29.731,20.825z M21.508,17.966
					l-0.003,0.003C21.506,17.968,21.507,17.967,21.508,17.966z M28.704,17.929c0.003,0.004,0.007,0.007,0.011,0.011L28.704,17.929z
					 M25.125,24.986c-1.46,0-2.647-1.169-2.647-2.606c0-1.437,1.188-2.604,2.647-2.604s2.646,1.168,2.646,2.604
					C27.771,23.817,26.584,24.986,25.125,24.986z M25.125,20.775c-0.908,0-1.647,0.72-1.647,1.604c0,0.886,0.739,1.606,1.647,1.606
					s1.646-0.721,1.646-1.606C26.771,21.495,26.033,20.775,25.125,20.775z" />
                        </g>
                    </g>
                </g>
            </g>
            <g
                id="Try_before_Buy"
                class="st0">
                <g class="st1">
                    <path
                        class="st34"
                        d="M30.271,12.396V8.303H16.42l-2.643-3.41H2.092l-0.091,22.64h16.144v-1.5H3.888l6.156-12.137h20.003
			l-2.71,6.003l1.367,0.617l3.665-8.121L30.271,12.396L30.271,12.396z M9.123,12.396L3.518,23.448L3.586,6.393h9.456l2.643,3.41
			h13.086v2.593H9.123z" />
                    <polygon
                        class="st34"
                        points="24.92,18.146 23.42,18.146 23.42,25.288 20.211,25.288 24.169,30.021 28.13,25.288 24.92,25.288
			" />
                </g>
            </g>
            <g
                id="join_fd"
                class="st0">
                <g
                    id="join_fd_1_"
                    class="st1">
                    <g>
                        <path d="M8.2,31.083H3.333V20.708H8.2V31.083z M4.333,30.083H7.2v-8.375H4.333V30.083z" />
                    </g>
                    <g>
                        <path
                            d="M21.586,32.59l-7.987-2.242l-4.528,0.508V20.721l7.564-1.173l8.183,2.049v2.909l-0.484,0.149l-0.146-0.029L19.16,23.4
				l-0.159,0.654l5.321,1.298l7.329-2.014l0.848,3.235L21.586,32.59z M13.681,29.332l7.78,2.184l9.874-5.441l-0.395-1.503
				l-6.603,1.814l-6.545-1.597l0.633-2.598l5.393,1.315v-1.129l-7.23-1.811l-6.517,1.011v8.158L13.681,29.332z" />
                    </g>
                    <g>
                        <path
                            d="M13.076,13.214V7.118h1.968c0.846,0,1.517,0.242,2.012,0.727c0.495,0.484,0.743,1.127,0.743,1.928v0.792
				c0,0.807-0.249,1.45-0.746,1.93s-1.174,0.72-2.031,0.72h-1.946V13.214z M14.298,8.06v4.217h0.662
				c0.559,0,0.967-0.151,1.225-0.454s0.387-0.723,0.387-1.258v-0.8c0-0.539-0.128-0.958-0.383-1.256S15.531,8.06,14.981,8.06H14.298
				z" />
                        <path
                            d="M21.966,11.883h-2.14l-0.415,1.332h-1.235l2.098-6.097h1.252l2.09,6.097H22.38L21.966,11.883z M20.119,10.94h1.554
				l-0.771-2.47H20.89L20.119,10.94z" />
                    </g>
                    <g>
                        <path
                            d="M18.042,18.583c-4.664,0-8.458-3.792-8.458-8.454c0-4.664,3.794-8.458,8.458-8.458S26.5,5.463,26.5,10.125
				C26.5,14.789,22.706,18.583,18.042,18.583z M18.042,2.671c-4.113,0-7.458,3.346-7.458,7.458c0,4.11,3.346,7.454,7.458,7.454
				s7.458-3.346,7.458-7.458C25.5,6.015,22.154,2.671,18.042,2.671z" />
                    </g>
                    <g>
                        <path
                            class="st36"
                            d="M23.338,13.92" />
                    </g>
                </g>
            </g>
            <g
                id="become_vendor"
                class="st0">
                <g
                    id="developer_center"
                    class="st1">
                    <g>
                        <path
                            class="st4"
                            d="M13.5,30.9h-1v-4.3H7.7v-5.11l-3.458-0.864l3.335-5.917c-0.129-0.867-0.476-4.464,2.031-7.62
				c2.103-2.563,5.175-3.991,8.333-3.976c3.097,0.034,5.995,1.484,7.952,3.979c0.502,0.603,1.021,1.328,1.53,2.144
				c3.704,7.205-0.628,12.937-3.924,15.324v6.24h-1v-6.763l0.216-0.149c3.049-2.102,7.288-7.449,3.84-14.159
				C26.089,8.988,25.598,8.3,25.116,7.72c-1.778-2.266-4.394-3.577-7.186-3.607c-2.895-0.039-5.639,1.283-7.543,3.604
				c-2.511,3.162-1.804,6.948-1.796,6.986l0.036,0.181l-2.868,5.09L8.7,20.709V25.6h4.8V30.9z" />
                    </g>
                    <g>
                        <g>
                            <path
                                class="st4"
                                d="M18.1,10.1c-2.6,0-4.6,2-4.6,4.4c0,1.2,0.5,2.3,1.4,3.1l0,0c0,0,0.9,0.7,0.9,2.3v0.5h4.6v-0.5
					c0-1.6,0.9-2.2,0.9-2.3l0,0c0.9-0.8,1.4-2,1.4-3.1C22.7,12,20.6,10.1,18.1,10.1z M21,17.3c-0.1,0.1-1.1,0.9-1.1,2.6h-3.6
					c0-1.7-1-2.5-1.1-2.6c-0.8-0.7-1.2-1.7-1.2-2.8c0-2.2,1.9-3.9,4.1-3.9c2.3,0,4.1,1.8,4.1,3.9C22.2,15.5,21.8,16.5,21,17.3z" />
                            <path
                                class="st4"
                                d="M20.525,20.525h-4.851V19.9c0-1.514-0.843-2.195-0.852-2.202c-0.936-0.832-1.448-1.966-1.448-3.199
					c0-2.495,2.12-4.525,4.725-4.525s4.726,2.03,4.726,4.525c0,1.168-0.543,2.381-1.419,3.172c-0.02,0.038-0.056,0.078-0.107,0.135
					c-0.231,0.258-0.773,0.86-0.773,2.093L20.525,20.525L20.525,20.525z M15.925,20.275h4.351V19.9c0-1.328,0.608-2.005,0.838-2.26
					c0.026-0.029,0.048-0.052,0.062-0.069v-0.027l0.042-0.037c0.838-0.745,1.358-1.897,1.358-3.007c0-2.357-2.008-4.275-4.476-4.275
					c-2.467,0-4.475,1.917-4.475,4.275c0,1.16,0.482,2.228,1.358,3.007c0.032,0.025,0.942,0.751,0.942,2.394V20.275z M20.025,20.025
					h-3.851V19.9c0-1.003-0.355-1.86-1.028-2.479l-0.035-0.033c-0.795-0.695-1.237-1.723-1.237-2.888
					c0-2.219,1.895-4.025,4.225-4.025s4.226,1.806,4.226,4.025c0,1.065-0.439,2.09-1.236,2.888l0,0l0,0l-0.035,0.033
					c-0.673,0.619-1.028,1.477-1.028,2.479v0.125H20.025z M16.423,19.775h3.354c0.028-1.021,0.41-1.897,1.107-2.539l0.026-0.025
					c0.751-0.75,1.164-1.713,1.164-2.711c0-2.082-1.783-3.775-3.976-3.775c-2.191,0-3.975,1.693-3.975,3.775
					c0,1.092,0.411,2.053,1.157,2.706l0.033,0.031C16.013,17.878,16.395,18.754,16.423,19.775z" />
                        </g>
                        <g>
                            <rect
                                x="15.8"
                                y="20.925"
                                class="st4"
                                width="4.601"
                                height="0.75" />
                        </g>
                        <g>
                            <rect
                                x="16.2"
                                y="22.025"
                                class="st4"
                                width="3.7"
                                height="0.75" />
                        </g>
                        <g>
                            <path
                                class="st4"
                                d="M18.1,23.675c-0.786,0-1.475-0.643-1.475-1.375h0.75c0,0.283,0.323,0.625,0.725,0.625
					c0.536,0,0.688-0.431,0.73-0.687l0.74,0.123C19.437,23.159,18.859,23.675,18.1,23.675z" />
                        </g>
                        <g>

                            <rect
                                x="12.824"
                                y="9.736"
                                transform="matrix(0.6758 -0.737 0.737 0.6758 -3.4974 13.1481)"
                                class="st4"
                                width="0.75"
                                height="1.628" />
                        </g>
                        <g>

                            <rect
                                x="22.285"
                                y="10.176"
                                transform="matrix(0.7377 -0.6751 0.6751 0.7377 -1.0642 18.362)"
                                class="st4"
                                width="1.628"
                                height="0.749" />
                        </g>
                        <g>
                            <rect
                                x="17.725"
                                y="8"
                                class="st4"
                                width="0.75"
                                height="1.5" />
                        </g>
                        <g>
                            <rect
                                x="23.6"
                                y="13.825"
                                class="st4"
                                width="1.5"
                                height="0.75" />
                        </g>
                        <g>
                            <rect
                                x="11.2"
                                y="13.825"
                                class="st4"
                                width="1.5"
                                height="0.75" />
                        </g>
                    </g>
                </g>
            </g>
            <g
                id="addition"
                class="st0">
                <g class="st1">
                    <rect
                        x="5.2"
                        y="15.7"
                        class="st11"
                        width="23.8"
                        height="2"/>
                </g>
                <g class="st1">
                    <rect
                        x="16.1"
                        y="4.8"
                        class="st11"
                        width="2"
                        height="23.8"/>
                </g>
            </g>
            <g
                id="subtraction"
                class="st0">
                <g class="st1">
                    <rect
                        x="5.2"
                        y="15.7"
                        class="st11"
                        width="23.8"
                        height="2"/>
                </g>
            </g>
            <g
                id="dustbin"
                class="st0">
                <g class="st1">
                    <rect
                        x="3"
                        y="6.5"
                        class="st2"
                        width="28.2"
                        height="1.5"/>
                </g>
                <g class="st1">
                    <polygon
                        class="st2"
                        points="25.6,6.5 24.1,6.5 24.1,2.3 10.1,2.3 10.1,6.5 8.6,6.5 8.6,0.8 25.6,0.8 		"/>
                </g>
                <g class="st1">
                    <polygon
                        class="st2"
                        points="27.1,33.4 7.2,33.4 7.2,6.5 8.7,6.5 8.7,31.9 25.6,31.9 25.6,6.5 27.1,6.5 		"/>
                </g>
                <g class="st1">
                    <rect
                        x="12.8"
                        y="10.7"
                        class="st2"
                        width="1.5"
                        height="18.4"/>
                </g>
                <g class="st1">
                    <rect
                        x="19.9"
                        y="10.7"
                        class="st2"
                        width="1.5"
                        height="18.4"/>
                </g>
            </g>
            <g id="upgrade">
                <g>
                    <rect
                        x="5.9"
                        y="4.4"
                        class="st2"
                        width="22.6"
                        height="1.5"/>
                </g>
                <g>
                    <path
                        class="st2"
                        d="M23.3,30.8H11.5V16.5H5.9l11.5-8.4l11.4,8.4h-5.5V30.8z M13,29.3h8.7V15h2.5l-6.8-5l-6.9,5H13V29.3z"/>
                </g>
            </g>
            <g id="review">
                <g>
                    <polygon
                        class="st2"
                        points="8.4,32.8 0.6,32.7 0.7,23.8 26.3,2 34,11 27.5,16.5 26.6,15.3 31.8,10.8 26.1,4.1 2.2,24.5 2.1,31.2
                        7.8,31.2 15.9,24.4 16.9,25.5 		"/>
                </g>
                <g>
                    <path
                        class="st2"
                        d="M29.9,32.1l-6.2-3.3l-6.2,3.3l1.2-6.9l-5-4.9l7-1l3.1-6.3l3.1,6.3l7,1l-5,4.9L29.9,32.1z M16.9,21.3l3.4,3.3
                        l-0.8,4.7l4.2-2.2l4.2,2.2l-0.8-4.7l3.4-3.3l-4.7-0.7l-2.1-4.3l-2.1,4.3L16.9,21.3z"/>
                </g>
            </g>
            <g
                id="save"
                class="st0">
                <g class="st1">
                    <g>
                        <path
                            class="st2"
                            d="M26.8,31.8l-10-7.8L6.1,31.8V1.6h20.7V31.8z M7.6,3.1v25.8l9.2-6.7l8.5,6.6V3.1H7.6z"/>
                    </g>
                </g>
            </g>
            <g
                id="empty_cart_1_"
                class="st0">
                <g
                    id="empty_cart"
                    class="st1">
                    <g id="top_nav_cart_1_">
                        <g>
                            <g>
                                <ellipse
                                    class="st2"
                                    cx="12.3"
                                    cy="26.6"
                                    rx="1.7"
                                    ry="1.7"/>
                            </g>
                        </g>
                        <g>
                            <g>
                                <ellipse
                                    class="st2"
                                    cx="24.8"
                                    cy="26.6"
                                    rx="1.7"
                                    ry="1.7"/>
                            </g>
                        </g>
                        <g>
                            <polygon
                                class="st2"
                                points="26.6,23.4 10.7,23.4 8.7,15.3 10.2,14.9 11.9,21.9 25.5,21.9 29.3,11.6 7.9,11.6 6.6,7.1 3,7.1
					3,5.6 7.8,5.6 9,10.1 31.4,10.1 				"/>
                        </g>
                    </g>
                    <g>

                        <rect
                            x="15.1"
                            y="15.7"
                            transform="matrix(0.7071 -0.7071 0.7071 0.7071 -5.9353 18.4834)"
                            class="st2"
                            width="8.6"
                            height="1.5"/>
                    </g>
                    <g>

                        <rect
                            x="18.6"
                            y="12.1"
                            transform="matrix(0.7071 -0.7071 0.7071 0.7071 -5.9353 18.4834)"
                            class="st2"
                            width="1.5"
                            height="8.6"/>
                    </g>
                    <g>

                        <rect
                            x="15.1"
                            y="15.7"
                            transform="matrix(0.7071 -0.7071 0.7071 0.7071 -5.9353 18.4834)"
                            class="st2"
                            width="8.6"
                            height="1.5"/>
                    </g>
                </g>
            </g>
            <g
                id="remove_item"
                class="st0">
                <g
                    id="empty_cart_2_"
                    class="st1">
                    <g id="top_nav_cart_3_">
                        <g>
                            <polygon
                                class="st2"
                                points="26.9,23.7 11.6,23.7 9,14 7.8,9.1 2.2,9.1 2.2,7.6 9,7.6 10.5,13.6 12.8,22.2 25.9,22.2 28.9,14.5
					30.3,15 				"/>
                        </g>
                    </g>
                </g>
                <g class="st1">
                    <polygon
                        class="st2"
                        points="15.9,10.5 14.9,9.4 19.9,4.6 24.5,9.3 23.4,10.3 19.9,6.7 		"/>
                </g>
                <g class="st1">
                    <rect
                        x="19.1"
                        y="5.8"
                        class="st2"
                        width="1.5"
                        height="12.4"/>
                </g>
                <g class="st1">
                    <g>
                        <ellipse
                            class="st2"
                            cx="13.8"
                            cy="26.6"
                            rx="1.7"
                            ry="1.7"/>
                    </g>
                </g>
                <g class="st1">
                    <g>
                        <ellipse
                            class="st2"
                            cx="25"
                            cy="26.6"
                            rx="1.7"
                            ry="1.7"/>
                    </g>
                </g>
            </g>
            <g
                id="waepon"
                class="st0">
                <g class="st1">
                    <path
                        class="st2"
                        d="M34.956,14.766l-5.829-5.528l8.422-8.881l5.83,5.528L34.956,14.766z M31.248,9.181l3.651,3.464l6.358-6.704
			l-3.652-3.464L31.248,9.181z"/>
                </g>
                <g class="st1">
                    <path
                        class="st2"
                        d="M35.37,23.334L20.548,9.28l5.063-5.339l14.821,14.054L35.37,23.334z M22.669,9.223l12.645,11.991l2.998-3.162
			L25.668,6.061L22.669,9.223z"/>
                </g>
                <g class="st1">
                    <polygon
                        class="st2"
                        points="8.827,44.666 1.157,44.631 0.907,36.782 23.957,12.19 25.051,13.215 2.426,37.354 2.61,43.137
			8.188,43.162 31.293,18.949 32.379,19.984 		"/>
                </g>
                <g class="st1">

                    <rect
                        x="8.843"
                        y="23.678"
                        transform="matrix(0.6876 -0.7261 0.7261 0.6876 -11.4077 22.3391)"
                        class="st2"
                        width="22.831"
                        height="1.5"/>
                </g>
            </g>
            <g
                id="Sport"
                class="st0">
                <g class="st1">
                    <path
                        class="st2"
                        d="M22.511,44.667c-12.263,0-22.24-9.978-22.24-22.241c0-12.264,9.977-22.241,22.24-22.241
			s22.241,9.977,22.241,22.241C44.752,34.689,34.774,44.667,22.511,44.667z M22.511,1.686c-11.436,0-20.74,9.304-20.74,20.741
			c0,11.436,9.304,20.741,20.74,20.741s20.741-9.305,20.741-20.741C43.252,10.99,33.947,1.686,22.511,1.686z"/>
                </g>
                <g class="st1">
                    <path
                        class="st2"
                        d="M35.313,38.998C33.98,11.013,12.95,4.166,12.738,4.1l0.444-1.433c0.223,0.069,22.248,7.237,23.629,36.259
			L35.313,38.998z"/>
                </g>
                <g class="st1">
                    <path
                        class="st2"
                        d="M6.274,35.602l-1.433-0.443C4.903,34.96,11.284,15.23,37.255,6.434l0.48,1.421
			C12.482,16.408,6.333,35.411,6.274,35.602z"/>
                </g>
                <path
                    class="st3"
                    d="M6.625,38.813"/>
                <g class="st1">
                    <path
                        class="st2"
                        d="M20.963,43.589l-1.44-0.418l0.701-2.415c1.28-4.401,2.603-8.953,3.827-13.447
			c0.168-0.617,0.317-1.253,0.469-1.896c0.601-2.553,1.221-5.192,3.058-7.205c2.081-2.283,5.15-3.279,8.215-2.667
			c6.307,1.262,8.866,7.95,8.973,8.234l-1.405,0.524c-0.023-0.062-2.384-6.192-7.862-7.288c-2.579-0.515-5.062,0.289-6.813,2.207
			c-1.573,1.725-2.148,4.171-2.705,6.538c-0.155,0.659-0.309,1.313-0.481,1.946c-1.229,4.506-2.553,9.063-3.834,13.472
			L20.963,43.589z"/>
                </g>
                <g class="st1">
                    <path
                        class="st2"
                        d="M2.699,16.109l-0.371-1.453c0.056-0.015,5.66-1.446,10.258-2.684c4.779-1.287,8.907-3.691,10.513-5.401
			c1.564-1.665,1.424-4.353,1.142-4.826l1.185-0.92c0.786,0.983,0.806,4.602-1.233,6.773c-2.076,2.208-6.688,4.603-11.217,5.822
			C8.368,14.66,2.755,16.095,2.699,16.109z"/>
                </g>
            </g>
            <g
                id="Exterior"
                class="st0">
                <g class="st1">
                    <g>
                        <path
                            class="st2"
                            d="M39.664,23.883l-1.033-1.087l3.915-3.726L22.667,2.177L2.417,19.106l3.33,3.558l-1.096,1.024L0.24,18.973
				L21.631,1.027c0.574-0.482,1.439-0.48,2.01,0.01l21.146,17.971L39.664,23.883z"/>
                    </g>
                    <g>
                        <path
                            class="st2"
                            d="M39.664,23.883l-1.033-1.087l3.915-3.726L22.667,2.177L2.417,19.106l3.33,3.558l-1.096,1.024L0.24,18.973
				L21.631,1.027c0.574-0.482,1.439-0.48,2.01,0.01l21.146,17.971L39.664,23.883z"/>
                    </g>
                </g>
                <g class="st1">
                    <path
                        class="st2"
                        d="M40.761,44.188H4.523V23.129L21.448,8.41l0,0c0.582-0.506,1.463-0.511,2.05-0.011l17.218,14.684
			L40.761,44.188z M6.023,42.688h33.234l-0.039-18.91L22.524,9.542l-0.092,0L6.023,23.813V42.688z"/>
                </g>
                <g class="st1">
                    <polygon
                        class="st2"
                        points="29.397,43.248 27.897,43.248 27.897,25.77 17.385,25.77 17.385,43.248 15.885,43.248 15.885,24.27
			29.397,24.27 		"/>
                </g>
            </g>
            <g
                id="Interior"
                class="st0">
                <g>
                    <defs>
                        <rect
                            id="SVGID_1_"
                            x="47.188"
                            y="-2.625"
                            width="18.96"
                            height="43"/>
                    </defs>
                    <clipPath
                        id="SVGID_2_"
                        class="st1">
                        <use
                            xlink:href="#SVGID_1_"
                            style="overflow:visible;"/>
                    </clipPath>
                    <path
                        class="st4"
                        d="M59.773,0.981c0,1.992-1.613,3.605-3.606,3.605c-1.988,0-3.605-1.613-3.605-3.605s1.617-3.606,3.605-3.606
			C58.16-2.625,59.773-1.011,59.773,0.981L59.773,0.981z M59.773,0.981"/>
                    <path
                        class="st4"
                        d="M57.425,6.305c-0.898-0.184-1.875-0.172-2.758,0.035c-5.996,0.703-7.941,7.641-7.39,12.93
			c0.238,2.289,3.844,2.312,3.601,0c-0.199-1.926-0.113-4.836,0.911-6.906v7.543c0,0.085,0.007,0.171,0.011,0.257
			c0,0.039-0.011,0.075-0.011,0.114c0,5.984-0.008,11.964-0.258,17.945c-0.11,2.656,4.011,2.644,4.121,0
			c0.195-4.688,0.242-9.375,0.254-14.063c0.195,0.012,0.39,0.012,0.586,0c0.011,4.688,0.058,9.379,0.25,14.063
			c0.109,2.644,4.23,2.656,4.121,0c-0.246-5.981-0.254-11.961-0.254-17.945c0-0.184-0.027-0.352-0.063-0.516
			c-0.007-2.598-0.105-5.195-0.078-7.793c1.231,2.078,1.34,5.246,1.129,7.301c-0.242,2.308,3.363,2.285,3.602,0
			C65.761,13.867,63.723,6.75,57.425,6.305L57.425,6.305z M57.425,6.305"/>
                </g>

                <image
                    style="overflow:visible;"
                    width="1644"
                    height="1671"
                    xlink:href="51EB583B.jpg"
                    transform="matrix(0.0328 0 0 0.0328 -50.8125 -6.2559)"/>
                <g class="st1">
                    <path
                        class="st2"
                        d="M35.438,15.825H19.863V14.22c0-4.112,3.937-6.263,7.825-6.263c3.732,0,7.75,1.96,7.75,6.263V15.825z
			 M21.363,14.325h12.575V14.22c0-3.272-3.24-4.763-6.25-4.763c-3.046,0-6.325,1.491-6.325,4.763V14.325z"/>
                </g>
                <g class="st1">
                    <rect
                        x="0.505"
                        y="41.5"
                        class="st2"
                        width="10.169"
                        height="1.5"/>
                </g>
                <g class="st1">
                    <path
                        class="st2"
                        d="M44.667,42.914H22.743v-8.638c0-1.907,1.552-3.458,3.459-3.458h18.465V42.914z M24.243,41.414h18.924v-9.096
			H26.202c-1.08,0-1.959,0.878-1.959,1.958V41.414z"/>
                </g>
                <g class="st1">
                    <path
                        class="st2"
                        d="M44.667,32.318h-6.884V20.905h6.884V32.318z M39.283,30.818h3.884v-8.414h-3.884V30.818z"/>
                </g>
                <g class="st1">
                    <path
                        class="st2"
                        d="M39.283,31.977h-6.285v-4.368c0-1.953,1.589-3.542,3.542-3.542h2.743V31.977z M34.498,30.477h3.285v-4.91
			H36.54c-1.126,0-2.042,0.916-2.042,2.042V30.477z"/>
                </g>
                <g class="st1">
                    <path
                        class="st2"
                        d="M6.038,42.25h-1.5V24.311c0-0.676-0.006-1.355-0.012-2.037c-0.033-3.562-0.066-7.245,0.786-10.759
			c1.11-4.578,3.893-7.511,8.269-8.718c5.644-1.556,12.383-0.402,14.716,5.684l-1.4,0.537c-2.134-5.566-8.291-6.051-12.917-4.775
			c-3.865,1.066-6.224,3.56-7.209,7.625C5.961,15.201,5.994,18.79,6.025,22.26c0.006,0.686,0.013,1.371,0.013,2.05V42.25z"/>
                </g>
            </g>
            <g
                id="Furniture"
                class="st0">
                <g class="st1">
                    <rect
                        x="0.45"
                        y="8.583"
                        class="st2"
                        width="1.5"
                        height="30.134"/>
                </g>
                <g class="st1">
                    <rect
                        x="0.625"
                        y="30.817"
                        class="st2"
                        width="43.158"
                        height="1.5"/>
                </g>
                <g class="st1">
                    <rect
                        x="0.625"
                        y="27.562"
                        class="st2"
                        width="43.158"
                        height="1.5"/>
                </g>
                <g class="st1">
                    <path
                        class="st2"
                        d="M44.917,38.065h-1.5V24.349c0-1.198-0.904-2.173-2.017-2.173H1.008v-1.5H41.4
			c1.939,0,3.517,1.647,3.517,3.673V38.065z"/>
                </g>
                <g class="st1">
                    <path
                        class="st2"
                        d="M16.91,21.267h-1.5v-1.104c0-1.09-1.076-1.977-2.399-1.977H4.456c-1.394,0-2.527,1.134-2.527,2.527v0.553
			h-1.5v-0.553c0-2.221,1.807-4.027,4.027-4.027h8.555c2.15,0,3.899,1.56,3.899,3.477V21.267z"/>
                </g>
            </g>
            <g
                id="Human"
                class="st0">
                <g class="st1">
                    <path
                        class="st2"
                        d="M44.76,43.5H0.235l0.092-0.832c0.181-1.639,0.621-3.672,2.438-4.851c0.571-0.369,1.079-0.745,1.597-1.129
			c1.492-1.104,3.183-2.354,6.628-3.621l0.84-0.306c2.846-1.032,3.687-1.393,4.157-2.811c0.157-0.47,0.384-1.592,0.527-2.354
			c-0.57-0.362-1.395-1.125-1.979-2.675c-0.526-1.389-0.853-2.579-0.999-3.153c-0.052-0.013-0.115-0.025-0.191-0.034l-0.147-0.033
			c-1.533-0.51-2.179-4.104-2.268-5.039c-0.115-1.208,0.071-1.879,0.603-2.178c0.236-0.132,0.476-0.193,0.704-0.21
			c-0.258-2.259-0.54-7.259,1.672-9.236c2.705-2.416,4.746-3.435,7.047-3.521c4.278-0.161,7.114,0.825,10.131,3.522
			c2.21,1.977,1.93,6.978,1.672,9.237c0.228,0.018,0.467,0.079,0.702,0.211c0.688,0.385,0.676,1.418,0.606,2.161
			c-0.13,1.39-0.881,4.592-2.271,5.059l-0.148,0.034c-0.074,0.009-0.137,0.021-0.188,0.035c-0.146,0.573-0.476,1.773-1.004,3.167
			c-0.583,1.556-1.409,2.325-1.976,2.691c0.142,0.775,0.368,1.93,0.524,2.404c0.497,1.488,1.414,1.882,4.518,3.017l0.482,0.177
			c3.563,1.31,5.201,2.471,6.785,3.594c0.466,0.33,0.929,0.659,1.441,0.99l0.002,0.001c1.814,1.178,2.254,3.211,2.435,4.851
			L44.76,43.5z M1.938,42h41.12c-0.267-1.467-0.776-2.362-1.64-2.924c-0.532-0.343-1.013-0.684-1.495-1.026
			c-1.574-1.115-3.061-2.169-6.436-3.409l-0.48-0.176c-3.114-1.139-4.677-1.71-5.426-3.954c-0.271-0.826-0.635-2.927-0.676-3.163
			l-0.113-0.66l0.644-0.188c0.022-0.008,0.967-0.352,1.617-2.086c0.688-1.817,1.026-3.309,1.03-3.324l0.053-0.237l0.182-0.161
			c0.087-0.077,0.407-0.323,1.026-0.422c0.612-0.44,1.388-3.568,1.248-4.497c-0.124,0.006-0.273,0.06-0.348,0.101l-1.351,0.742
			l0.24-1.516c0.318-1.942,0.752-7.333-1.047-8.941c-2.728-2.438-5.188-3.289-9.075-3.141c-1.943,0.072-3.654,0.952-6.104,3.14
			c-1.803,1.611-1.367,6.999-1.046,8.939l0.26,1.571l-1.377-0.801c-0.069-0.038-0.217-0.091-0.341-0.097
			c-0.136,0.925,0.628,4.018,1.258,4.495c0.607,0.099,0.921,0.333,1.007,0.407l0.189,0.162l0.055,0.243
			c0.003,0.015,0.341,1.505,1.026,3.314c0.652,1.73,1.603,2.061,1.612,2.063l0.659,0.181l-0.118,0.673
			c-0.017,0.093-0.403,2.284-0.681,3.118c-0.72,2.169-2.265,2.729-5.069,3.746l-0.834,0.304c-3.244,1.192-4.773,2.324-6.253,3.419
			C4.71,38.297,4.177,38.69,3.58,39.076C2.716,39.638,2.205,40.533,1.938,42z"/>
                </g>
            </g>
            <g
                id="Accessory"
                class="st0">
                <g class="st1">
                    <path
                        class="st2"
                        d="M9.577,35.847c-5.143,0-9.327-4.184-9.327-9.326c0-5.143,4.184-9.327,9.327-9.327s9.327,4.184,9.327,9.327
			C18.903,31.663,14.719,35.847,9.577,35.847z M9.577,18.693c-4.315,0-7.827,3.511-7.827,7.827c0,4.315,3.511,7.826,7.827,7.826
			s7.827-3.511,7.827-7.826C17.403,22.205,13.892,18.693,9.577,18.693z"/>
                </g>
                <g class="st1">
                    <path
                        class="st2"
                        d="M35.507,35.847c-5.143,0-9.327-4.184-9.327-9.326c0-5.143,4.185-9.327,9.327-9.327s9.326,4.184,9.326,9.327
			C44.833,31.663,40.649,35.847,35.507,35.847z M35.507,18.693c-4.315,0-7.827,3.511-7.827,7.827c0,4.315,3.512,7.826,7.827,7.826
			s7.826-3.511,7.826-7.826C43.333,22.205,39.822,18.693,35.507,18.693z"/>
                </g>
                <g class="st1">
                    <path
                        class="st2"
                        d="M18.771,26.998l-0.999-1.119c2.961-2.642,6.787-2.642,9.747,0l-0.998,1.119
			C24.13,24.864,21.162,24.866,18.771,26.998z"/>
                </g>
                <g class="st1">
                    <path
                        class="st2"
                        d="M4.47,20.615l-1.109-1.01l7.856-8.629c1.448-1.268,2.89-1.782,4.349-1.593
			c2.433,0.317,3.944,2.515,4.007,2.608l-1.242,0.841l0.621-0.42l-0.62,0.422c-0.012-0.017-1.21-1.74-2.969-1.964
			c-1.007-0.129-2.053,0.267-3.098,1.177L4.47,20.615z"/>
                </g>
                <g class="st1">
                    <path
                        class="st2"
                        d="M40.333,20.335l-7.718-8.345c-0.989-0.856-2.039-1.252-3.049-1.12c-1.742,0.228-2.948,1.944-2.96,1.961
			l-1.242-0.841c0.063-0.093,1.575-2.291,4.008-2.608c1.458-0.191,2.9,0.325,4.286,1.532l7.776,8.401L40.333,20.335z"/>
                </g>
            </g>
            <g
                id="Vfx"
                class="st0">
                <g class="st1">
                    <path
                        class="st2"
                        d="M17.038,44.702l-2.832-8.888L1.962,37.269l10.545-8.719l-11.12-8.403l11.997,0.327l0.56-15.227l7.771,12.915
			l9.728-6.195l-2.898,11.271l9.586,3.758l-9.089,4.64l6.73,11.789l-13.281-6.132L17.038,44.702z M15.259,34.179l2.315,7.265
			l4.434-6.025l10.136,4.681l-5.186-9.084l7.521-3.839l-7.719-3.026l2.283-8.876l-7.821,4.98l-5.966-9.914l-0.429,11.674l-8.8-0.24
			l8.896,6.723l-8.081,6.682L15.259,34.179z"/>
                </g>
                <g class="st1">
                    <polygon
                        class="st2"
                        points="35.948,18.634 35.188,17.34 39.808,14.63 34.107,12.772 35.371,6.297 29.95,10.215 26.131,4.852
			25.422,11.106 23.932,10.937 25.082,0.791 30.295,8.114 37.573,2.856 35.833,11.757 43.443,14.236 		"/>
                </g>
            </g>
            <g
                id="Hair"
                class="st0">
                <g class="st1">
                    <path
                        class="st2"
                        d="M16.155,44.75c-2.918,0-7.36-3.868-8.273-4.907c-2.467-2.809-4.413-6.463-5.479-10.291
			C0.474,22.626,1.253,15.24,4.54,9.286c3.153-5.72,8.539-7.022,12.417-5.841c2.475-2.278,6.107-3.323,10.049-2.874
			c5.443,0.62,10.511,3.936,13.556,8.872c3.43,5.562,4.274,12.905,2.258,19.643c-0.747,2.498-2.055,5.117-3.683,7.376l0,0
			c-2.582,3.579-5.812,6.057-9.094,6.976c-0.358,0.103-0.756-0.017-1.009-0.304c-0.255-0.29-0.319-0.687-0.169-1.036
			c0.425-0.987,1.096-1.885,1.746-2.752c0.514-0.687,0.999-1.335,1.351-2.001c1.424-2.697,2.272-5.773,2.457-8.902
			c-0.732-2.662-2.298-4.55-4.775-5.737c-1.218-0.585-2.655-0.972-4.178-1.381c-3.142-0.845-6.635-1.785-8.443-4.796
			c-2.004,5.851-4.817,8.362-6.299,9.333c-0.021,0.918-0.017,1.839,0.01,2.801c0.169,5.362,2.476,11.993,7.138,13.873l0.8,0.322
			l-0.43,0.747c-0.38,0.661-0.998,1.052-1.786,1.131C16.358,44.745,16.258,44.75,16.155,44.75z M14.177,4.548
			c-2.644,0-5.978,1.209-8.323,5.462C2.8,15.541,2.05,22.696,3.848,29.149c1.007,3.615,2.84,7.061,5.161,9.703
			c0.942,1.071,4.826,4.213,6.945,4.391c-4.997-3.047-6.586-10.391-6.717-14.536c-0.032-1.135-0.032-2.211,0-3.293l0.012-0.418
			l0.362-0.209c1.306-0.755,4.56-3.302,6.574-10.629l0.715-2.602l0.73,2.598c1.066,3.796,4.544,4.731,8.227,5.722
			c1.521,0.409,3.095,0.833,4.438,1.477c2.877,1.379,4.763,3.669,5.604,6.807l0.028,0.18l-0.002,0.068
			c-0.182,3.384-1.093,6.716-2.635,9.637c-0.406,0.771-0.95,1.497-1.477,2.2c-0.337,0.449-0.664,0.886-0.949,1.322
			c2.537-1.053,5.004-3.136,7.058-5.982c1.532-2.127,2.762-4.588,3.462-6.929c1.896-6.335,1.111-13.223-2.098-18.426
			c-2.805-4.547-7.458-7.601-12.448-8.169c-3.668-0.419-7.003,0.591-9.152,2.767L17.346,5.17l-0.453-0.165
			C16.167,4.739,15.226,4.548,14.177,4.548z M29.641,41.992c-0.002,0.001-0.003,0.001-0.005,0.002
			C29.638,41.993,29.639,41.993,29.641,41.992z"/>
                </g>
            </g>
            <g
                id="Head"
                class="st0">
                <g class="st1">
                    <path
                        class="st2"
                        d="M22.44,44.647c-0.047,0-0.094-0.002-0.141-0.006c-0.574-0.052-1.071-0.414-1.296-0.947
			c-0.873-2.061-2.534-5.25-2.794-5.748c-0.828-0.984-2.089-0.888-3.53-0.669c-0.175,0.026-0.337,0.051-0.485,0.068
			c-3.258,0.401-4.497-0.414-4.857-0.75c-1.004-0.721-0.756-2.537-0.654-3.089c0.169-0.618,0.003-0.841-0.247-1.177L8.36,32.226
			c-0.659-0.92-0.643-1.608-0.512-2.024c-0.632-0.409-0.737-0.92-0.752-1.04l-0.007-0.055L7.11,27.53
			c0.02-0.168,0.024-0.286,0.022-0.368c-0.697-0.061-1.285-0.31-1.691-0.737c-0.52-0.547-0.526-1.162-0.522-1.28h0
			c0.021-0.692,0.797-2.389,2.307-5.049c0.55-1.061,0.188-1.806-0.194-2.596c-0.201-0.415-0.409-0.844-0.454-1.305
			C6.036,10.547,8.234,7.43,10.211,5.344c3.857-4.079,8.727-4.896,12.162-4.873c8.172,0.06,11.673,2.716,14.239,5.578
			c5.03,5.614,4.327,10.605,4.205,11.271c-0.177,3.167-4.184,8.488-4.355,8.715c-1.874,2.695-2.033,4.994-1.834,6.443
			c0.146,1.074-0.479,2.111-1.518,2.525c-4.283,1.7-7.976,6.816-9.364,8.938C23.455,44.385,22.963,44.647,22.44,44.647z
			 M16.158,35.633c1.117,0,2.351,0.279,3.267,1.432l0.077,0.117c0.078,0.147,1.915,3.642,2.883,5.929l0.734,0.419l-0.627-0.411
			c1.822-2.782,5.552-7.718,10.065-9.51c0.403-0.16,0.639-0.533,0.585-0.927c-0.235-1.714-0.062-4.411,2.107-7.529
			c1.114-1.473,3.981-5.721,4.073-7.954l0.016-0.127c0.039-0.187,0.906-4.72-3.843-10.021c-2.176-2.427-5.165-5.021-13.134-5.079
			c-3.137-0.04-7.575,0.716-11.061,4.404c-1.758,1.855-3.714,4.631-3.228,9.676c0.019,0.193,0.16,0.486,0.311,0.795
			c0.427,0.881,1.072,2.212,0.162,3.965c-0.988,1.741-2.074,3.881-2.129,4.346l0.002,0.008c0.015,0.241,0.317,0.503,1.12,0.518
			c0.137,0.014,1.296,0.192,1.065,1.956L8.59,28.888c0.051,0.045,0.16,0.12,0.374,0.191l0.166,0.056l0.124,0.123
			c0.298,0.294,0.425,0.854,0.021,1.405c-0.003,0.06,0.01,0.278,0.302,0.687l0.063,0.085c0.298,0.401,0.854,1.148,0.503,2.411
			c-0.104,0.583-0.072,1.378,0.079,1.54l0.166,0.144l0,0c0.008,0,0.833,0.67,3.624,0.328c0.136-0.017,0.285-0.039,0.444-0.063
			C14.933,35.722,15.527,35.633,16.158,35.633z M9.259,30.685c-0.007,0.01-0.014,0.019-0.021,0.027
			C9.247,30.703,9.254,30.693,9.259,30.685z"/>
                </g>
            </g>
            <g
                id="Underwear"
                class="st0">
                <g class="st1">
                    <g>
                        <path
                            class="st2"
                            d="M12.073,27.543c-0.193,0-0.382-0.074-0.524-0.214c-6.751-6.595,0.825-14.685,0.902-14.766
				c0.14-0.146,0.334-0.23,0.537-0.232c0.173,0.019,0.398,0.079,0.54,0.224c6.956,7.064,8.198,12.494,8.248,12.722
				c0.051,0.236-0.014,0.482-0.176,0.662c-0.162,0.179-0.404,0.267-0.64,0.242c-3.132-0.349-8.611,1.313-8.666,1.329
				C12.22,27.532,12.146,27.543,12.073,27.543z M13.024,14.191c-1.434,1.773-5.054,7.142-0.73,11.755
				c1.249-0.355,4.866-1.31,7.71-1.313C19.366,22.893,17.558,18.958,13.024,14.191z"/>
                    </g>
                    <g>
                        <path
                            class="st2"
                            d="M31.165,13.873c-0.036-0.104-3.68-10.353-8.834-11.366c-5.163,1.014-8.798,11.262-8.835,11.366l-1.416-0.495
				c0.162-0.463,4.033-11.355,10.127-12.373l0.124-0.021l0.124,0.021c6.092,1.018,9.964,11.91,10.126,12.373L31.165,13.873z"/>
                    </g>
                    <g>
                        <path
                            class="st2"
                            d="M32.587,27.543c-0.073,0-0.147-0.011-0.22-0.033c-0.056-0.017-5.53-1.679-8.666-1.329
				c-0.241,0.024-0.479-0.063-0.64-0.243c-0.162-0.179-0.228-0.426-0.176-0.661c0.05-0.228,1.293-5.657,8.249-12.722
				c0.143-0.144,0.36-0.205,0.54-0.224c0.203,0.001,0.396,0.085,0.536,0.232c0.078,0.081,7.652,8.171,0.901,14.766
				C32.969,27.469,32.78,27.543,32.587,27.543z M24.656,24.634c2.845,0.003,6.461,0.957,7.71,1.313
				c4.337-4.625,0.709-9.987-0.728-11.756C27.104,18.958,25.294,22.893,24.656,24.634z"/>
                    </g>
                    <g>
                        <path
                            class="st2"
                            d="M23.82,44.589h-2.98l-0.214-0.385c-2.147-3.858-10.014-5.578-10.093-5.595L9.88,38.47l0.438-4.621l0.9,0.31
				c3.479,1.195,7.22,1.807,11.107,1.764c3.895,0.054,7.636-0.567,11.116-1.764l0.901-0.31l0.438,4.621l-0.652,0.14
				c-0.079,0.017-7.95,1.742-10.094,5.595L23.82,44.589z M21.704,43.089h1.254c2.298-3.519,8.217-5.284,10.206-5.791l-0.135-1.426
				c-3.381,1.053-6.963,1.589-10.702,1.55c-3.704,0.041-7.312-0.496-10.692-1.55l-0.136,1.426
				C13.487,37.805,19.405,39.57,21.704,43.089z"/>
                    </g>
                    <g>
                        <path
                            class="st2"
                            d="M23.55,26.183c-1.208-0.112-2.427-0.002-2.439,0l-0.137-1.494c0.055-0.004,1.372-0.123,2.713,0L23.55,26.183
				z"/>
                    </g>
                </g>
            </g>
            <g
                id="Shirts"
                class="st0">
                <g class="st1">
                    <path
                        class="st2"
                        d="M36.981,44.417H7.994l1.569-20.761l-7.232-4.553L7.964,4.211l9.978-3.883l0.019,1.076
			c0.018,0.997,0.324,1.768,0.937,2.358c1.283,1.236,3.509,1.226,3.538,1.226c0.065,0.002,2.409,0.078,3.709-1.172
			c0.585-0.562,0.869-1.304,0.869-2.267V0.431l10.042,4.112l5.655,15.283l-7.229,3.867L36.981,44.417z M9.611,42.917h25.757
			l-1.453-20.088l6.935-3.709L35.878,5.682l-7.466-3.057c-0.178,0.899-0.591,1.662-1.234,2.278c-1.768,1.693-4.64,1.589-4.759,1.584
			c-0.065,0-2.813,0.038-4.561-1.645c-0.667-0.642-1.098-1.437-1.287-2.372l-7.44,2.896L4.168,18.487l6.958,4.381L9.611,42.917z"/>
                </g>
            </g>
            <g
                id="Pants"
                class="st0">
                <g class="st1">
                    <path
                        class="st2"
                        d="M42.326,44.75H26.698l-4.146-18.808L17.966,44.75H2.851L0.598,13.258L5.518,0.5h34.144l4.916,12.759
			L42.326,44.75z M27.903,43.25H40.93l2.129-29.765L38.633,2H6.547L2.118,13.486L4.247,43.25h12.541l5.839-23.942L27.903,43.25z"/>
                </g>
            </g>
            <g
                id="Skirts"
                class="st0">
                <g class="st1">
                    <g>
                        <path
                            class="st2"
                            d="M44.725,40.25H0.693l10.286-29.381h23.458L44.725,40.25z M2.807,38.75h39.802l-9.236-26.381h-21.33
				L2.807,38.75z"/>
                    </g>
                    <g>
                        <path
                            class="st2"
                            d="M34.864,12.369H10.552v-6.57h24.312V12.369z M12.052,10.869h21.312v-3.57H12.052V10.869z"/>
                    </g>
                </g>
            </g>
            <g
                id="Coats"
                class="st0">
                <g class="st1">
                    <g>
                        <path
                            class="st2"
                            d="M32.269,37.833H12.898L12.62,21.479L6.697,32.241l-6.473-3.504l10.274-18.336l6.094-3.139l5.992,6.07
				l5.992-6.07l6.095,3.139l10.273,18.336l-6.473,3.504l-5.923-10.762L32.269,37.833z M14.373,36.333h16.421l0.35-20.516
				l7.923,14.397l3.824-2.07l-9.309-16.616L28.868,9.1l-6.285,6.367L16.298,9.1l-4.713,2.428L2.276,28.144l3.825,2.07l7.923-14.397
				L14.373,36.333z"/>
                    </g>
                    <g>
                        <rect
                            x="21.833"
                            y="14.4"
                            class="st2"
                            width="1.5"
                            height="19.407"/>
                    </g>
                </g>
            </g>
            <g
                id="Fullbody"
                class="st0">
                <g class="st1">
                    <path
                        class="st2"
                        d="M30.574,44.75H14.438l-0.183-0.485c-1.338-3.544-2.01-5.322-1.787-9.298l0.016-0.296
			c0.089-1.669,0.182-3.394,0.834-5.025c0.215-0.532,0.449-1.051,0.683-1.568c0.416-0.922,0.809-1.792,1.092-2.726
			c0.691-2.238,1.095-5.296,0.44-7.088c-1.738-4.804-1.763-6.824-1.736-7.292c-0.126-1.639,0.681-9.037,0.775-9.887l0.074-0.668
			h3.586l-0.007,0.758c-0.001,0.086-0.035,8.55,4.279,9.021c4.323-0.471,4.283-8.935,4.282-9.021l-0.008-0.758h3.587l0.073,0.667
			c0.095,0.851,0.906,8.249,0.777,9.889c0.025,0.467-0.003,2.487-1.746,7.289c-0.647,1.79-0.243,4.849,0.444,7.086
			c0.283,0.938,0.677,1.808,1.095,2.729c0.234,0.517,0.469,1.035,0.683,1.564c0.647,1.612,0.741,3.314,0.833,4.96l0.021,0.364
			c0.222,3.978-0.449,5.756-1.788,9.298L30.574,44.75z M15.476,43.25h14.062c1.175-3.12,1.704-4.715,1.51-8.198l-0.021-0.366
			c-0.084-1.524-0.172-3.102-0.727-4.482c-0.205-0.509-0.432-1.008-0.658-1.507c-0.419-0.925-0.852-1.882-1.162-2.91
			c-0.704-2.291-1.238-5.773-0.42-8.035c1.782-4.909,1.658-6.694,1.657-6.712l-0.006-0.072l0.007-0.083
			c0.102-0.928-0.338-5.638-0.697-8.968H28.27c-0.102,2.359-0.816,9.344-5.699,9.779l-0.066,0.006l-0.066-0.006
			c-4.883-0.435-5.595-7.419-5.696-9.779h-0.75c-0.358,3.33-0.795,8.041-0.695,8.969l0.009,0.084l-0.01,0.083
			c0,0.006-0.128,1.791,1.648,6.698c0.827,2.263,0.292,5.746-0.416,8.04c-0.311,1.023-0.742,1.979-1.159,2.903
			c-0.226,0.499-0.452,0.999-0.658,1.511c-0.559,1.398-0.645,2.999-0.728,4.546l-0.016,0.299
			C13.771,38.533,14.3,40.128,15.476,43.25z"/>
                </g>
            </g>
            <g
                id="Shoes"
                class="st0">
                <g class="st1">
                    <path
                        class="st2"
                        d="M44.5,37.47H32.139l0.157-0.883c0.031-0.174,0.725-4.271-2.244-5.361c0.001,0,0.001,0,0.001,0
			c-0.011,0-1.894-0.496-3.219,0.557c-1.069,0.849-1.559,2.499-1.453,4.904l0.034,0.783H0.667l-0.25-9.888
			c0-0.069,0.016-5.868,6.813-7.126l5.216-0.641c0.645-0.078,1.299-0.131,1.952-0.183c0.957-0.077,1.946-0.156,2.868-0.322
			c0.664-0.12,1.328-0.176,1.969-0.23c1.069-0.091,2.079-0.177,3.028-0.536c1.371-0.517,2.029-1.546,2.201-3.442l0.7-7.693H44.5
			V37.47z M33.876,35.97H43V8.908H26.533l-0.575,6.329c-0.143,1.563-0.625,3.751-3.165,4.709c-1.144,0.433-2.306,0.532-3.431,0.627
			c-0.635,0.054-1.235,0.105-1.83,0.212c-0.995,0.179-2.022,0.262-3.015,0.341c-0.633,0.051-1.267,0.101-1.891,0.177l-5.17,0.634
			c-5.484,1.017-5.541,5.433-5.541,5.621l0.213,8.411h21.739c0.019-2.512,0.705-4.316,2.047-5.373
			c1.952-1.537,4.496-0.825,4.604-0.796C33.43,30.868,33.997,33.929,33.876,35.97z"/>
                </g>
            </g>
            <g
                id="Gloves"
                class="st0">
                <g class="st1">
                    <path
                        d="M31.994,44.914l-14.906-0.033c-1.334,0-2.421-1.087-2.421-2.423v-4.366c0-0.565,0.196-1.105,0.549-1.535
			c-0.045-0.049-0.09-0.097-0.125-0.132l-0.169-0.18c-2.348-2.618-9.833-11.586-9.908-11.676c-0.617-0.638-0.967-1.564-0.925-2.504
			c0.043-0.954,0.465-1.824,1.188-2.451c1.382-1.2,3.51-1.059,4.841,0.326l3.969,4.122L12.056,6.819
			c-0.121-1.024,0.219-2.039,0.932-2.785s1.717-1.13,2.765-1.055c1.63,0.118,2.959,1.436,3.158,3.133l0.233,1.979V4.05
			c0-1.031,0.456-2,1.251-2.657s1.841-0.919,2.869-0.724c1.605,0.308,2.771,1.771,2.771,3.48v3.339L26.162,6
			c0.087-1.027,0.624-1.954,1.473-2.541c0.849-0.588,1.912-0.763,2.92-0.478c1.573,0.443,2.609,2,2.465,3.704l-0.39,4.58
			c0.361-1.641,1.876-2.792,3.472-2.63c0.903,0.092,1.728,0.562,2.263,1.289c0.535,0.728,0.738,1.653,0.559,2.539l-3.052,14.947
			h-0.057c-0.118,0.538-0.308,1.541-0.566,2.998c-0.05,0.283-0.086,0.482-0.098,0.54l-0.649,3.218
			c-0.042,0.243-0.086,0.487-0.155,0.719c-0.113,0.378-0.283,0.663-0.42,0.893c-0.205,0.343-0.273,0.458-0.2,0.769
			c0.053,0.222,0.145,0.434,0.232,0.646c0.171,0.411,0.363,0.876,0.375,1.419c0,0.006,0.084,3.865,0.084,3.865
			C34.417,43.827,33.33,44.914,31.994,44.914z M7.477,20.309c-0.444,0-0.877,0.144-1.216,0.438
			c-0.409,0.355-0.648,0.847-0.672,1.386c-0.024,0.538,0.168,1.048,0.542,1.436c0.111,0.13,7.578,9.076,9.909,11.675l0.134,0.143
			c0.316,0.328,0.709,0.738,0.681,1.282c-0.014,0.279-0.143,0.535-0.362,0.722c-0.207,0.175-0.325,0.432-0.325,0.702v4.366
			c0,0.509,0.414,0.923,0.923,0.923l14.907,0.033c0.507,0,0.921-0.414,0.921-0.923c0-0.001-0.081-3.748-0.084-3.845
			c-0.005-0.266-0.123-0.551-0.261-0.881c-0.107-0.26-0.23-0.555-0.306-0.875c-0.215-0.902,0.124-1.47,0.371-1.884
			c0.113-0.189,0.212-0.354,0.271-0.552c0.053-0.175,0.083-0.362,0.115-0.547l0.06-0.327l0.598-2.935
			c0.012-0.055,0.044-0.238,0.091-0.501c0.393-2.212,0.58-3.27,0.78-3.774l2.901-14.208c0.096-0.471-0.013-0.963-0.298-1.35
			c-0.288-0.392-0.717-0.636-1.206-0.686l0,0c-0.849-0.089-1.672,0.568-1.861,1.491l-1.14,5.583
			c-0.124,0.613-0.679,1.009-1.304,0.919c-0.622-0.089-1.051-0.627-0.997-1.252l0.878-10.31c0.082-0.972-0.51-1.889-1.377-2.133
			c-0.586-0.166-1.175-0.07-1.66,0.267c-0.479,0.332-0.782,0.855-0.832,1.435l-0.755,8.867c-0.056,0.646-0.582,1.124-1.23,1.083
			c-0.647-0.028-1.136-0.537-1.136-1.183V4.149c0-0.975-0.668-1.837-1.553-2.007c-0.596-0.116-1.175,0.03-1.631,0.407
			c-0.449,0.372-0.707,0.918-0.707,1.5v10.673c0,0.597-0.45,1.073-1.046,1.108c-0.596,0.034-1.097-0.385-1.167-0.978l-1.009-8.565
			c-0.114-0.968-0.878-1.748-1.777-1.813c-0.611-0.048-1.164,0.168-1.572,0.595c-0.403,0.422-0.595,0.995-0.527,1.573l2.105,17.862
			c0.066,0.561-0.221,1.077-0.73,1.317c-0.508,0.239-1.089,0.133-1.48-0.272L9.039,20.98C8.612,20.538,8.036,20.309,7.477,20.309z
			 M15.521,36.246C15.521,36.246,15.52,36.246,15.521,36.246C15.52,36.246,15.521,36.246,15.521,36.246z"/>
                </g>
                <g class="st1">
                    <path
                        d="M28.813,41.125c-1.172,0-2.125-0.953-2.125-2.125s0.953-2.125,2.125-2.125s2.125,0.953,2.125,2.125
			S29.984,41.125,28.813,41.125z M28.813,38.375c-0.345,0-0.625,0.28-0.625,0.625s0.28,0.625,0.625,0.625s0.625-0.28,0.625-0.625
			S29.157,38.375,28.813,38.375z"/>
                </g>
            </g>
            <g
                id="all"
                class="st0">
                <circle
                    class="st6"
                    cx="6.041"
                    cy="22.903"
                    r="2.541"/>
                <circle
                    class="st6"
                    cx="22.646"
                    cy="22.903"
                    r="2.541"/>
                <circle
                    class="st6"
                    cx="39.251"
                    cy="22.903"
                    r="2.541"/>
            </g>
            <g
                id="Accessory_C"
                class="st0">
                <g class="st1">
                    <g>
                        <path
                            class="st2"
                            d="M22.632,20.002h-1.5v-3.389l0.203-0.216c3.273-3.495,3.679-5.599,3.443-6.748
				c-0.234-1.141-1.17-1.581-1.179-1.584c-1.202-0.528-2.208-0.578-2.992-0.148c-1.498,0.822-1.897,3.168-1.901,3.192l-1.482-0.229
				c0.02-0.125,0.499-3.091,2.662-4.278c1.214-0.666,2.667-0.636,4.316,0.089c0.066,0.029,1.653,0.745,2.046,2.657
				c0.437,2.126-0.779,4.768-3.615,7.856V20.002z"/>
                    </g>
                    <g>
                        <path
                            class="st2"
                            d="M41.741,36.125H2.87l-2.682-1.677v-4.401l17.194-10.191h8.389l19.087,10.169v4.461L41.741,36.125z
				 M3.3,34.625h38.07l1.987-1.046v-2.654l-17.962-9.569h-7.603L1.688,30.902v2.714L3.3,34.625z"/>
                    </g>
                </g>
            </g>
            <g
                id="Morph"
                class="st0">
                <g class="st1">
                    <g>
                        <polygon
                            class="st7"
                            points="37.496,12.27 32.069,16.737 37.496,21.512 			"/>
                    </g>
                    <g>
                        <rect
                            x="34.783"
                            y="16.142"
                            class="st7"
                            width="9.821"
                            height="1.5"/>
                    </g>
                    <g>
                        <polygon
                            class="st7"
                            points="6.545,21.512 11.972,17.047 6.545,12.27 			"/>
                    </g>
                    <g>
                        <rect
                            x="0.407"
                            y="16.142"
                            class="st7"
                            width="9.822"
                            height="1.5"/>
                    </g>
                    <g>
                        <path
                            class="st7"
                            d="M14.193,39.395c-1.569-2.534-2.508-5.342-2.715-8.119c-0.2-2.693,0.262-5.541,1.337-8.235
				c0.393-0.981,0.913-1.869,1.416-2.728c0.62-1.059,1.206-2.059,1.54-3.179c0.209-0.703,0.332-1.409,0.367-2.099
				c0.058-1.164-0.129-2.322-0.555-3.443c-0.465-1.216-1.129-2.274-1.921-3.058l1.055-1.066c0.943,0.933,1.728,2.174,2.269,3.59
				c0.5,1.316,0.719,2.679,0.651,4.051c-0.041,0.81-0.184,1.634-0.427,2.452c-0.386,1.295-1.045,2.42-1.683,3.509
				c-0.497,0.849-0.966,1.651-1.317,2.527c-0.991,2.483-1.418,5.101-1.234,7.567c0.189,2.538,1.051,5.11,2.494,7.441L14.193,39.395z
				"/>
                    </g>
                    <g>
                        <path
                            class="st7"
                            d="M30.956,39.395l-1.275-0.789c1.442-2.331,2.306-4.904,2.494-7.441c0.185-2.466-0.242-5.083-1.234-7.568
				c-0.351-0.875-0.82-1.677-1.317-2.526c-0.638-1.088-1.297-2.214-1.682-3.508c-0.244-0.819-0.388-1.645-0.428-2.453
				c-0.069-1.371,0.15-2.734,0.651-4.051c0.541-1.416,1.325-2.658,2.268-3.591l1.055,1.066c-0.791,0.784-1.455,1.841-1.921,3.059
				c-0.427,1.121-0.613,2.279-0.555,3.441c0.034,0.689,0.157,1.396,0.367,2.1c0.333,1.12,0.919,2.12,1.539,3.178
				c0.503,0.859,1.023,1.748,1.415,2.728c1.076,2.696,1.539,5.544,1.338,8.236C33.464,34.052,32.525,36.859,30.956,39.395z"/>
                    </g>
                </g>
            </g>
            <g
                id="Signs"
                class="st0">
                <g class="st1">
                    <path
                        class="st2"
                        d="M40.5,29.5H4.4V6.8h36.1V29.5z M5.9,28H39V8.3H5.9V28z"/>
                </g>
                <g class="st1">
                    <polygon
                        class="st2"
                        points="28.7,7.6 27.2,7.6 27.2,4.3 17.7,4.3 17.7,7.6 16.2,7.6 16.2,2.8 28.7,2.8 		"/>
                </g>
                <g class="st1">
                    <rect
                        x="4.4"
                        y="32.6"
                        class="st2"
                        width="36.2"
                        height="1.5"/>
                </g>
                <g class="st1">

                    <rect
                        x="9.3"
                        y="37.3"
                        transform="matrix(0.4181 -0.9084 0.9084 0.4181 -26.3292 35.0486)"
                        class="st2"
                        width="9.7"
                        height="1.5"/>
                </g>
                <g class="st1">

                    <rect
                        x="30.3"
                        y="33.2"
                        transform="matrix(0.9085 -0.4179 0.4179 0.9085 -13.0714 16.4585)"
                        class="st2"
                        width="1.5"
                        height="9.7"/>
                </g>
            </g>
            <g id="Motion">
                <g>

                    <rect
                        x="-2.8"
                        y="29.2"
                        transform="matrix(0.7071 -0.7071 0.7071 0.7071 -16.1148 20.9988)"
                        class="st2"
                        width="40.2"
                        height="1.5"/>
                </g>
                <g>
                    <polygon
                        class="st2"
                        points="41.5,28.2 26.6,28.2 26.6,19.8 28.1,19.8 28.1,26.7 41.5,26.7 		"/>
                </g>
                <g>
                    <polygon
                        class="st2"
                        points="11.8,25.5 10.7,24.4 20.7,14.5 26.9,20.7 25.9,21.8 20.7,16.6 		"/>
                </g>
                <g>
                    <polygon
                        class="st2"
                        points="18,38.7 17.9,37.2 26.8,36.7 18.5,28.8 19.5,27.7 30.4,38 		"/>
                </g>
                <g>
                    <path
                        class="st2"
                        d="M36.2,16.9h-5.9V0.2h5.9V16.9z M31.8,15.4h2.9V1.7h-2.9V15.4z"/>
                </g>
            </g>
            <g
                id="Elastic_Motion"
                class="st0">
                <g class="st1">
                    <polygon
                        class="st2"
                        points="10.487,42.465 12.165,32.686 13.643,32.939 12.479,39.723 23.57,33.891 34.661,39.723 32.543,27.372
			41.514,18.626 29.115,16.824 23.57,5.588 18.025,16.824 5.627,18.626 9.427,22.331 8.38,23.405 2.403,17.58 17.029,15.453
			23.57,2.199 30.111,15.453 44.736,17.58 34.154,27.896 36.653,42.465 23.57,35.586 		"/>
                </g>
                <g class="st1">
                    <polygon
                        class="st2"
                        points="27.625,24.773 21.517,19.781 21.517,30.328 		"/>
                    <path
                        class="st2"
                        d="M21.017,31.457v-12.73l7.374,6.026L21.017,31.457z M22.017,20.835v8.362l4.843-4.403L22.017,20.835z"/>
                </g>
                <g class="st1">
                    <path
                        class="st2"
                        d="M1.951,42.773l-1.499-0.046c0.005-0.189,0.803-18.948,20.627-18.948v1.5
			C2.727,25.279,1.974,42.06,1.951,42.773z"/>
                </g>
            </g>
            <g
                id="Animal_Motion"
                class="st0">
                <g class="st1">
                    <path
                        d="M28.144,44.362c-0.387,0-0.719-0.013-0.869-0.025c-0.758-0.066-2.822-0.554-3.657-1.047
			c-0.198-0.116-0.487-0.256-0.804-0.41c-1.112-0.542-1.926-0.966-2.275-1.49c-0.208-0.312-0.286-0.634-0.295-0.927h-0.499
			c-0.397,0-1.489-0.262-2.214-0.867c-0.567-0.472-1.13-1.576-1.613-2.575l-0.122-0.25c-0.105-0.21-0.171-0.438-0.212-0.655
			c-1.973,1.342-4.754,1.157-5.573,1.065c-0.684-0.072-1.224,0.145-1.978,0.448c-0.395,0.158-0.815,0.327-1.294,0.471
			c-1.629,0.486-4.214,0.189-5.466-1.033c-1.254-1.225-1.323-2.68-0.975-3.278c0.104-0.179,0.505-0.77,1.278-0.873
			c0.639-0.084,1.299,0.194,1.951,0.834c0.778,0.763,1.213,0.666,2.589-0.047c1.387-0.719,2.576-0.754,3.953-0.795l0.29-0.01
			c1.116-0.035,2.159-0.427,3.101-1.165c0.912-0.715,1.374-1.281,1.593-1.957c0.343-1.057,1.638-3.712,2.229-4.806
			c0.613-1.136,1.763-4.023,2.097-5.787c0.321-1.69,2.208-3.77,3.817-5.392l0.356-0.365c0.489-0.507,1.229-1.273,1.417-1.768
			c0.264-0.696,0.618-1.505,1.498-2.3c0.416-0.375,1.35-1.963,2.031-3.122c0.376-0.639,0.734-1.249,1.031-1.713
			c0.927-1.45,1.809-1.751,2.453-1.971c0.092-0.031,0.182-0.062,0.27-0.096c0.636-0.25,3.528-1.579,3.861-1.746
			c0.308-0.155,0.635-0.161,0.915-0.022c0.095,0.047,0.173,0.104,0.239,0.167c0.198,0.057,0.328,0.171,0.404,0.258
			c0.383,0.443,0.153,0.961-0.031,1.377c-0.125,0.281-0.303,0.534-0.466,0.759c0.227,0.163,0.509,0.395,0.776,0.761
			c0.585,0.796,0.741,1.813,0.845,2.485l0.024,0.156c0.029,0.182,0.156,0.395,0.291,0.621c0.153,0.256,0.327,0.547,0.407,0.884
			c0.147,0.621-0.128,1.129-0.501,1.415c-0.839,1.358-2.336,1.296-2.99,1.271c-0.102-0.004-0.189-0.01-0.26-0.005
			c-0.141,0.008-0.305,0.044-0.445,0.086c0.302,0.759,0.478,1.667,0.613,2.366c0.052,0.268,0.094,0.49,0.133,0.631
			c0.029,0.107,0.077,0.283,1.049,0.21c1.082-0.081,3.54-0.812,4.08-1.007c0.027-0.054,0.064-0.135,0.094-0.2
			c0.114-0.255,0.271-0.604,0.566-0.92c0.352-0.378,0.876-0.547,1.442-0.466c0.571,0.083,1.077,0.409,1.289,0.831
			c0.284,0.568,0.422,1.514,0.089,2.348c-0.33,0.824-0.983,1.352-1.675,1.912c-0.844,0.683-7.803,3.342-7.87,3.367l-0.252,0.09
			c-0.508,0.178-1.14,0.4-1.474,0.813c-0.456,0.563-1.518,2.324-1.905,3.842c-0.44,1.73-2.085,4.573-2.409,4.979l-0.095,0.116
			c-0.066,0.078-0.176,0.21-0.193,0.265c1.278,1.924,1.396,4.26,0.329,6.223c-0.63,1.16-2.099,3.078-2.784,3.8
			c0.384,0.144,0.861,0.359,1.452,0.654c0.155,0.078,0.235,0.073,0.489,0.046c0.153-0.017,0.309-0.031,0.487-0.03
			c0.518,0,1.524,0.036,2,1.229c0.36,0.899,0.07,1.742-0.739,2.146C29.727,44.321,28.845,44.362,28.144,44.362z M21.162,38.963
			h1.264l-0.605,1.109c-0.029,0.058-0.134,0.335-0.034,0.485c0.177,0.239,1.195,0.735,1.684,0.974
			c0.359,0.175,0.687,0.336,0.91,0.468c0.56,0.33,2.369,0.786,3.024,0.844c0.605,0.051,1.663,0.006,1.993-0.044
			c0.035-0.041,0.034-0.103-0.014-0.223c-0.107-0.269-0.189-0.276-0.607-0.285c-0.147,0-0.235,0.011-0.322,0.021
			c-0.324,0.037-0.767,0.086-1.326-0.195c-1.107-0.553-1.556-0.688-1.725-0.72c-0.432-0.081-0.746-0.389-0.82-0.801
			c-0.105-0.582,0.313-1.198,0.618-1.438c0.27-0.265,1.907-2.255,2.612-3.553c0.801-1.473,0.705-3.236-0.254-4.719
			c-0.609-0.942,0.04-1.721,0.284-2.015l0.075-0.09c0.249-0.325,1.762-2.978,2.128-4.413c0.434-1.702,1.564-3.641,2.192-4.416
			c0.603-0.743,1.492-1.056,2.143-1.284l0.23-0.083c1.069-0.394,6.854-2.685,7.449-3.128c0.642-0.52,1.046-0.862,1.222-1.301
			c0.16-0.4,0.074-0.895-0.038-1.118c-0.026-0.003-0.233-0.046-0.296-0.011c-0.123,0.132-0.205,0.315-0.292,0.509
			c-0.145,0.321-0.323,0.721-0.763,0.921c-0.411,0.187-3.317,1.067-4.667,1.168c-1.021,0.077-2.246-0.002-2.606-1.304
			c-0.046-0.166-0.099-0.43-0.16-0.748c-0.14-0.722-0.352-1.813-0.689-2.433c-0.158-0.29-0.156-0.622,0.005-0.913
			c0.366-0.66,1.497-0.865,1.901-0.889c0.11-0.006,0.247-0.003,0.408,0.004c0.753,0.029,1.362,0.002,1.706-0.653l0.117-0.222
			l0.116-0.055c-0.046-0.107-0.126-0.241-0.204-0.372c-0.183-0.306-0.41-0.688-0.484-1.153l-0.025-0.164
			c-0.081-0.528-0.204-1.326-0.571-1.826c-0.192-0.263-0.394-0.399-0.588-0.531c-0.266-0.18-0.668-0.453-0.668-1
			c0-0.321,0.174-0.579,0.4-0.895c-1.025,0.474-2.6,1.188-3.087,1.38c-0.108,0.043-0.22,0.081-0.333,0.12
			c-0.529,0.181-1.029,0.351-1.674,1.359c-0.288,0.451-0.637,1.044-1.002,1.666c-1.047,1.779-1.773,2.982-2.319,3.474
			c-0.632,0.571-0.881,1.139-1.101,1.718c-0.297,0.784-1.097,1.613-1.74,2.279l-0.37,0.379c-0.774,0.781-3.132,3.159-3.409,4.615
			c-0.366,1.93-1.578,4.973-2.251,6.22c-0.636,1.178-1.839,3.688-2.121,4.556c-0.397,1.223-1.282,2.038-2.095,2.675
			c-1.198,0.939-2.537,1.438-3.979,1.484l-0.292,0.009c-1.291,0.038-2.224,0.066-3.308,0.628c-1.262,0.653-2.691,1.393-4.329-0.215
			c-0.338-0.331-0.59-0.432-0.701-0.417c-0.089,0.012-0.167,0.115-0.182,0.143c-0.005,0.065,0.01,0.747,0.728,1.449
			c0.738,0.72,2.713,1.053,3.987,0.668c0.432-0.129,0.81-0.282,1.165-0.425c0.849-0.342,1.65-0.661,2.703-0.547
			c1.447,0.16,3.427,0.014,4.653-0.878c0.43-0.312,1.229-0.891,1.856-0.437c0.291,0.211,0.417,0.574,0.337,0.947
			c-0.007,0.194,0.01,0.566,0.116,0.777l0.13,0.268c0.212,0.438,0.857,1.771,1.223,2.074c0.396,0.331,1.104,0.512,1.264,0.521
			H21.162z M36.111,1.733c0.004,0.019,0.009,0.037,0.015,0.053L36.111,1.733z"/>
                </g>
            </g>
            <g
                id="Human_Motion"
                class="st0">
                <g class="st1">
                    <path
                        d="M30.402,44.75c-1.562,0-2.887-1.118-3.151-2.658l-1.291-7.289l-5.444-1.877l-0.96,3.308l0.03,0.011l-0.468,1.386
			l-0.11-0.032c-0.371,0.546-0.906,0.97-1.535,1.201c-0.627,0.222-5.688,1.394-7.655,1.847l0.004,0.021l-1.456,0.291l-0.021-0.098
			C6.856,40.762,5.636,39.66,5.4,38.167c-0.284-1.797,0.894-3.436,2.614-3.727l5.747-1.356l1.795-6.336
			c-0.662,0.836-1.782,1.306-2.906,1.123c-0.878-0.14-1.594-0.58-2.078-1.248c-0.484-0.669-0.679-1.484-0.549-2.298l1.083-6.719
			c0.146-0.794,0.667-1.55,1.413-2.002l8.606-4.521c0.099-0.053,0.185-0.09,0.318-0.143c0.7-0.252,1.407-0.275,2.085-0.095
			L26.73,11.7c1.191,0.318,2.132,1.256,2.456,2.449l-0.007,0.002c0.114,0.407,0.397,1.76,1.49,7.11l4.189,2.564
			c0.659,0.403,1.122,1.039,1.303,1.791c0.181,0.75,0.058,1.526-0.346,2.186c-0.528,0.865-1.451,1.383-2.468,1.383
			c-0.534,0-1.056-0.147-1.51-0.427l-5.213-3.189l-0.624,2.338l4.007,1.45c0.918,0.361,1.603,1.094,1.897,2.017
			c0.151,0.429,1.256,6.871,1.723,9.619c0.145,0.842-0.047,1.69-0.54,2.39s-1.229,1.164-2.07,1.309
			C30.768,44.734,30.584,44.75,30.402,44.75z M19.515,30.994l7.768,2.678l1.446,8.162c0.158,0.918,1.058,1.556,1.961,1.392
			c0.521-0.089,0.911-0.336,1.174-0.707c0.262-0.372,0.364-0.824,0.287-1.272c-0.577-3.396-1.541-8.953-1.673-9.414
			c-0.158-0.494-0.521-0.884-0.999-1.071l-5.281-1.91l1.766-6.614l0.909,1.533c0.121,0.203,0.292,0.373,0.493,0.491l5.258,3.22
			c0.636,0.392,1.525,0.175,1.913-0.46c0.195-0.318,0.254-0.692,0.167-1.053v-0.001c-0.087-0.361-0.31-0.667-0.627-0.861L29.33,22.2
			l-0.064-0.319c-0.55-2.689-1.386-6.754-1.511-7.281l-0.016-0.057c-0.185-0.679-0.719-1.213-1.396-1.394l-3.202-0.854
			c-0.383-0.102-0.792-0.086-1.173,0.05c-0.047,0.019-0.09,0.036-0.142,0.063l-8.536,4.48c-0.377,0.229-0.645,0.618-0.728,1.063
			l-1.06,6.609c-0.067,0.418,0.033,0.838,0.283,1.182c0.249,0.344,0.617,0.57,1.037,0.638c0.146,0.022,0.231,0.029,0.316,0.029
			c0.783,0,1.441-0.562,1.564-1.336l0.919-5.757l4.231-2.238l-4.89,17.263L8.311,35.91c-0.96,0.164-1.585,1.034-1.441,1.948
			c0.156,0.993,1.01,1.62,1.932,1.48c2.91-0.666,7.677-1.78,8.162-1.951c0.43-0.158,0.784-0.499,0.966-0.935L19.515,30.994z
			 M16.985,20.292l-0.514,3.221l0.982-3.469L16.985,20.292z"/>
                </g>
                <g class="st1">
                    <path
                        d="M26.708,12.171c-3.287,0-5.961-2.674-5.961-5.961c0-3.287,2.674-5.96,5.961-5.96c3.286,0,5.96,2.674,5.96,5.96
			C32.668,9.498,29.994,12.171,26.708,12.171z M26.708,1.75c-2.46,0-4.461,2.001-4.461,4.46c0,2.46,2.001,4.461,4.461,4.461
			c2.459,0,4.46-2.001,4.46-4.461C31.168,3.751,29.167,1.75,26.708,1.75z"/>
                </g>
            </g>
            <g
                id="Animal"
                class="st0">
                <g class="st1">
                    <path
                        class="st2"
                        d="M39.61,44.048c-1.03,0-1.963-0.525-2.318-1.354c-0.225-0.521-0.173-1.065,0.123-1.521
			c-0.146,0.141-0.302,0.271-0.468,0.392c-0.75,0.546-2.31,1.682-4.021,0.998c-0.246-0.099-0.995-0.398-1.197-1.15
			c-0.216-0.806,0.311-1.564,0.969-2.402l0.157-0.199c0.794-1.008,1.479-1.877,1.678-2.868c0.225-1.125-0.262-2.237-0.776-3.414
			c-0.122-0.277-0.242-0.553-0.352-0.826c-0.722-1.789-1.206-3.337-1.221-5.075c-0.001-0.255-0.002-0.429-0.039-0.535
			c-0.171-0.23-1.307-0.439-1.734-0.519c-0.143-0.026-0.277-0.052-0.398-0.076c-0.698,0.37-2.732,1.412-5.128,2.302
			c-1.305,0.485-2.708,0.98-4.164,1.338l-0.399,0.984c-0.057,0.141-0.012,0.387,0.035,0.648l0.258,1.706
			c0.172,1.19,0.336,2.382,0.479,3.575l0.065,0.521c0.106,0.822,0.215,1.672,0.17,2.528c-0.093,1.775-0.698,2.566-2.231,2.919
			c-0.111,0.026-0.24,0.064-0.38,0.104c-0.831,0.241-2.222,0.646-2.994-0.413c-0.034-0.047-0.065-0.095-0.093-0.145
			c-0.457,0.445-1.072,0.738-1.75,0.8l-0.173,0.016c-0.817,0.077-1.834,0.174-2.7-0.254c-0.642-0.317-0.988-0.97-0.925-1.746
			c0.071-0.881,0.646-1.657,1.399-1.889c0.161-0.049,0.328-0.073,0.496-0.092c0.081-0.01,0.203-0.023,0.237-0.04
			c0.022-0.015,0.085-0.105,0.118-0.273c0.215-1.104,0.139-2.354,0.066-3.563l-0.032-0.538c-0.081-1.462-0.199-2.73-0.36-3.878
			l-0.024-0.173c-0.051-0.374-0.099-0.727-0.202-1.034c-0.288-0.863-1.359-4.912-1.359-7.417c0-1.179,0.045-2.468,0.143-4.057
			c0.005-0.087,0.011-0.176,0.004-0.225c-0.041-0.283-0.296-0.734-0.682-1.207c-0.23-0.282-0.6-0.632-1.054-0.7
			c-0.412-0.064-0.881,0.055-1.515,0.378c-0.125,0.064-0.259,0.149-0.4,0.237c-0.487,0.304-1.103,0.681-1.766,0.646
			c-0.201-0.012-0.4-0.056-0.599-0.105c-0.093-0.023-0.186-0.047-0.279-0.06c-0.423-0.055-0.853-0.111-1.275-0.295
			C1.862,15.603,1.01,14.5,0.604,12.994l-0.052-0.185c-0.07-0.25-0.151-0.533-0.184-0.833c-0.058-0.528,0.083-1.007,0.408-1.384
			c0.768-0.891,2.355-0.95,3.304-0.985l0.015,0L5.14,8.588C6.043,7.709,6.947,6.83,7.839,5.938C7.87,5.84,7.745,5.516,7.685,5.36
			c-0.22-0.571-0.288-1.025-0.234-1.574c0.131-1.367,0.866-2.277,1.968-2.434c1.132-0.161,1.53,0.671,1.791,1.222
			c0.078,0.164,0.164,0.347,0.278,0.538c0.115,0.192,0.256,0.463,0.429,0.799c0.565,1.095,1.511,2.926,3.125,4.789
			c2.074,2.394,4.584,5.291,6.751,5.963c2.345,0.728,2.848,0.793,6.724,0.874c7.373,0.153,10.668,0.021,11.306-0.145
			c0.21-0.224,0.425-0.987,0.52-1.325c0.048-0.168,0.091-0.323,0.133-0.45l0.033-0.102c0.317-0.965,0.646-1.963,0.735-2.936
			c0.074-0.784,0.512-1.441,1.116-1.677c0.544-0.214,1.149-0.07,1.661,0.391c1.133,1.019,1.032,3.399,0.362,5.12
			c-0.491,1.263-1.119,2.471-1.727,3.639l-0.004,0.009c0.912,1.47,2.103,3.998,1.603,6.617c-0.137,0.721-0.402,1.508-0.659,2.27
			c-0.381,1.128-0.774,2.294-0.73,3.163c0.06,1.204,0.399,2.362,0.758,3.588c0.409,1.396,0.832,2.841,0.83,4.4
			c-0.003,2.515-1.37,5.437-4.365,5.91C39.929,44.036,39.769,44.048,39.61,44.048z M38.734,31.709c0.104,0,0.21,0.022,0.309,0.066
			c0.871,0.394,1.44,1.639,1.739,3.807c0.176,1.288,0.089,2.644-0.251,3.921c-0.328,1.231-0.512,1.447-1.395,2.109l-0.358,0.271
			c-0.152,0.117-0.129,0.171-0.108,0.218c0.104,0.241,0.575,0.525,1.185,0.427c2.126-0.336,3.098-2.531,3.1-4.43
			c0.001-1.344-0.373-2.623-0.77-3.977c-0.367-1.256-0.748-2.554-0.816-3.935c-0.058-1.154,0.382-2.457,0.807-3.718
			c0.252-0.747,0.49-1.452,0.608-2.071c0.444-2.334-0.824-4.686-1.62-5.879c-0.151-0.227-0.168-0.519-0.042-0.761l0.206-0.396
			c0.588-1.133,1.196-2.304,1.658-3.492c0.558-1.432,0.474-3.064,0.032-3.461c-0.084-0.076-0.14-0.1-0.154-0.103
			c0.011,0.013-0.102,0.157-0.125,0.414c-0.106,1.14-0.461,2.22-0.804,3.264l-0.033,0.102c-0.036,0.109-0.073,0.243-0.114,0.388
			c-0.214,0.763-0.48,1.712-1.133,2.177c-0.304,0.217-0.875,0.621-12.168,0.387c-3.989-0.083-4.656-0.171-7.137-0.941
			c-2.576-0.799-5.13-3.747-7.383-6.347c-1.789-2.064-2.786-3.996-3.382-5.15c-0.155-0.3-0.28-0.543-0.383-0.715
			c-0.142-0.237-0.25-0.463-0.347-0.667C9.781,3.063,9.681,2.852,9.629,2.802C9.117,2.911,8.98,3.553,8.944,3.93
			c-0.03,0.314,0.004,0.538,0.138,0.884C9.278,5.324,9.639,6.259,8.9,6.999C8.003,7.896,7.095,8.779,6.186,9.663l-1.158,1.128
			c-0.055,0.053-0.162,0.157-0.326,0.227c-0.162,0.069-0.309,0.076-0.38,0.08l-0.186,0.007c-0.563,0.021-1.883,0.07-2.224,0.466
			c-0.026,0.031-0.07,0.082-0.053,0.239c0.022,0.198,0.082,0.396,0.136,0.59l0.057,0.203c0.165,0.612,0.585,1.701,1.547,2.118
			c0.229,0.1,0.519,0.137,0.827,0.177c0.192,0.025,0.34,0.06,0.488,0.097c0.108,0.026,0.215,0.058,0.323,0.063
			c0.178,0.018,0.613-0.248,0.888-0.419c0.181-0.113,0.354-0.22,0.514-0.301c0.577-0.295,1.458-0.671,2.418-0.525
			c0.734,0.109,1.423,0.537,1.994,1.235c0.401,0.491,0.901,1.227,1.004,1.94c0.029,0.203,0.018,0.386,0.009,0.533
			c-0.096,1.557-0.14,2.817-0.14,3.964c0,2.144,0.929,5.883,1.282,6.942c0.147,0.44,0.209,0.9,0.265,1.306l0.023,0.167
			c0.167,1.189,0.289,2.5,0.373,4.004l0.031,0.53c0.075,1.241,0.161,2.648-0.091,3.94c-0.12,0.617-0.46,1.104-0.933,1.334
			c-0.264,0.129-0.518,0.158-0.722,0.182c-0.077,0.01-0.155,0.014-0.229,0.036c-0.144,0.045-0.321,0.3-0.344,0.576
			c-0.012,0.149,0.02,0.243,0.095,0.281c0.484,0.238,1.232,0.169,1.893,0.104l0.179-0.017c0.556-0.05,1.017-0.412,1.148-0.899
			c0.117-0.432,0.128-0.931,0.142-1.458c0.005-0.204,0.01-0.406,0.021-0.604l0.397-7.286c0.021-0.37,0.308-0.67,0.678-0.706
			c0.359-0.036,0.708,0.204,0.799,0.564l1.084,4.33c0.186,0.742,0.377,1.509,0.4,2.328c0.028,0.993-0.213,1.875-0.698,2.551
			c-0.11,0.153-0.235,0.297-0.36,0.439c-0.118,0.135-0.24,0.268-0.332,0.421c-0.078,0.131-0.092,0.254-0.082,0.288
			c0.144,0.191,0.994-0.053,1.357-0.157c0.169-0.049,0.325-0.094,0.46-0.125c0.688-0.159,1.001-0.23,1.07-1.536
			c0.038-0.722-0.063-1.503-0.16-2.259l-0.067-0.534c-0.141-1.182-0.304-2.361-0.474-3.538l-0.25-1.654
			c-0.075-0.416-0.169-0.936,0.051-1.479l0.506-1.248c0.031-0.076,0.111-0.271,0.317-0.418c0.079-0.056,0.237-0.123,0.331-0.146
			c1.483-0.344,2.932-0.854,4.276-1.354c2.804-1.041,5.157-2.333,5.181-2.346c0.172-0.096,0.372-0.118,0.56-0.067
			c0.147,0.04,0.351,0.076,0.58,0.119c1.063,0.195,2.519,0.464,2.88,1.501c0.119,0.344,0.12,0.68,0.122,0.948
			c0.013,1.568,0.454,2.963,1.111,4.594c0.105,0.26,0.22,0.521,0.335,0.785c0.559,1.276,1.19,2.723,0.873,4.311
			c-0.269,1.343-1.096,2.392-1.971,3.501l-0.155,0.198c-0.54,0.688-0.68,0.973-0.694,1.09l0,0c0.02,0,0.102,0.064,0.3,0.144
			c0.784,0.311,1.568-0.082,2.581-0.818c0.604-0.438,1.265-1.211,1.597-3.621c0.205-1.49,0.314-2.93,0.323-4.277
			c0.002-0.254,0.132-0.489,0.346-0.627C38.452,31.749,38.593,31.709,38.734,31.709z M39.292,35.755
			c-0.042,0.391-0.09,0.784-0.145,1.182c-0.238,1.729-0.655,2.935-1.34,3.803c0.019-0.015,0.037-0.03,0.057-0.045l0.373-0.282
			c0.624-0.468,0.624-0.468,0.845-1.296c0.289-1.086,0.363-2.237,0.214-3.33C39.295,35.775,39.293,35.766,39.292,35.755z
			 M16.682,35.673l-0.126,2.32c-0.01,0.183-0.015,0.369-0.019,0.559c-0.002,0.073-0.003,0.146-0.006,0.22
			c0.34-0.506,0.398-1.14,0.386-1.588C16.902,36.69,16.801,36.179,16.682,35.673z"/>
                </g>
            </g>
            <g
                id="Vehicle"
                class="st0">
                <g class="st1">
                    <path
                        class="st2"
                        d="M42.943,30.11c-0.005,0-0.009,0-0.015,0l-5.361-0.044l0.012-1.5l5.361,0.044
			c0.133-0.004,0.246-0.048,0.337-0.138c0.09-0.09,0.14-0.208,0.14-0.335v-6.52c0-0.258-0.202-0.465-0.46-0.473l-9.592-0.264
			l-6.623-8.887H13.918l-6.432,8.475l-5.232,0.582c-0.245,0.027-0.425,0.232-0.42,0.478l0.125,6.575
			c0.005,0.256,0.217,0.463,0.472,0.463h7.233v1.5H2.431c-1.067,0-1.952-0.867-1.972-1.934l-0.125-6.575
			c-0.02-1.025,0.734-1.884,1.754-1.998l4.593-0.51l6.492-8.555h14.321l6.639,8.907l8.866,0.244c1.076,0.03,1.918,0.896,1.918,1.972
			v6.52c0,0.529-0.207,1.026-0.583,1.399C43.962,29.907,43.467,30.11,42.943,30.11z"/>
                </g>
                <g class="st1">
                    <rect
                        x="17.311"
                        y="28.566"
                        class="st2"
                        width="12.71"
                        height="1.5"/>
                </g>
                <g class="st1">
                    <path
                        class="st2"
                        d="M13.631,33.698c-2.495,0-4.525-2.029-4.525-4.524s2.03-4.525,4.525-4.525s4.525,2.03,4.525,4.525
			S16.126,33.698,13.631,33.698z M13.631,26.148c-1.668,0-3.025,1.357-3.025,3.025s1.357,3.024,3.025,3.024s3.025-1.356,3.025-3.024
			S15.299,26.148,13.631,26.148z"/>
                </g>
                <g class="st1">
                    <path
                        class="st2"
                        d="M33.797,33.698c-2.495,0-4.525-2.029-4.525-4.524s2.03-4.525,4.525-4.525s4.525,2.03,4.525,4.525
			S36.292,33.698,33.797,33.698z M33.797,26.148c-1.668,0-3.025,1.357-3.025,3.025s1.357,3.024,3.025,3.024s3.025-1.356,3.025-3.024
			S35.465,26.148,33.797,26.148z"/>
                </g>
            </g>
            <g
                id="Architecture"
                class="st0">
                <g class="st1">
                    <path
                        class="st2"
                        d="M42.479,44.667H2.5V8.205h3.564V3.282h4.763V0.445h4.436v2.837h4.763v4.923h3.564v9.512h2.943v-4.993h4.155
			v-2.692h4.437v2.692h4.155v4.993h3.197V44.667z M4,43.167h36.979v-23.95h-3.197v-4.993h-4.155v-2.692h-1.437v2.692h-4.155v4.993
			h-5.943V9.705h-3.564V4.782h-4.763V1.945h-1.436v2.837H7.564v4.923H4V43.167z"/>
                </g>
            </g>
            <g
                id="Outfit"
                class="st0">
                <g class="st1">
                    <path
                        class="st2"
                        d="M41.437,44.917h-8.441l-2.419-5.498l-2.419,5.498h-8.441l-0.878-12.25l1.496-0.107l0.778,10.857h6.066
			l2.497-5.676c0.158-0.357,0.511-0.587,0.9-0.587s0.742,0.229,0.899,0.585l2.498,5.678h6.066l1.108-15.485L38.9,22.098H27.279v-1.5
			h12.65l2.738,7.107L41.437,44.917z"/>
                </g>
                <g class="st1">
                    <path
                        class="st2"
                        d="M28.896,32.911H6.909l1.175-15.385l-5.419-3.263L6.953,2.92l0.336-0.113c0.042-0.015,4.266-1.44,6.435-2.107
			l0.819-0.252l0.142,0.845c0.375,2.234,3.055,2.179,3.166,2.175c0.171,0.006,3.029,0.08,3.219-2.115l0.08-0.921l0.885,0.268
			c1.115,0.338,6.31,2.24,6.531,2.321l0.325,0.119l4.305,11.595l-5.42,2.821L28.896,32.911z M8.528,31.411h18.755L26.206,16.68
			l5.121-2.665L27.724,4.31c-0.963-0.352-3.829-1.396-5.346-1.917c-0.721,2.129-3.195,2.628-4.532,2.574
			c-1.215,0.046-3.591-0.465-4.417-2.603c-1.832,0.581-4.41,1.444-5.323,1.751l-3.594,9.508l5.14,3.095L8.528,31.411z"/>
                </g>
            </g>
            <g
                id="Weapon"
                class="st0">
                <g class="st1">
                    <path
                        class="st2"
                        d="M35,14.8l-5.8-5.5l8.4-8.9l5.8,5.5L35,14.8z M31.2,9.2l3.7,3.5l6.4-6.7l-3.7-3.5L31.2,9.2z"/>
                </g>
                <g class="st1">
                    <path
                        class="st2"
                        d="M35.4,23.3L20.5,9.3l5.1-5.3L40.4,18L35.4,23.3z M22.7,9.2l12.6,12l3-3.2l-12.6-12L22.7,9.2z"/>
                </g>
                <g class="st1">
                    <polygon
                        class="st2"
                        points="8.8,44.7 1.2,44.6 0.9,36.8 24,12.2 25.1,13.2 2.4,37.4 2.6,43.1 8.2,43.2 31.3,18.9 32.4,20 		"/>
                </g>
                <g class="st1">

                    <rect
                        x="8.8"
                        y="23.7"
                        transform="matrix(0.6876 -0.7261 0.7261 0.6876 -11.4066 22.3409)"
                        class="st2"
                        width="22.8"
                        height="1.5"/>
                </g>
            </g>
            <g
                id="Food"
                class="st0">
                <g class="st1">
                    <g>
                        <g>
                            <g>
                                <path
                                    d="M22.9,14.4c-2.4,0-4.4-2-4.4-4.4c0-0.8,0.2-1.6,0.6-2.3l3.8-6.5l3.8,6.5c0.4,0.7,0.6,1.5,0.6,2.2
						C27.3,12.5,25.3,14.4,22.9,14.4z M22.9,4.3l-2.5,4.3C20.2,9,20,9.5,20,10.1c0,1.6,1.3,2.9,2.9,2.9s2.9-1.3,2.9-2.9
						c0-0.5-0.1-1-0.4-1.5L22.9,4.3z"/>
                            </g>
                            <g>
                                <path
                                    d="M10.1,32.2c-2.4,0-4.3-1.9-4.3-4.3v-2.8c0-3.4,2.8-6.2,6.2-6.2h8.4v-3.6h5.1v3.6h8.3c3.4,0,6.2,2.8,6.2,6.2v2.8
						c0,2.4-1.9,4.3-4.3,4.3c-1.2,0-2.2-0.5-3.1-1.3l-3.4-3.3L26,30.9c-1.7,1.7-4.4,1.7-6.1,0l-3.4-3.3l-3.4,3.4
						C12.3,31.8,11.3,32.2,10.1,32.2z M12,20.4c-2.6,0-4.7,2.1-4.7,4.7v2.8c0,1.6,1.3,2.8,2.8,2.8c0.8,0,1.5-0.3,2-0.8l4.4-4.4
						l4.4,4.4c1.1,1.1,2.9,1.1,4,0l4.4-4.4l4.4,4.4c0.5,0.5,1.2,0.8,2,0.8c1.6,0,2.8-1.3,2.8-2.8v-2.8c0-2.6-2.1-4.7-4.7-4.7H24
						v-3.6h-2.1v3.6H12z"/>
                            </g>
                            <g>
                                <path
                                    d="M37.5,44H8.4c-1.4,0-2.6-1.2-2.6-2.6v-9.8L7,32.4c0.9,0.6,2,1,3.1,1c1.5,0,2.9-0.6,3.9-1.6l2.5-2.5l2.5,2.5
						c2.1,2.1,5.8,2.1,7.8,0l2.5-2.5l2.5,2.5c1,1,2.4,1.6,3.9,1.6c1.1,0,2.2-0.3,3.1-1l1.2-0.8v9.8C40,42.9,38.9,44,37.5,44z
						 M7.3,34.3v7.1c0,0.6,0.5,1.1,1.1,1.1h29.1c0.6,0,1.1-0.5,1.1-1.1v-7.1c-0.9,0.4-1.8,0.6-2.8,0.6c-1.9,0-3.6-0.7-5-2.1
						l-1.4-1.4l-1.4,1.4c-2.7,2.7-7.3,2.7-10,0l-1.4-1.4l-1.4,1.4c-1.3,1.3-3.1,2.1-5,2.1C9.1,34.9,8.2,34.7,7.3,34.3z"/>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
            <g
                id="rltv_black"
                class="st0">
                <g class="st1">
                    <path
                        style="fill:#393939;"
                        d="M0,0.2h3.8c2.1,0,3.5,0.2,4.4,0.6c0.9,0.4,1.6,1,2.1,1.8c0.5,0.9,0.8,1.9,0.8,3c0,1.2-0.3,2.3-0.9,3.1
			c-0.6,0.8-1.5,1.5-2.7,1.9l4.4,8.3H8.1L3.9,11H3.6v7.9H0V0.2z M3.6,7.5h1.1C5.8,7.5,6.6,7.3,7,7s0.6-0.8,0.6-1.5
			c0-0.4-0.1-0.8-0.3-1.1S6.9,4,6.5,3.8s-1-0.2-2-0.2h-1V7.5z"/>
                    <path
                        style="fill:#393939;"
                        d="M14.9,0.2h10.2v3.5h-6.7V7h6.7v3.4h-6.7v4.9h6.7v3.5H14.9V0.2z"/>
                    <path
                        style="fill:#393939;"
                        d="M34.1,0.2h3.6l7.2,18.7h-3.7L39.8,15h-7.6l-1.5,3.9h-3.7L34.1,0.2z M35.9,5.1l-2.5,6.4h5L35.9,5.1z"/>
                    <path
                        style="fill:#393939;"
                        d="M47.7,0.2h3.6v15.3h5.2v3.4h-8.7V0.2z"/>
                    <path
                        style="fill:#393939;"
                        d="M59.1,0.2h3.6v15.3h5.2v3.4h-8.7V0.2z"/>
                    <path
                        style="fill:#393939;"
                        d="M70.4,0.2H74v12.1c0,1,0.1,1.8,0.3,2.2c0.2,0.4,0.5,0.8,0.9,1c0.4,0.3,0.9,0.4,1.5,0.4c0.6,0,1.2-0.1,1.6-0.4
			c0.5-0.3,0.8-0.7,0.9-1.1s0.3-1.3,0.3-2.5V0.2h3.6v11.1c0,1.9-0.1,3.2-0.3,3.9c-0.2,0.7-0.6,1.4-1.2,2.1c-0.6,0.7-1.3,1.2-2.1,1.5
			s-1.7,0.5-2.7,0.5c-1.4,0-2.5-0.3-3.5-0.9c-1-0.6-1.7-1.4-2.2-2.3c-0.4-0.9-0.6-2.5-0.6-4.7V0.2z"/>
                    <path
                        style="fill:#393939;"
                        d="M97,2.7L94.4,5c-0.9-1.3-1.9-1.9-2.8-1.9c-0.5,0-0.8,0.1-1.1,0.4S90,4,90,4.3c0,0.3,0.1,0.6,0.3,0.9
			c0.3,0.4,1.2,1.2,2.6,2.4c1.4,1.1,2.2,1.9,2.5,2.1c0.7,0.7,1.2,1.4,1.5,2.1c0.3,0.7,0.5,1.4,0.5,2.2c0,1.5-0.5,2.8-1.6,3.8
			c-1.1,1-2.4,1.5-4.1,1.5c-1.3,0-2.5-0.3-3.5-1c-1-0.7-1.8-1.7-2.5-3.1l3-1.8c0.9,1.7,1.9,2.5,3.1,2.5c0.6,0,1.1-0.2,1.5-0.5
			c0.4-0.4,0.6-0.8,0.6-1.2c0-0.4-0.2-0.8-0.5-1.3c-0.3-0.4-1-1.1-2.1-1.9c-2-1.7-3.4-2.9-3.9-3.8c-0.6-0.9-0.9-1.8-0.9-2.7
			C86.5,3.1,87,2,88,1.1c1-0.9,2.2-1.4,3.7-1.4c0.9,0,1.8,0.2,2.7,0.6S96,1.6,97,2.7z"/>
                    <path
                        style="fill:#393939;"
                        d="M100.5,0.2h3.5v18.7h-3.5V0.2z"/>
                    <path
                        style="fill:#393939;"
                        d="M116.9-0.3c2.6,0,4.9,1,6.8,2.9c1.9,1.9,2.9,4.2,2.9,7c0,2.7-0.9,5-2.8,6.9c-1.9,1.9-4.2,2.8-6.8,2.8
			c-2.8,0-5.1-1-7-2.9c-1.9-1.9-2.8-4.2-2.8-6.9c0-1.8,0.4-3.4,1.3-4.9c0.9-1.5,2.1-2.7,3.6-3.6S115.1-0.3,116.9-0.3z M116.8,3.2
			c-1.7,0-3.2,0.6-4.4,1.8c-1.2,1.2-1.8,2.7-1.8,4.6c0,2.1,0.7,3.7,2.2,4.9c1.2,0.9,2.5,1.4,4,1.4c1.7,0,3.1-0.6,4.3-1.8
			c1.2-1.2,1.8-2.7,1.8-4.5c0-1.8-0.6-3.3-1.8-4.5S118.5,3.2,116.8,3.2z"/>
                    <path
                        style="fill:#393939;"
                        d="M129.9,0.2h3.4l8,12.3V0.2h3.6v18.7h-3.4l-8-12.3v12.3h-3.6V0.2z"/>
                    <path
                        style="fill:#36A6E9;"
                        d="M147.4,2V0.2h10.2V2h-4.2v16.9h-1.9V2H147.4z"/>
                    <path
                        style="fill:#36A6E9;"
                        d="M158.9,0.2h2l6.2,14.4l6.3-14.4h2l-8.1,18.7h-0.4L158.9,0.2z"/>
                </g>
            </g>
            <g
                id="rltv_white"
                class="st0">
                <g class="st1">
                    <path
                        style="fill:#FFFFFF;"
                        d="M0,0.2h3.8c2.1,0,3.5,0.2,4.4,0.6c0.9,0.4,1.6,1,2.1,1.8c0.5,0.9,0.8,1.9,0.8,3c0,1.2-0.3,2.3-0.9,3.1
			c-0.6,0.8-1.5,1.5-2.7,1.9l4.4,8.3H8.1L3.9,11H3.6v7.9H0V0.2z M3.6,7.5h1.1C5.8,7.5,6.6,7.3,7,7s0.6-0.8,0.6-1.5
			c0-0.4-0.1-0.8-0.3-1.1S6.9,4,6.5,3.8s-1-0.2-2-0.2h-1V7.5z"/>
                    <path
                        style="fill:#FFFFFF;"
                        d="M14.9,0.2h10.2v3.5h-6.7V7h6.7v3.4h-6.7v4.9h6.7v3.5H14.9V0.2z"/>
                    <path
                        style="fill:#FFFFFF;"
                        d="M34.1,0.2h3.6l7.2,18.7h-3.7L39.8,15h-7.6l-1.5,3.9h-3.7L34.1,0.2z M35.9,5.1l-2.5,6.4h5L35.9,5.1z"/>
                    <path
                        style="fill:#FFFFFF;"
                        d="M47.7,0.2h3.6v15.3h5.2v3.4h-8.7V0.2z"/>
                    <path
                        style="fill:#FFFFFF;"
                        d="M59.1,0.2h3.6v15.3h5.2v3.4h-8.7V0.2z"/>
                    <path
                        style="fill:#FFFFFF;"
                        d="M70.4,0.2H74v12.1c0,1,0.1,1.8,0.3,2.2c0.2,0.4,0.5,0.8,0.9,1c0.4,0.3,0.9,0.4,1.5,0.4
			c0.6,0,1.2-0.1,1.6-0.4c0.5-0.3,0.8-0.7,0.9-1.1s0.3-1.3,0.3-2.5V0.2h3.6v11.1c0,1.9-0.1,3.2-0.3,3.9c-0.2,0.7-0.6,1.4-1.2,2.1
			c-0.6,0.7-1.3,1.2-2.1,1.5s-1.7,0.5-2.7,0.5c-1.4,0-2.5-0.3-3.5-0.9c-1-0.6-1.7-1.4-2.2-2.3c-0.4-0.9-0.6-2.5-0.6-4.7V0.2z"/>
                    <path
                        style="fill:#FFFFFF;"
                        d="M97,2.7L94.4,5c-0.9-1.3-1.9-1.9-2.8-1.9c-0.5,0-0.8,0.1-1.1,0.4S90,4,90,4.3c0,0.3,0.1,0.6,0.3,0.9
			c0.3,0.4,1.2,1.2,2.6,2.4c1.4,1.1,2.2,1.9,2.5,2.1c0.7,0.7,1.2,1.4,1.5,2.1c0.3,0.7,0.5,1.4,0.5,2.2c0,1.5-0.5,2.8-1.6,3.8
			c-1.1,1-2.4,1.5-4.1,1.5c-1.3,0-2.5-0.3-3.5-1c-1-0.7-1.8-1.7-2.5-3.1l3-1.8c0.9,1.7,1.9,2.5,3.1,2.5c0.6,0,1.1-0.2,1.5-0.5
			c0.4-0.4,0.6-0.8,0.6-1.2c0-0.4-0.2-0.8-0.5-1.3c-0.3-0.4-1-1.1-2.1-1.9c-2-1.7-3.4-2.9-3.9-3.8c-0.6-0.9-0.9-1.8-0.9-2.7
			C86.5,3.1,87,2,88,1.1c1-0.9,2.2-1.4,3.7-1.4c0.9,0,1.8,0.2,2.7,0.6S96,1.6,97,2.7z"/>
                    <path
                        style="fill:#FFFFFF;"
                        d="M100.5,0.2h3.5v18.7h-3.5V0.2z"/>
                    <path
                        style="fill:#FFFFFF;"
                        d="M116.9-0.3c2.6,0,4.9,1,6.8,2.9c1.9,1.9,2.9,4.2,2.9,7c0,2.7-0.9,5-2.8,6.9c-1.9,1.9-4.2,2.8-6.8,2.8
			c-2.8,0-5.1-1-7-2.9c-1.9-1.9-2.8-4.2-2.8-6.9c0-1.8,0.4-3.4,1.3-4.9c0.9-1.5,2.1-2.7,3.6-3.6S115.1-0.3,116.9-0.3z M116.8,3.2
			c-1.7,0-3.2,0.6-4.4,1.8c-1.2,1.2-1.8,2.7-1.8,4.6c0,2.1,0.7,3.7,2.2,4.9c1.2,0.9,2.5,1.4,4,1.4c1.7,0,3.1-0.6,4.3-1.8
			c1.2-1.2,1.8-2.7,1.8-4.5c0-1.8-0.6-3.3-1.8-4.5S118.5,3.2,116.8,3.2z"/>
                    <path
                        style="fill:#FFFFFF;"
                        d="M129.9,0.2h3.4l8,12.3V0.2h3.6v18.7h-3.4l-8-12.3v12.3h-3.6V0.2z"/>
                    <path
                        style="fill:#36A6E9;"
                        d="M147.4,2V0.2h10.2V2h-4.2v16.9h-1.9V2H147.4z"/>
                    <path
                        style="fill:#36A6E9;"
                        d="M158.9,0.2h2l6.2,14.4l6.3-14.4h2l-8.1,18.7h-0.4L158.9,0.2z"/>
                </g>
            </g>
            <g id="other">
                <g>
                    <g>
                        <circle
                            class="st2"
                            cx="10.5"
                            cy="17.1"
                            r="1.3"/>
                    </g>
                    <g>
                        <circle
                            class="st2"
                            cx="17"
                            cy="17.1"
                            r="1.3"/>
                    </g>
                    <g>
                        <circle
                            class="st2"
                            cx="23.5"
                            cy="17.1"
                            r="1.3"/>
                    </g>
                </g>
                <g>
                    <path
                        class="st2"
                        d="M17,30.9c-7.6,0-13.8-6.2-13.8-13.8C3.2,9.5,9.4,3.3,17,3.3c7.6,0,13.8,6.2,13.8,13.8
                        C30.8,24.7,24.6,30.9,17,30.9z M17,4.8c-6.8,0-12.3,5.5-12.3,12.3c0,6.8,5.5,12.3,12.3,12.3c6.8,0,12.3-5.5,12.3-12.3
                        C29.3,10.3,23.8,4.8,17,4.8z"/>
                </g>
            </g>
            <g id="Tool">
                <g>
                    <g>
                        <g>
                            <path
                                class="st9"
                                d="M35.1,43.4c-4.2,0-7.8-3.3-8.1-7.6l0-0.5c0-0.8,0.1-1.6,0.4-2.4L12.9,18.5c-0.8,0.2-1.6,0.4-2.3,0.4
					L10,18.8c-4.2-0.3-7.5-3.8-7.5-8.1c0-1.2,0.3-2.4,0.8-3.5l0.5-1l5.1,5.1c0.2,0.2,0.4,0.3,0.6,0.4c0.7,0.3,1.3,0.1,1.8-0.4
					c0.5-0.5,0.6-1.2,0.4-1.8c-0.1-0.2-0.2-0.4-0.4-0.6L6.1,3.9l1-0.5c1.1-0.5,2.3-0.8,3.5-0.8c4.2,0,7.8,3.3,8.1,7.6l0,0.5
					c0,0.8-0.1,1.6-0.4,2.4l14.5,14.5c0.8-0.2,1.6-0.4,2.3-0.4l0.6,0.1c4.2,0.3,7.6,3.8,7.6,8.1c0,1.2-0.3,2.4-0.8,3.5L42,39.7
					l-5.2-5.1c-0.2-0.2-0.4-0.3-0.6-0.4c-0.7-0.3-1.4-0.1-1.8,0.4c-0.5,0.5-0.6,1.2-0.4,1.8c0.1,0.2,0.2,0.5,0.4,0.6l5.3,5.1l-1,0.5
					C37.5,43.1,36.3,43.4,35.1,43.4z M13.3,16.8l15.8,15.8L28.9,33c-0.3,0.8-0.4,1.5-0.4,2.3l0,0.4c0.2,3.5,3.1,6.2,6.6,6.2
					c0.6,0,1.2-0.1,1.8-0.3l-3.7-3.5c-0.3-0.3-0.6-0.7-0.7-1.2c-0.4-1.2-0.2-2.5,0.7-3.4c0.8-0.8,2.1-1.2,3.4-0.7
					c0.5,0.2,0.8,0.4,1.2,0.7l3.7,3.5c0.2-0.6,0.3-1.2,0.3-1.8c0-3.4-2.7-6.3-6.2-6.6L35,28.7c-0.7,0-1.4,0.1-2.2,0.4l-0.5,0.2
					L16.6,13.5l0.2-0.5c0.3-0.8,0.4-1.5,0.4-2.3l0-0.4c-0.2-3.5-3.1-6.2-6.6-6.2c-0.6,0-1.2,0.1-1.8,0.3l3.6,3.5
					c0.3,0.3,0.6,0.7,0.7,1.2c0.4,1.2,0.1,2.5-0.7,3.4c-0.9,0.9-2.1,1.2-3.4,0.7c-0.5-0.2-0.8-0.4-1.2-0.7L4.2,8.9
					C4,9.5,3.9,10.1,3.9,10.7c0,3.4,2.7,6.3,6.2,6.6l0.5,0.1c0.7,0,1.4-0.1,2.2-0.4L13.3,16.8z"/>
                        </g>
                    </g>
                </g>
            </g>
            <g
                id="User_Story"
                class="st0">
                <g class="st1">
                    <polygon
                        class="st26"
                        points="22.9,24.8 21.4,25.7 19.8,26.7 19.8,24.8 19.8,23 21.4,23.9 		"/>
                </g>
                <g class="st1">
                    <path
                        class="st26"
                        d="M15.1,16.2c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S18.4,16.2,15.1,16.2z M15.1,5.2c-2.7,0-5,2.2-5,5
			s2.2,5,5,5s5-2.2,5-5S17.9,5.2,15.1,5.2z"/>
                </g>
                <g class="st1">
                    <path
                        class="st26"
                        d="M13.4,29.2H7v-4.7c0.3-2.4,1.8-4.5,4.1-5.7l0.5,0.9c-2,1-3.3,2.9-3.5,4.9v3.6h5.4v1L13.4,29.2z"/>
                </g>
                <g class="st1">
                    <path
                        class="st26"
                        d="M27.9,29.2H14.8v-8.8h13.1L27.9,29.2z M15.8,28.2h11.1v-6.8H15.8V28.2z"/>
                </g>
            </g>
            <g
                id="3dx"
                class="st0">
                <g class="st1">
                    <path
                        class="st2"
                        d="M3.4,27.6l8.5-10.2l0.3,2.8c0.9-0.4,2.5-1.6,2.4-4.1c-0.1-2.9-4.3-6.3-9.6-6.3H4.9h-4l3.9-1
                        c3.7-1,8.4-1.4,12.5,3.3l0,0c0,0,0.2,0.3,0.4,0.4c0,0,0,0,0.1,0.1c1.2-1.3,2.8-2.4,4.5-3c2.2-0.8,3.2-1.1,4.3-1.3
                        c2.3-0.5,3.5-0.6,3.6-0.6l1.2-0.1l-8.5,10.2L22.6,15c-0.9,0.4-2.5,1.6-2.4,4.1l0,0c0.1,3,4.1,6.3,9.2,6.3h0.1h4l-3.9,1
                        c-3.9,1-8.5,1.4-12.5-3.8c0,0,0,0,0-0.1c-1.2,1.3-2.8,2.4-4.5,3c-2.2,0.8-3.2,1.1-4.3,1.3c-2.3,0.5-3.5,0.6-3.6,0.6L3.4,27.6z
                        M11.1,19.9l-5.4,6.4c0.6-0.1,1.3-0.2,2.2-0.4c1.1-0.2,2-0.4,4.2-1.3c1.7-0.7,3.3-1.7,4.4-3.1c0,0,0.1-0.1,0.2-0.2l0.4-0.6
                        l0.4,0.6c0.1,0.2,0.2,0.4,0.4,0.5c2.6,3.4,5.5,4.1,8.2,4c-4.1-1.1-6.8-4.1-7-6.9l0,0c-0.2-4.2,3.7-5.3,3.7-5.3l0.6-0.2l0.2,1.7
                        L29,8.9c-0.6,0.1-1.3,0.2-2.2,0.4c-1.1,0.2-2,0.4-4.2,1.3c-1.8,0.7-3.4,1.8-4.5,3.2l-0.4,0.5l-0.4-0.6c-0.1-0.2-0.2-0.4-0.4-0.5
                        c-0.1-0.1-0.3-0.4-0.3-0.4c-2.2-2.6-4.8-3.7-8.1-3.5c4.2,1.1,7.1,4.1,7.2,6.8c0.2,4.2-3.7,5.3-3.7,5.3l-0.6,0.2L11.1,19.9z"/>
                </g>
            </g>
            <path
                id="Scene"
                class="st2"
                d="M44.7,16.4c0-2.6-1.8-4.7-4.2-5.3c-0.3-5.3-4.7-9.5-10.1-9.5c-4.2,0-7.9,2.6-9.4,6.5
	c-2.2,0.4-4.2,1.5-5.7,3l-0.2,0c-0.8-0.1-1.6-0.2-2.3-0.2c-6.9,0-12.5,5.6-12.5,12.5c0.1,4.4,2.5,8.5,6.3,10.7l-5.4,9.1h21.9
	l-4.9-8.4c1.9-1.1,4.1-3.2,5.1-4.7l0,0c0.4,0,0.9,0,1.4-0.1v13.8h9.2L34,31.7c0.9,0.3,1.8,0.5,2.7,0.5c4.4,0,8-3.6,8-8
	c0-1.5-0.5-3-1.3-4.3C44.2,18.9,44.7,17.7,44.7,16.4z M3.9,41.7l8.3-14l8.3,14H3.9z M17.4,33.6l-5.2-8.8l-4.8,8.1
	c-3.5-1.9-5.6-5.5-5.6-9.5c0-6,4.9-11,11-11c0.4,0,0.8,0,1.3,0.1C12.8,14.3,12,16.6,12,19c0,5.6,4.2,10.2,9.5,11
	C20.5,31.3,18.9,32.7,17.4,33.6z M41.8,20.3c0.8,1.1,1.3,2.5,1.3,3.9c0,3.6-2.9,6.5-6.5,6.5c-1.1,0-2.1-0.3-3.1-0.8l-1.1-0.6v13
	h-6.2V28.1l-0.9,0.2c-0.8,0.2-1.5,0.3-2.2,0.3c-5.3,0-9.6-4.3-9.6-9.6c0-4.8,3.5-8.8,8.2-9.5l0.5-0.1L22.3,9
	c1.2-3.5,4.4-5.9,8.1-5.9c4.7,0,8.6,3.8,8.6,8.5v0.8l0.7,0.1c2,0.2,3.5,1.9,3.5,3.9c0,1.1-0.5,2.1-1.3,2.9l-0.5,0.5L41.8,20.3z"/>
        </svg>
    </div>
</template>
<script>
    export default {
        name: "Icon"
    };
</script>
<style lang="scss">
.IconSvg {
    display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/svgIcon.vue